import { __decorate, __param, __awaiter } from 'tslib';
import { Inject, Optional, Injectable, Input, Component, ComponentFactoryResolver, EventEmitter, Output, ChangeDetectorRef, ViewContainerRef, Directive, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import Amplify, { Logger, Hub, I18n } from '@aws-amplify/core';
import { has } from 'lodash';
import { isUndefined } from 'util';
import * as AmplifyUI from '@aws-amplify/ui';

// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

function AuthenticatorComponentCore_amplify_auth_sign_in_core_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-sign-in-core", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r0.authState)("usernameAttributes", ctx_r0._usernameAttributes)("hide", ctx_r0.hide);
} }
function AuthenticatorComponentCore_amplify_auth_sign_up_core_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-sign-up-core", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r1.authState)("signUpConfig", ctx_r1._signUpConfig)("usernameAttributes", ctx_r1._usernameAttributes)("hide", ctx_r1.hide);
} }
function AuthenticatorComponentCore_amplify_auth_confirm_sign_up_core_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-confirm-sign-up-core", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r2.authState)("usernameAttributes", ctx_r2._usernameAttributes)("hide", ctx_r2.hide);
} }
function AuthenticatorComponentCore_amplify_auth_confirm_sign_in_core_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-confirm-sign-in-core", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r3.authState)("hide", ctx_r3.hide);
} }
function AuthenticatorComponentCore_amplify_auth_forgot_password_core_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-forgot-password-core", 5);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r4.authState)("usernameAttributes", ctx_r4._usernameAttributes)("hide", ctx_r4.hide);
} }
function AuthenticatorComponentCore_amplify_auth_greetings_core_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-greetings-core", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r5.authState)("usernameAttributes", ctx_r5._usernameAttributes);
} }
function AuthenticatorComponentCore_amplify_auth_require_new_password_core_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-require-new-password-core", 7);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r6.authState)("hide", ctx_r6.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_sign_in_ionic_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-sign-in-ionic", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r0.authState)("usernameAttributes", ctx_r0._usernameAttributes)("hide", ctx_r0.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_sign_up_ionic_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-sign-up-ionic", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r1.authState)("signUpConfig", ctx_r1._signUpConfig)("usernameAttributes", ctx_r1._usernameAttributes)("hide", ctx_r1.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_confirm_sign_up_ionic_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-confirm-sign-up-ionic", 5);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r2.authState)("usernameAttributes", ctx_r2._usernameAttributes)("hide", ctx_r2.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_confirm_sign_in_ionic_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-confirm-sign-in-ionic", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r3.authState)("hide", ctx_r3.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_forgot_password_ionic_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-forgot-password-ionic", 5);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r4.authState)("usernameAttributes", ctx_r4._usernameAttributes)("hide", ctx_r4.hide);
} }
function AuthenticatorIonicComponent_amplify_auth_greetings_ionic_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-greetings-ionic", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r5.authState)("usernameAttributes", ctx_r5._usernameAttributes);
} }
function AuthenticatorIonicComponent_amplify_auth_require_new_password_ionic_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "amplify-auth-require-new-password-ionic", 7);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("authState", ctx_r6.authState)("hide", ctx_r6.hide);
} }
function AuthenticatorComponent_ng_template_1_Template(rf, ctx) { }
function ConfirmSignInComponentCore_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "label", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 15, 16);
    ɵngcc0.ɵɵlistener("change", function ConfirmSignInComponentCore_div_0_div_5_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r3 = ɵngcc0.ɵɵreference(4); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.setCode(_r3.value); })("keyup", function ConfirmSignInComponentCore_div_0_div_5_Template_input_keyup_3_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r3 = ɵngcc0.ɵɵreference(4); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.setCode(_r3.value); })("keyup.enter", function ConfirmSignInComponentCore_div_0_div_5_Template_input_keyup_enter_3_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onConfirm(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.amplifyService.i18n().get("Confirmation Code *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r1.amplifyService.i18n().get("Enter your Code"));
} }
function ConfirmSignInComponentCore_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelementStart(2, "span", 19);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 21);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentCore_div_0_div_14_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get(ctx_r2.errorMessage));
} }
function ConfirmSignInComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, ConfirmSignInComponentCore_div_0_div_5_Template, 5, 2, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵelementStart(9, "a", 9);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentCore_div_0_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onSignIn(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "button", 11);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentCore_div_0_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onConfirm(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, ConfirmSignInComponentCore_div_0_div_14_Template, 8, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Confirm Sign in"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("SignIn"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Back to Sign in"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirm"), "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ConfirmSignInComponentIonic_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "span", 13);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 14);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 15);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentIonic_div_0_div_14_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get(ctx_r2.errorMessage));
} }
function ConfirmSignInComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ion-list");
    ɵngcc0.ɵɵelementStart(5, "ion-item", 4);
    ɵngcc0.ɵɵelementStart(6, "ion-label", 5);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ion-input", 6, 7);
    ɵngcc0.ɵɵlistener("keyup", function ConfirmSignInComponentIonic_div_0_Template_ion_input_keyup_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r1 = ɵngcc0.ɵɵreference(9); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setCode(_r1.value); })("keyup.enter", function ConfirmSignInComponentIonic_div_0_Template_ion_input_keyup_enter_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onConfirm(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 8);
    ɵngcc0.ɵɵelementStart(11, "div");
    ɵngcc0.ɵɵelementStart(12, "ion-button", 9);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignInComponentIonic_div_0_Template_ion_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onConfirm(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, ConfirmSignInComponentIonic_div_0_div_14_Template, 8, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirm your sign in code"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Code *"), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Confirm Code"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ConfirmSignInComponent_ng_template_1_Template(rf, ctx) { }
function ConfirmSignUpComponentCore_div_0_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "span", 23);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 25);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentCore_div_0_div_27_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.amplifyService.i18n().get(ctx_r3.errorMessage));
} }
function ConfirmSignUpComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "label", 6);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "input", 7, 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 5);
    ɵngcc0.ɵɵelementStart(11, "label", 9);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "input", 10, 11);
    ɵngcc0.ɵɵlistener("change", function ConfirmSignUpComponentCore_div_0_Template_input_change_13_listener() { ɵngcc0.ɵɵrestoreView(_r7); const _r2 = ɵngcc0.ɵɵreference(14); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.setCode(_r2.value); })("keyup", function ConfirmSignUpComponentCore_div_0_Template_input_keyup_13_listener() { ɵngcc0.ɵɵrestoreView(_r7); const _r2 = ɵngcc0.ɵɵreference(14); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.setCode(_r2.value); })("keyup.enter", function ConfirmSignUpComponentCore_div_0_Template_input_keyup_enter_13_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onConfirm(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span", 12);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementStart(17, "a", 13);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentCore_div_0_Template_a_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onResend(); });
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 14);
    ɵngcc0.ɵɵelementStart(20, "div", 15);
    ɵngcc0.ɵɵelementStart(21, "div", 16);
    ɵngcc0.ɵɵelementStart(22, "a", 17);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentCore_div_0_Template_a_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onSignIn(); });
    ɵngcc0.ɵɵtext(23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 18);
    ɵngcc0.ɵɵelementStart(25, "button", 19);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentCore_div_0_Template_button_click_25_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onConfirm(); });
    ɵngcc0.ɵɵtext(26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(27, ConfirmSignUpComponentCore_div_0_div_27_Template, 8, 1, "div", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirm Sign up"), "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get(ctx_r0.getUsernameLabel()), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get(ctx_r0.getUsernameLabel()));
    ɵngcc0.ɵɵproperty("value", ctx_r0.username);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirmation Code *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get("Enter your Code"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.amplifyService.i18n().get("Lost your code?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Resend Code"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Back to Sign in"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Confirm"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ConfirmSignUpComponentIonic_div_0_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "span", 18);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 19);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 20);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentIonic_div_0_div_27_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get(ctx_r2.errorMessage));
} }
function ConfirmSignUpComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ion-list");
    ɵngcc0.ɵɵelementStart(5, "ion-item", 4);
    ɵngcc0.ɵɵelementStart(6, "ion-label", 5);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ion-input", 6);
    ɵngcc0.ɵɵlistener("keyup", function ConfirmSignUpComponentIonic_div_0_Template_ion_input_keyup_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setUsername($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "ion-item", 4);
    ɵngcc0.ɵɵelementStart(10, "ion-label", 5);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "ion-input", 7, 8);
    ɵngcc0.ɵɵlistener("keyup", function ConfirmSignUpComponentIonic_div_0_Template_ion_input_keyup_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r1 = ɵngcc0.ɵɵreference(13); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setCode(_r1.value); })("keyup.enter", function ConfirmSignUpComponentIonic_div_0_Template_ion_input_keyup_enter_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onConfirm(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 9);
    ɵngcc0.ɵɵelementStart(15, "div");
    ɵngcc0.ɵɵelementStart(16, "ion-button", 10);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentIonic_div_0_Template_ion_button_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onConfirm(); });
    ɵngcc0.ɵɵtext(17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 11);
    ɵngcc0.ɵɵelementStart(19, "div", 12);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵelementStart(21, "a", 13);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentIonic_div_0_Template_a_click_21_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onSignIn(); });
    ɵngcc0.ɵɵtext(22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 12);
    ɵngcc0.ɵɵtext(24);
    ɵngcc0.ɵɵelementStart(25, "a", 14);
    ɵngcc0.ɵɵlistener("click", function ConfirmSignUpComponentIonic_div_0_Template_a_click_25_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onResend(); });
    ɵngcc0.ɵɵtext(26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(27, ConfirmSignUpComponentIonic_div_0_div_27_Template, 8, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirm your sign up code"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get(ctx_r0.getUsernameLabel()), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r0.username);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Code *"), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Confirm Code"), "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Have an account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Sign In"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Lost your code?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Resend"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ConfirmSignUpComponent_ng_template_1_Template(rf, ctx) { }
function SignInComponentCore_div_0_span_11_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "a", 17);
    ɵngcc0.ɵɵlistener("click", function SignInComponentCore_div_0_span_11_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onForgotPassword(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Forgot Password?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get("Reset password"));
} }
function SignInComponentCore_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "a", 20);
    ɵngcc0.ɵɵlistener("click", function SignInComponentCore_div_0_div_16_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onSignUp(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.amplifyService.i18n().get("No account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.amplifyService.i18n().get("Create account"), " ");
} }
function SignInComponentCore_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "span", 23);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 25);
    ɵngcc0.ɵɵlistener("click", function SignInComponentCore_div_0_div_17_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.amplifyService.i18n().get(ctx_r4.errorMessage), "");
} }
function SignInComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "amplify-auth-username-field-core", 5);
    ɵngcc0.ɵɵlistener("usernameFieldChanged", function SignInComponentCore_div_0_Template_amplify_auth_username_field_core_usernameFieldChanged_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onUsernameFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "label", 7);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "input", 8, 9);
    ɵngcc0.ɵɵlistener("keyup", function SignInComponentCore_div_0_Template_input_keyup_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r1 = ɵngcc0.ɵɵreference(10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.setPassword(_r1.value); })("keyup.enter", function SignInComponentCore_div_0_Template_input_keyup_enter_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onSignIn(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, SignInComponentCore_div_0_span_11_Template, 4, 2, "span", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 11);
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵelementStart(14, "button", 13);
    ɵngcc0.ɵɵlistener("click", function SignInComponentCore_div_0_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onSignIn(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, SignInComponentCore_div_0_div_16_Template, 5, 2, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, SignInComponentCore_div_0_div_17_Template, 8, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Sign in to your account"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("usernameAttributes", ctx_r0._usernameAttributes);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Password *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get("Enter your password"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("ForgotPassword"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Sign In"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("SignUp"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function SignInComponentIonic_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "a", 15);
    ɵngcc0.ɵɵlistener("click", function SignInComponentIonic_div_0_div_16_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onSignUp(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("No account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Create account"), " ");
} }
function SignInComponentIonic_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "a", 16);
    ɵngcc0.ɵɵlistener("click", function SignInComponentIonic_div_0_div_17_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onForgotPassword(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.amplifyService.i18n().get("Reset Password"), " ");
} }
function SignInComponentIonic_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelementStart(2, "span", 19);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 21);
    ɵngcc0.ɵɵlistener("click", function SignInComponentIonic_div_0_div_18_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.amplifyService.i18n().get(ctx_r4.errorMessage));
} }
function SignInComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ion-list", 4);
    ɵngcc0.ɵɵelementStart(5, "amplify-auth-username-field-ionic", 5);
    ɵngcc0.ɵɵlistener("usernameFieldChanged", function SignInComponentIonic_div_0_Template_amplify_auth_username_field_ionic_usernameFieldChanged_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onUsernameFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ion-item", 4);
    ɵngcc0.ɵɵelementStart(7, "ion-label", 6);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "ion-input", 7, 8);
    ɵngcc0.ɵɵlistener("keyup", function SignInComponentIonic_div_0_Template_ion_input_keyup_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r1 = ɵngcc0.ɵɵreference(10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.setPassword(_r1.value); })("keyup.enter", function SignInComponentIonic_div_0_Template_ion_input_keyup_enter_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onSignIn(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵelementStart(12, "div", 10);
    ɵngcc0.ɵɵelementStart(13, "ion-button", 11);
    ɵngcc0.ɵɵlistener("click", function SignInComponentIonic_div_0_Template_ion_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onSignIn(); });
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 10);
    ɵngcc0.ɵɵtemplate(16, SignInComponentIonic_div_0_div_16_Template, 4, 2, "div", 12);
    ɵngcc0.ɵɵtemplate(17, SignInComponentIonic_div_0_div_17_Template, 3, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, SignInComponentIonic_div_0_div_18_Template, 8, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Sign in to your account"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("usernameAttributes", ctx_r0._usernameAttributes);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Password *"), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Sign In"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("SignUp"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("ForgotPassword"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function SignInComponent_ng_template_1_Template(rf, ctx) { }
function SignUpComponentCore_div_0_div_5_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function SignUpComponentCore_div_0_div_5_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.passwordPolicy, " ");
} }
const _c0 = function (a0) { return { "amplify-input-invalid ": a0 }; };
function SignUpComponentCore_div_0_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, SignUpComponentCore_div_0_div_5_div_1_span_3_Template, 2, 0, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 14, 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function SignUpComponentCore_div_0_div_5_div_1_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const field_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return (ctx_r10.user[field_r4.key] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, SignUpComponentCore_div_0_div_5_div_1_div_6_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.amplifyService.i18n().get(field_r4.label), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("type", field_r4.type);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c0, field_r4.invalid))("placeholder", ctx_r5.amplifyService.i18n().get(field_r4.label))("ngModel", ctx_r5.user[field_r4.key]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key === "password");
} }
function SignUpComponentCore_div_0_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "amplify-auth-phone-field-core", 18);
    ɵngcc0.ɵɵlistener("phoneFieldChanged", function SignUpComponentCore_div_0_div_5_div_2_Template_amplify_auth_phone_field_core_phoneFieldChanged_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.onPhoneFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", field_r4.label)("required", field_r4.required)("placeholder", field_r4.placeholder)("defaultCountryCode", ctx_r6.country_code);
} }
function SignUpComponentCore_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, SignUpComponentCore_div_0_div_5_div_1_Template, 7, 9, "div", 12);
    ɵngcc0.ɵɵtemplate(2, SignUpComponentCore_div_0_div_5_div_2_Template, 2, 4, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key !== "phone_number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key === "phone_number");
} }
function SignUpComponentCore_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "a", 21);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentCore_div_0_div_7_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onSignIn(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Have an account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Sign in"), " ");
} }
function SignUpComponentCore_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵelementStart(2, "span", 24);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 25);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 26);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentCore_div_0_div_11_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.amplifyService.i18n().get(ctx_r3.errorMessage));
} }
function SignUpComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, SignUpComponentCore_div_0_div_5_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtemplate(7, SignUpComponentCore_div_0_div_7_Template, 5, 2, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵelementStart(9, "button", 9);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentCore_div_0_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onSignUp(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, SignUpComponentCore_div_0_div_11_Template, 8, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get(ctx_r0.header));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.signUpFields);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("SignIn"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Create Account"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function SignUpComponentIonic_div_0_ion_item_5_ion_label_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function SignUpComponentIonic_div_0_ion_item_5_ion_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ion-label", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, SignUpComponentIonic_div_0_ion_item_5_ion_label_1_span_2_Template, 2, 0, "span", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.amplifyService.i18n().get(field_r4.label), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.required);
} }
function SignUpComponentIonic_div_0_ion_item_5_ion_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-input", 18, 19);
    ɵngcc0.ɵɵlistener("keyup", function SignUpComponentIonic_div_0_ion_item_5_ion_input_2_Template_ion_input_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.setProp($event.target); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("type", field_r4.type);
    ɵngcc0.ɵɵpropertyInterpolate("name", field_r4.key);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, field_r4.invalid))("placeholder", ctx_r6.amplifyService.i18n().get(field_r4.label));
} }
function SignUpComponentIonic_div_0_ion_item_5_ion_content_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-content", 20);
    ɵngcc0.ɵɵelementStart(1, "amplify-auth-phone-field-ionic", 21);
    ɵngcc0.ɵɵlistener("phoneFieldChanged", function SignUpComponentIonic_div_0_ion_item_5_ion_content_3_Template_amplify_auth_phone_field_ionic_phoneFieldChanged_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.onPhoneFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("label", field_r4.label)("required", field_r4.required)("placeholder", field_r4.placeholder)("defaultCountryCode", ctx_r7.country_code);
} }
function SignUpComponentIonic_div_0_ion_item_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ion-item", 4);
    ɵngcc0.ɵɵtemplate(1, SignUpComponentIonic_div_0_ion_item_5_ion_label_1_Template, 3, 2, "ion-label", 13);
    ɵngcc0.ɵɵtemplate(2, SignUpComponentIonic_div_0_ion_item_5_ion_input_2_Template, 2, 6, "ion-input", 14);
    ɵngcc0.ɵɵtemplate(3, SignUpComponentIonic_div_0_ion_item_5_ion_content_3_Template, 2, 4, "ion-content", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key !== "phone_number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key !== "phone_number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r4.key === "phone_number");
} }
function SignUpComponentIonic_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "a", 22);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentIonic_div_0_div_15_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onConfirmSignUp(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Have a code?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Confirm"), " ");
} }
function SignUpComponentIonic_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵelementStart(2, "span", 25);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 26);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 27);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentIonic_div_0_div_16_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.amplifyService.i18n().get(ctx_r3.errorMessage));
} }
function SignUpComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ion-list", 4);
    ɵngcc0.ɵɵtemplate(5, SignUpComponentIonic_div_0_ion_item_5_Template, 4, 3, "ion-item", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "ion-button", 8);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentIonic_div_0_Template_ion_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onSignUp(); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 7);
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementStart(13, "a", 10);
    ɵngcc0.ɵɵlistener("click", function SignUpComponentIonic_div_0_Template_a_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onSignIn(); });
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(15, SignUpComponentIonic_div_0_div_15_Template, 4, 2, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, SignUpComponentIonic_div_0_div_16_Template, 8, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get(ctx_r0.header), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.signUpFields);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Create Account"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Have an account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Sign In"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.shouldHide("SignUp"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function SignUpComponent_ng_template_1_Template(rf, ctx) { }
function RequireNewPasswordComponentCore_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 19);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentCore_div_0_div_17_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.amplifyService.i18n().get(ctx_r2.errorMessage));
} }
function RequireNewPasswordComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "label", 6);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 7, 8);
    ɵngcc0.ɵɵlistener("keyup", function RequireNewPasswordComponentCore_div_0_Template_input_keyup_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r1 = ɵngcc0.ɵɵreference(9); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setPassword(_r1.value); })("keyup.enter", function RequireNewPasswordComponentCore_div_0_Template_input_keyup_enter_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onSubmit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "a", 11);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentCore_div_0_Template_a_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSignIn(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 12);
    ɵngcc0.ɵɵelementStart(15, "button", 13);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentCore_div_0_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onSubmit(); });
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, RequireNewPasswordComponentCore_div_0_div_17_Template, 8, 1, "div", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("You are required to update your password"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Password *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get("Password"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Back to Sign In"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Submit"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function RequireNewPasswordComponentIonic_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "span", 15);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 17);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentIonic_div_0_div_17_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.errorMessage);
} }
function RequireNewPasswordComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ion-list");
    ɵngcc0.ɵɵelementStart(5, "ion-item", 4);
    ɵngcc0.ɵɵelementStart(6, "ion-label", 5);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ion-input", 6, 7);
    ɵngcc0.ɵɵlistener("keyup", function RequireNewPasswordComponentIonic_div_0_Template_ion_input_keyup_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r1 = ɵngcc0.ɵɵreference(9); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setPassword(_r1.value); })("keyup.enter", function RequireNewPasswordComponentIonic_div_0_Template_ion_input_keyup_enter_8_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onSubmit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 8);
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵelementStart(12, "ion-button", 10);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentIonic_div_0_Template_ion_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSignIn(); });
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 9);
    ɵngcc0.ɵɵelementStart(15, "ion-button", 11);
    ɵngcc0.ɵɵlistener("click", function RequireNewPasswordComponentIonic_div_0_Template_ion_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onSubmit(); });
    ɵngcc0.ɵɵtext(16, "Submit");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, RequireNewPasswordComponentIonic_div_0_div_17_Template, 8, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Reset your password"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Password"), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Back to Sign In"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function RequireNewPasswordComponent_ng_template_1_Template(rf, ctx) { }
function GreetingComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "a", 4);
    ɵngcc0.ɵɵlistener("click", function GreetingComponentCore_div_0_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onSignOut(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.greeting);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Sign Out"));
} }
function GreetingComponentIonic_div_0_ion_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-button", 5);
    ɵngcc0.ɵɵlistener("click", function GreetingComponentIonic_div_0_ion_button_4_Template_ion_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.onSignOut(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.amplifyService.i18n().get("Sign Out"));
} }
function GreetingComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, GreetingComponentIonic_div_0_ion_button_4_Template, 2, 1, "ion-button", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.greeting);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.signedIn);
} }
function GreetingComponent_ng_template_1_Template(rf, ctx) { }
function ForgotPasswordComponentCore_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.amplifyService.i18n().get("You will receive a verification code"), " ");
} }
function ForgotPasswordComponentCore_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Enter the code you received and set a new password"), " ");
} }
function ForgotPasswordComponentCore_div_0_amplify_auth_username_field_core_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "amplify-auth-username-field-core", 18);
    ɵngcc0.ɵɵlistener("usernameFieldChanged", function ForgotPasswordComponentCore_div_0_amplify_auth_username_field_core_7_Template_amplify_auth_username_field_core_usernameFieldChanged_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onUsernameFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("usernameAttributes", ctx_r3._usernameAttributes);
} }
function ForgotPasswordComponentCore_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "label", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 21, 22);
    ɵngcc0.ɵɵlistener("keyup", function ForgotPasswordComponentCore_div_0_div_8_Template_input_keyup_3_listener() { ɵngcc0.ɵɵrestoreView(_r15); const _r13 = ɵngcc0.ɵɵreference(4); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.setCode(_r13.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.amplifyService.i18n().get("Confirmation Code *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r4.amplifyService.i18n().get("Enter code"));
} }
function ForgotPasswordComponentCore_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "label", 23);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 24, 25);
    ɵngcc0.ɵɵlistener("keyup", function ForgotPasswordComponentCore_div_0_div_9_Template_input_keyup_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const _r16 = ɵngcc0.ɵɵreference(4); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.setPassword(_r16.value); })("keyup.enter", function ForgotPasswordComponentCore_div_0_div_9_Template_input_keyup_enter_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.onSubmit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.amplifyService.i18n().get("New Password *"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r5.amplifyService.i18n().get("Password"));
} }
function ForgotPasswordComponentCore_div_0_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 26);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentCore_div_0_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onSend(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.amplifyService.i18n().get("Submit"), "");
} }
function ForgotPasswordComponentCore_div_0_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 27);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentCore_div_0_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.onSubmit(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.amplifyService.i18n().get("Verify"), "");
} }
function ForgotPasswordComponentCore_div_0_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 28);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentCore_div_0_a_16_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onSend(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.amplifyService.i18n().get("Resend Code"), " ");
} }
function ForgotPasswordComponentCore_div_0_a_17_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 29);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentCore_div_0_a_17_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onSignIn(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.amplifyService.i18n().get("Back to Sign in"), " ");
} }
function ForgotPasswordComponentCore_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "div", 31);
    ɵngcc0.ɵɵelementStart(2, "span", 32);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 33);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 34);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentCore_div_0_div_18_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.amplifyService.i18n().get(ctx_r10.errorMessage));
} }
function ForgotPasswordComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, ForgotPasswordComponentCore_div_0_div_5_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(6, ForgotPasswordComponentCore_div_0_div_6_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(7, ForgotPasswordComponentCore_div_0_amplify_auth_username_field_core_7_Template, 1, 1, "amplify-auth-username-field-core", 6);
    ɵngcc0.ɵɵtemplate(8, ForgotPasswordComponentCore_div_0_div_8_Template, 5, 2, "div", 7);
    ɵngcc0.ɵɵtemplate(9, ForgotPasswordComponentCore_div_0_div_9_Template, 5, 2, "div", 7);
    ɵngcc0.ɵɵelementStart(10, "div", 8);
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵtemplate(12, ForgotPasswordComponentCore_div_0_button_12_Template, 2, 1, "button", 10);
    ɵngcc0.ɵɵtemplate(13, ForgotPasswordComponentCore_div_0_button_13_Template, 2, 1, "button", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 12);
    ɵngcc0.ɵɵelementStart(15, "div", 13);
    ɵngcc0.ɵɵtemplate(16, ForgotPasswordComponentCore_div_0_a_16_Template, 2, 1, "a", 14);
    ɵngcc0.ɵɵtemplate(17, ForgotPasswordComponentCore_div_0_a_17_Template, 2, 1, "a", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, ForgotPasswordComponentCore_div_0_div_18_Template, 8, 1, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Reset your password"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ForgotPasswordComponentIonic_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.amplifyService.i18n().get("You will receive a verification code to reset your password"), " ");
} }
function ForgotPasswordComponentIonic_div_0_ion_item_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-item", 16);
    ɵngcc0.ɵɵelementStart(1, "ion-label", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ion-input", 18, 19);
    ɵngcc0.ɵɵlistener("keyup", function ForgotPasswordComponentIonic_div_0_ion_item_7_Template_ion_input_keyup_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const _r7 = ɵngcc0.ɵɵreference(4); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.setCode(_r7.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get("Code *"), " ");
} }
function ForgotPasswordComponentIonic_div_0_ion_item_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-item", 16);
    ɵngcc0.ɵɵelementStart(1, "ion-label", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ion-input", 20, 21);
    ɵngcc0.ɵɵlistener("keyup", function ForgotPasswordComponentIonic_div_0_ion_item_8_Template_ion_input_keyup_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r10 = ɵngcc0.ɵɵreference(4); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.setPassword(_r10.value); })("keyup.enter", function ForgotPasswordComponentIonic_div_0_ion_item_8_Template_ion_input_keyup_enter_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onSubmit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.amplifyService.i18n().get("Password *"), " ");
} }
function ForgotPasswordComponentIonic_div_0_ion_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-button", 22);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentIonic_div_0_ion_button_11_Template_ion_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onSend(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.amplifyService.i18n().get("Submit"), "");
} }
function ForgotPasswordComponentIonic_div_0_ion_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-button", 23);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentIonic_div_0_ion_button_12_Template_ion_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onSubmit(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.amplifyService.i18n().get("Verify"));
} }
function ForgotPasswordComponentIonic_div_0_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "span", 26);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 27);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 28);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentIonic_div_0_div_22_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.amplifyService.i18n().get(ctx_r6.errorMessage));
} }
function ForgotPasswordComponentIonic_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ForgotPasswordComponentIonic_div_0_div_4_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "ion-list");
    ɵngcc0.ɵɵelementStart(6, "amplify-auth-username-field-ionic", 5);
    ɵngcc0.ɵɵlistener("usernameFieldChanged", function ForgotPasswordComponentIonic_div_0_Template_amplify_auth_username_field_ionic_usernameFieldChanged_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onUsernameFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, ForgotPasswordComponentIonic_div_0_ion_item_7_Template, 5, 1, "ion-item", 6);
    ɵngcc0.ɵɵtemplate(8, ForgotPasswordComponentIonic_div_0_ion_item_8_Template, 5, 1, "ion-item", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 7);
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵtemplate(11, ForgotPasswordComponentIonic_div_0_ion_button_11_Template, 2, 1, "ion-button", 8);
    ɵngcc0.ɵɵtemplate(12, ForgotPasswordComponentIonic_div_0_ion_button_12_Template, 2, 1, "ion-button", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 10);
    ɵngcc0.ɵɵelementStart(14, "div", 11);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵelementStart(16, "a", 12);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentIonic_div_0_Template_a_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onSignIn(); });
    ɵngcc0.ɵɵtext(17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 11);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵelementStart(20, "a", 13);
    ɵngcc0.ɵɵlistener("click", function ForgotPasswordComponentIonic_div_0_Template_a_click_20_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onSend(); });
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(22, ForgotPasswordComponentIonic_div_0_div_22_Template, 8, 1, "div", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Reset your password"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("usernameAttributes", ctx_r0._usernameAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.code_sent);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Have an account?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Sign In"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Lost your code?"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Resend"), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.errorMessage);
} }
function ForgotPasswordComponent_ng_template_1_Template(rf, ctx) { }
function UsernameFieldComponentCore_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 3, 4);
    ɵngcc0.ɵɵlistener("keyup", function UsernameFieldComponentCore_div_1_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setEmail($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.amplifyService.i18n().get("Email"), " *");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get(ctx_r0.getPlaceholder()));
} }
function UsernameFieldComponentCore_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "amplify-auth-phone-field-core", 5);
    ɵngcc0.ɵɵlistener("phoneFieldChanged", function UsernameFieldComponentCore_div_2_Template_amplify_auth_phone_field_core_phoneFieldChanged_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onPhoneFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function UsernameFieldComponentCore_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 7, 8);
    ɵngcc0.ɵɵlistener("keyup", function UsernameFieldComponentCore_div_3_Template_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setUsername($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.amplifyService.i18n().get(ctx_r2.getUsernameLabel()), " *");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r2.username);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.amplifyService.i18n().get(ctx_r2.getPlaceholder()));
} }
function PhoneFieldComponentCore_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function PhoneFieldComponentCore_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r4 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("value", country_r4.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", country_r4.label, " ");
} }
function S3AlbumComponentCore_amplify_s3_image_core_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "amplify-s3-image-core", 3);
    ɵngcc0.ɵɵlistener("selected", function S3AlbumComponentCore_amplify_s3_image_core_2_Template_amplify_s3_image_core_selected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onImageSelected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("path", item_r1.path);
    ɵngcc0.ɵɵproperty("options", ctx_r0._options);
} }
function S3AlbumComponentIonic_amplify_s3_image_core_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "amplify-s3-image-core", 3);
    ɵngcc0.ɵɵlistener("selected", function S3AlbumComponentIonic_amplify_s3_image_core_2_Template_amplify_s3_image_core_selected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onImageSelected($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("path", item_r1.path);
} }
function S3AlbumComponent_ng_template_1_Template(rf, ctx) { }
function S3ImageComponent_ng_template_1_Template(rf, ctx) { }
function PhotoPickerComponentCore_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} }
function PhotoPickerComponentCore_img_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 11);
    ɵngcc0.ɵɵlistener("error", function PhotoPickerComponentCore_img_6_Template_img_error_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onPhotoError(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.photoUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function PhotoPickerComponentCore_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerComponentCore_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.uploadFile(); });
    ɵngcc0.ɵɵtext(1, " Upload Photo ");
    ɵngcc0.ɵɵelementEnd();
} }
function PhotoPickerComponentCore_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "span", 15);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 17);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerComponentCore_div_10_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.errorMessage);
} }
function PhotoPickerIonicComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} }
function PhotoPickerIonicComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 11);
    ɵngcc0.ɵɵlistener("error", function PhotoPickerIonicComponent_img_6_Template_img_error_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onPhotoError(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.photoUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function PhotoPickerIonicComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerIonicComponent_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.uploadFile(); });
    ɵngcc0.ɵɵtext(1, " Upload Photo ");
    ɵngcc0.ɵɵelementEnd();
} }
function PhotoPickerIonicComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "span", 15);
    ɵngcc0.ɵɵtext(3, "\u26A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "a", 17);
    ɵngcc0.ɵɵlistener("click", function PhotoPickerIonicComponent_div_10_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onAlertClose(); });
    ɵngcc0.ɵɵtext(7, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.errorMessage);
} }
function PhotoPickerComponent_ng_template_1_Template(rf, ctx) { }
function ChatbotComponentCore_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 12);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(message_r5.me);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(message_r5.meSentTime);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(message_r5.bot);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(message_r5.botSentTime);
} }
function ChatbotComponentCore_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 15, 16);
    ɵngcc0.ɵɵlistener("keyup.enter", function ChatbotComponentCore_input_7_Template_input_keyup_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const _r6 = ɵngcc0.ɵɵreference(1); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onSubmit(_r6.value); })("change", function ChatbotComponentCore_input_7_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onInputChange($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r1.currentVoiceState);
    ɵngcc0.ɵɵproperty("value", ctx_r1.inputText)("disabled", ctx_r1.inputDisabled);
} }
function ChatbotComponentCore_input_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 17, 16);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.currentVoiceState);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r2.textEnabled);
} }
function ChatbotComponentCore_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function ChatbotComponentCore_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.micButtonHandler(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.micButtonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.micText, " ");
} }
function ChatbotComponentCore_button_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "button", 19);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.inputDisabled);
} }
function ChatbotComponentIonic_ion_row_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ion-row");
    ɵngcc0.ɵɵelementStart(1, "ion-col");
    ɵngcc0.ɵɵelementStart(2, "ion-row");
    ɵngcc0.ɵɵelementStart(3, "ion-col", 9);
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵelementStart(5, "ion-chip", 10);
    ɵngcc0.ɵɵelementStart(6, "ion-label");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ion-col", 11);
    ɵngcc0.ɵɵtext(9, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.chatTitle);
} }
function ChatbotComponentIonic_ion_row_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ion-row");
    ɵngcc0.ɵɵelementStart(1, "ion-col");
    ɵngcc0.ɵɵelementStart(2, "ion-row");
    ɵngcc0.ɵɵelementStart(3, "ion-col", 9);
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵtext(5, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ion-col", 11);
    ɵngcc0.ɵɵelementStart(7, "ion-chip", 12);
    ɵngcc0.ɵɵelementStart(8, "ion-label");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "ion-row");
    ɵngcc0.ɵɵelementStart(11, "ion-col", 9);
    ɵngcc0.ɵɵelementStart(12, "ion-chip", 10);
    ɵngcc0.ɵɵelementStart(13, "ion-label");
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "ion-col", 11);
    ɵngcc0.ɵɵelementStart(16, "div");
    ɵngcc0.ɵɵtext(17, " \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate(message_r6.me);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(message_r6.bot);
} }
function ChatbotComponentIonic_ion_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-input", 13, 14);
    ɵngcc0.ɵɵlistener("keyup.enter", function ChatbotComponentIonic_ion_input_6_Template_ion_input_keyup_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const _r7 = ɵngcc0.ɵɵreference(1); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSubmit(_r7.value); })("ionChange", function ChatbotComponentIonic_ion_input_6_Template_ion_input_ionChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onInputChange($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.currentVoiceState);
    ɵngcc0.ɵɵproperty("value", ctx_r2.inputText)("disabled", ctx_r2.inputDisabled);
} }
function ChatbotComponentIonic_ion_input_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ion-input", 15, 14);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r3.currentVoiceState);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.textEnabled);
} }
function ChatbotComponentIonic_ion_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-button", 16);
    ɵngcc0.ɵɵlistener("click", function ChatbotComponentIonic_ion_button_8_Template_ion_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.micButtonHandler(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.micButtonDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.micText, " ");
} }
function ChatbotComponentIonic_ion_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-button", 17);
    ɵngcc0.ɵɵlistener("click", function ChatbotComponentIonic_ion_button_9_Template_ion_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.inputDisabled === false || ctx_r14.onSubmit(ctx_r14.inputValue.value); });
    ɵngcc0.ɵɵtext(1, " Send ");
    ɵngcc0.ɵɵelementEnd();
} }
function ChatBotComponent_ng_template_1_Template(rf, ctx) { }
const _c1 = [[["", "form-body", ""]], [["", "form-footer", ""]]];
const _c2 = ["[form-body]", "[form-footer]"];
function SumerianSceneComponentCore_sumerian_scene_loading_core_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sumerian-scene-loading-core", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("loadPercentage", ctx_r0.loadPercentage);
    ɵngcc0.ɵɵpropertyInterpolate("sceneName", ctx_r0.sceneName);
    ɵngcc0.ɵɵpropertyInterpolate("sceneError", ctx_r0.sceneError);
} }
function SumerianSceneComponentCore_div_3__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 13);
    ɵngcc0.ɵɵelementStart(1, "g", 14);
    ɵngcc0.ɵɵelement(2, "path", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SumerianSceneComponentCore_div_3__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 13);
    ɵngcc0.ɵɵelementStart(1, "g", 16);
    ɵngcc0.ɵɵelement(2, "path", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SumerianSceneComponentCore_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentCore_div_3_div_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.toggleVRPresentation(); });
    ɵngcc0.ɵɵelementStart(1, "button");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 19);
    ɵngcc0.ɵɵelementStart(3, "g", 20);
    ɵngcc0.ɵɵelementStart(4, "g", 21);
    ɵngcc0.ɵɵelement(5, "path", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r4.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r4.amplifyUI.actionButton);
} }
function SumerianSceneComponentCore_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentCore_div_3_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.toggleVRPresentation(); });
    ɵngcc0.ɵɵelementStart(1, "button");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 24);
    ɵngcc0.ɵɵelementStart(4, "g", 25);
    ɵngcc0.ɵɵelement(5, "path", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r5.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r5.amplifyUI.actionButton);
} }
function SumerianSceneComponentCore_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "button", 28);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentCore_div_3_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.maximize(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 29);
    ɵngcc0.ɵɵelement(4, "path", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r6.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r6.amplifyUI.actionButton);
} }
function SumerianSceneComponentCore_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "button", 28);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentCore_div_3_div_9_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.minimize(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 32);
    ɵngcc0.ɵɵelement(4, "path", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r7.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r7.amplifyUI.actionButton);
} }
const _c3 = function (a0, a1) { return [a0, a1]; };
function SumerianSceneComponentCore_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "span", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentCore_div_3_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.muted ? ctx_r16.setMuted(false) : ctx_r16.setMuted(true); });
    ɵngcc0.ɵɵelementStart(3, "button");
    ɵngcc0.ɵɵtemplate(4, SumerianSceneComponentCore_div_3__svg_svg_4_Template, 3, 0, "svg", 8);
    ɵngcc0.ɵɵtemplate(5, SumerianSceneComponentCore_div_3__svg_svg_5_Template, 3, 0, "svg", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, SumerianSceneComponentCore_div_3_div_6_Template, 6, 6, "div", 9);
    ɵngcc0.ɵɵtemplate(7, SumerianSceneComponentCore_div_3_div_7_Template, 6, 6, "div", 10);
    ɵngcc0.ɵɵtemplate(8, SumerianSceneComponentCore_div_3_div_8_Template, 5, 6, "div", 11);
    ɵngcc0.ɵɵtemplate(9, SumerianSceneComponentCore_div_3_div_9_Template, 5, 6, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.sceneBar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.sceneActions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(17, _c3, ctx_r1.amplifyUI.tooltip, ctx_r1.showEnableAudio ? ctx_r1.amplifyUI.autoShowTooltip : ""));
    ɵngcc0.ɵɵattribute("data-text", ctx_r1.showEnableAudio ? "The scene is muted. Click to unmute." : ctx_r1.muted ? "Unmute" : "Mute");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.actionButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.muted);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.muted);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isVRCapable && !ctx_r1.isVRPresentationActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isVRCapable && ctx_r1.isVRPresentationActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isFullscreen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isFullscreen);
} }
function SumerianSceneComponentIonic_sumerian_scene_loading_ionic_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "sumerian-scene-loading-ionic", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("loadPercentage", ctx_r0.loadPercentage);
    ɵngcc0.ɵɵpropertyInterpolate("sceneName", ctx_r0.sceneName);
} }
function SumerianSceneComponentIonic_div_3__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 13);
    ɵngcc0.ɵɵelementStart(1, "g", 14);
    ɵngcc0.ɵɵelement(2, "path", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SumerianSceneComponentIonic_div_3__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 13);
    ɵngcc0.ɵɵelementStart(1, "g", 16);
    ɵngcc0.ɵɵelement(2, "path", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function SumerianSceneComponentIonic_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentIonic_div_3_div_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.toggleVRPresentation(); });
    ɵngcc0.ɵɵelementStart(1, "button");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 19);
    ɵngcc0.ɵɵelementStart(3, "g", 20);
    ɵngcc0.ɵɵelementStart(4, "g", 21);
    ɵngcc0.ɵɵelement(5, "path", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r4.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r4.amplifyUI.actionButton);
} }
function SumerianSceneComponentIonic_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentIonic_div_3_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.toggleVRPresentation(); });
    ɵngcc0.ɵɵelementStart(1, "button");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 24);
    ɵngcc0.ɵɵelementStart(4, "g", 25);
    ɵngcc0.ɵɵelement(5, "path", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r5.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r5.amplifyUI.actionButton);
} }
function SumerianSceneComponentIonic_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "button", 28);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentIonic_div_3_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.maximize(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 29);
    ɵngcc0.ɵɵelement(4, "path", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r6.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r6.amplifyUI.actionButton);
} }
function SumerianSceneComponentIonic_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "button", 28);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentIonic_div_3_div_9_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.minimize(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelementStart(3, "g", 32);
    ɵngcc0.ɵɵelement(4, "path", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r7.amplifyUI.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r7.amplifyUI.actionButton);
} }
function SumerianSceneComponentIonic_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "span", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵlistener("click", function SumerianSceneComponentIonic_div_3_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.muted ? ctx_r16.setMuted(false) : ctx_r16.setMuted(true); });
    ɵngcc0.ɵɵelementStart(3, "button");
    ɵngcc0.ɵɵtemplate(4, SumerianSceneComponentIonic_div_3__svg_svg_4_Template, 3, 0, "svg", 8);
    ɵngcc0.ɵɵtemplate(5, SumerianSceneComponentIonic_div_3__svg_svg_5_Template, 3, 0, "svg", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, SumerianSceneComponentIonic_div_3_div_6_Template, 6, 6, "div", 9);
    ɵngcc0.ɵɵtemplate(7, SumerianSceneComponentIonic_div_3_div_7_Template, 6, 6, "div", 10);
    ɵngcc0.ɵɵtemplate(8, SumerianSceneComponentIonic_div_3_div_8_Template, 5, 6, "div", 11);
    ɵngcc0.ɵɵtemplate(9, SumerianSceneComponentIonic_div_3_div_9_Template, 5, 6, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.sceneBar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.sceneActions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(17, _c3, ctx_r1.amplifyUI.tooltip, ctx_r1.showEnableAudio ? ctx_r1.amplifyUI.autoShowTooltip : ""));
    ɵngcc0.ɵɵattribute("data-text", ctx_r1.showEnableAudio ? "The scene is muted. Click to unmute." : ctx_r1.muted ? "Unmute" : "Mute");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.amplifyUI.actionButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.muted);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.muted);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isVRCapable && !ctx_r1.isVRPresentationActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isVRCapable && ctx_r1.isVRPresentationActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isFullscreen);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isFullscreen);
} }
function SumerianSceneComponent_ng_template_0_Template(rf, ctx) { }
function SumerianSceneLoadingComponentCore_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.AmplifyUI.sceneErrorText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.sceneError);
} }
const _c4 = function (a0) { return { "width": a0 }; };
function SumerianSceneLoadingComponentCore_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelement(1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.AmplifyUI.loadingBar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.AmplifyUI.loadingBarFill);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c4, ctx_r1.loadPercentage + "%"));
} }
function PhoneFieldComponentIonic_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function PhoneFieldComponentIonic_ion_select_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ion-select-option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r4 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("value", country_r4.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", country_r4.label, " ");
} }
function UsernameFieldComponentIonic_ion_item_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-item", 1);
    ɵngcc0.ɵɵelementStart(1, "ion-label", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ion-input", 3, 4);
    ɵngcc0.ɵɵlistener("keyup", function UsernameFieldComponentIonic_ion_item_0_Template_ion_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setEmail($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Email *"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r0.amplifyService.i18n().get(ctx_r0.getPlaceholder()));
} }
function UsernameFieldComponentIonic_ion_item_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-item", 1);
    ɵngcc0.ɵɵelementStart(1, "amplify-auth-phone-field-ionic", 5);
    ɵngcc0.ɵɵlistener("phoneFieldChanged", function UsernameFieldComponentIonic_ion_item_1_Template_amplify_auth_phone_field_ionic_phoneFieldChanged_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onPhoneFieldChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function UsernameFieldComponentIonic_ion_item_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ion-item", 1);
    ɵngcc0.ɵɵelementStart(1, "ion-label", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ion-input", 7, 8);
    ɵngcc0.ɵɵlistener("keyup", function UsernameFieldComponentIonic_ion_item_2_Template_ion_input_keyup_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setUsername($event.target.value); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.amplifyService.i18n().get(ctx_r2.getUsernameLabel()), " *");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx_r2.amplifyService.i18n().get(ctx_r2.getPlaceholder()));
} }
function SumerianSceneLoadingComponentIonic_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.AmplifyUI.sceneErrorText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.sceneError);
} }
function SumerianSceneLoadingComponentIonic_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelement(1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.AmplifyUI.loadingBar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r1.AmplifyUI.loadingBarFill);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c4, ctx_r1.loadPercentage + "%"));
} }
class ComponentMount {
    constructor(component, data) {
        this.component = component;
        this.data = data;
    }
}

const logger = new Logger('AuthDecorator');
function check(authState, Auth) {
    // check for current authenticated user to init authState
    Auth.currentAuthenticatedUser()
        .then(user => {
        logger.debug('has authenticated user', user);
        authState.next({ state: 'signedIn', user });
    })
        .catch(err => {
        logger.debug('no authenticated user', err);
        authState.next({ state: 'signedOut', user: null });
    });
}
function listen(authState) {
    const config = Amplify.configure(null);
    if (has(config, 'Auth.oauth')) {
        Hub.listen('auth', {
            onHubCapsule: capsule => {
                const { channel, payload } = capsule;
                if (channel === 'auth') {
                    const { username } = payload.data;
                    logger.debug('authentication oauth event', payload);
                    authState.next({ state: payload.event, user: { username } });
                }
            },
        }, 'angularAuthListener');
    }
}
function decorateSignIn(authState, Auth) {
    const _signIn = Auth.signIn;
    Auth.signIn = (username, password) => {
        return _signIn
            .call(Auth, username, password)
            .then(user => {
            logger.debug('signIn success');
            if (!user.challengeName) {
                authState.next({ state: 'signedIn', user });
                return user;
            }
            logger.debug('signIn challenge: ' + user.challengeName);
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                authState.next({ state: 'requireNewPassword', user });
            }
            else if (user.challengeName === 'MFA_SETUP') {
                authState.next({ state: 'setupMFA', user });
            }
            else if (user.challengeName === 'SMS_MFA' ||
                user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                authState.next({ state: 'confirmSignIn', user });
            }
            else {
                logger.debug('warning: unhandled challengeName ' + user.challengeName);
            }
            return user;
        })
            .catch(err => {
            logger.debug('signIn error', err);
            throw err;
        });
    };
}
function decorateSignOut(authState, Auth) {
    const _signOut = Auth.signOut;
    Auth.signOut = () => {
        return _signOut
            .call(Amplify.Auth)
            .then(data => {
            logger.debug('signOut success');
            authState.next({ state: 'signedOut', user: null });
            return data;
        })
            .catch(err => {
            logger.debug('signOut error', err);
            throw err;
        });
    };
}
function decorateSignUp(authState, Auth) {
    const _signUp = Auth.signUp;
    Auth.signUp = (username, password, email, phone_number) => {
        return _signUp
            .call(Auth, username, password, email, phone_number)
            .then(data => {
            logger.debug('signUp success');
            authState.next({ state: 'confirmSignUp', user: { username } });
            return data;
        })
            .catch(err => {
            logger.debug('signUp error', err);
            throw err;
        });
    };
}
function decorateConfirmSignUp(authState, Auth) {
    const _confirmSignUp = Auth.confirmSignUp;
    Auth.confirmSignUp = (username, code) => {
        return _confirmSignUp
            .call(Auth, username, code)
            .then(data => {
            logger.debug('confirmSignUp success');
            authState.next({ state: 'signIn', user: { username } });
            return data;
        })
            .catch(err => {
            logger.debug('confirmSignUp error', err);
            throw err;
        });
    };
}
function authDecorator(authState, authModule) {
    check(authState, authModule);
    listen(authState);
    decorateSignIn(authState, authModule);
    decorateSignOut(authState, authModule);
    decorateSignUp(authState, authModule);
    decorateConfirmSignUp(authState, authModule);
}

// tslint:disable
let AmplifyService = class AmplifyService {
    constructor(modules = {}) {
        this.modules = modules;
        this._authState = new Subject();
        this.authStateChange$ = this._authState.asObservable();
        const source = modules || Amplify;
        authDecorator(this._authState, source.Auth);
        this._auth = source.Auth;
        this._analytics = source.Analytics;
        this._storage = source.Storage;
        this._api = source.API;
        this._cache = source.Cache;
        this._pubsub = source.PubSub;
        this._interactions = source.Interactions;
        this._xr = source.XR;
        // i18n and logger instantiated by default (do not change)
        this._i18n = I18n;
        this._logger = Logger;
    }
    auth() {
        return this._auth;
    }
    analytics() {
        return this._analytics;
    }
    storage() {
        return this._storage;
    }
    api() {
        return this._api;
    }
    interactions() {
        return this._interactions;
    }
    cache() {
        return this._cache;
    }
    pubsub() {
        return this._pubsub;
    }
    logger(name, level) {
        return new this._logger(name, level);
    }
    xr() {
        return this._xr;
    }
    i18n() {
        return this._i18n;
    }
    authState() {
        return this._authState;
    }
    setAuthState(state) {
        this._authState.next(state);
    }
};
AmplifyService.ɵfac = function AmplifyService_Factory(t) { return new (t || AmplifyService)(ɵngcc0.ɵɵinject('modules', 8)); };
AmplifyService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AmplifyService, factory: AmplifyService.ɵfac });
AmplifyService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: ['modules',] }, { type: Optional }] }
];
AmplifyService = __decorate([ __param(0, Inject('modules')),
    __param(0, Optional())
], AmplifyService);

var amplify_compose_service = modules => {
    return new AmplifyService(modules);
};

// tslint:disable
const template = `
  <div class="amplify-authenticator">
    <amplify-auth-sign-in-core
      *ngIf="!shouldHide('SignIn')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-sign-in-core>

    <amplify-auth-sign-up-core
      *ngIf="!shouldHide('SignUp')"
      [authState]="authState"
      [signUpConfig]="_signUpConfig"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-sign-up-core>

    <amplify-auth-confirm-sign-up-core
      *ngIf="!shouldHide('ConfirmSignUp')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-confirm-sign-up-core>

    <amplify-auth-confirm-sign-in-core
      *ngIf="!shouldHide('ConfirmSignIn')"
      [authState]="authState"
      [hide]="hide"
    ></amplify-auth-confirm-sign-in-core>

    <amplify-auth-forgot-password-core
      *ngIf="!shouldHide('ForgotPassword')"
      [authState]="authState"
      [usernameAttributes]="_usernameAttributes"
      [hide]="hide"
    ></amplify-auth-forgot-password-core>

    <amplify-auth-greetings-core
    *ngIf="!shouldHide('Greetings')"
    [authState]="authState"
    [usernameAttributes]="_usernameAttributes"
    ></amplify-auth-greetings-core>

     <amplify-auth-require-new-password-core
      *ngIf="!shouldHide('RequireNewPassword')"
      [authState]="authState"
      [hide]="hide"
    ></amplify-auth-require-new-password-core>
  </div>
`;
let AuthenticatorComponentCore = class AuthenticatorComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this.authState = {
            state: 'loading',
            user: null,
        };
        this._signUpConfig = {};
        this._usernameAttributes = 'username';
        this.hide = [];
        this.subscribe();
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
        else {
            const loadStatus = this.amplifyService
                .auth()
                .currentAuthenticatedUser()
                .then(user => {
                if (this.authState.state === 'loading' && user) {
                    this.amplifyService.setAuthState({ state: 'signedIn', user });
                }
            })
                .catch(e => {
                if (this.authState.state === 'loading') {
                    this.amplifyService.setAuthState({ state: 'signIn', user: null });
                }
            });
        }
    }
    set data(data) {
        if (data.signUpConfig) {
            this._signUpConfig = data.signUpConfig;
        }
        if (data.hide) {
            this.hide = data.hide;
        }
        this._usernameAttributes =
            data.usernameAttributes || this._usernameAttributes || 'username';
    }
    set signUpConfig(signUpConfig) {
        this._signUpConfig = signUpConfig;
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes || 'username';
    }
    subscribe() {
        this.amplifyService.authStateChange$.subscribe(state => {
            this.authState = state;
        }, () => {
            this.authState = {
                state: 'signIn',
                user: null,
            };
        });
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
};
AuthenticatorComponentCore.ɵfac = function AuthenticatorComponentCore_Factory(t) { return new (t || AuthenticatorComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
AuthenticatorComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthenticatorComponentCore, selectors: [["amplify-authenticator-core"]], inputs: { hide: "hide", data: "data", signUpConfig: "signUpConfig", usernameAttributes: "usernameAttributes" }, decls: 8, vars: 7, consts: [[1, "amplify-authenticator"], [3, "authState", "usernameAttributes", "hide", 4, "ngIf"], [3, "authState", "signUpConfig", "usernameAttributes", "hide", 4, "ngIf"], [3, "authState", "hide", 4, "ngIf"], [3, "authState", "usernameAttributes", 4, "ngIf"], [3, "authState", "usernameAttributes", "hide"], [3, "authState", "signUpConfig", "usernameAttributes", "hide"], [3, "authState", "hide"], [3, "authState", "usernameAttributes"]], template: function AuthenticatorComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AuthenticatorComponentCore_amplify_auth_sign_in_core_1_Template, 1, 3, "amplify-auth-sign-in-core", 1);
        ɵngcc0.ɵɵtemplate(2, AuthenticatorComponentCore_amplify_auth_sign_up_core_2_Template, 1, 4, "amplify-auth-sign-up-core", 2);
        ɵngcc0.ɵɵtemplate(3, AuthenticatorComponentCore_amplify_auth_confirm_sign_up_core_3_Template, 1, 3, "amplify-auth-confirm-sign-up-core", 1);
        ɵngcc0.ɵɵtemplate(4, AuthenticatorComponentCore_amplify_auth_confirm_sign_in_core_4_Template, 1, 2, "amplify-auth-confirm-sign-in-core", 3);
        ɵngcc0.ɵɵtemplate(5, AuthenticatorComponentCore_amplify_auth_forgot_password_core_5_Template, 1, 3, "amplify-auth-forgot-password-core", 1);
        ɵngcc0.ɵɵtemplate(6, AuthenticatorComponentCore_amplify_auth_greetings_core_6_Template, 1, 2, "amplify-auth-greetings-core", 4);
        ɵngcc0.ɵɵtemplate(7, AuthenticatorComponentCore_amplify_auth_require_new_password_core_7_Template, 1, 2, "amplify-auth-require-new-password-core", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("SignIn"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("SignUp"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ConfirmSignUp"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ConfirmSignIn"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ForgotPassword"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("Greetings"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("RequireNewPassword"));
    } }, directives: function () { return [ɵngcc1.NgIf, SignInComponentCore,
        SignUpComponentCore,
        ConfirmSignUpComponentCore,
        ConfirmSignInComponentCore,
        ForgotPasswordComponentCore,
        GreetingComponentCore,
        RequireNewPasswordComponentCore]; }, encapsulation: 2 });
AuthenticatorComponentCore.ctorParameters = () => [
    { type: AmplifyService }
];
__decorate([
    Input()
], AuthenticatorComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], AuthenticatorComponentCore.prototype, "data", null);
__decorate([
    Input()
], AuthenticatorComponentCore.prototype, "signUpConfig", null);
__decorate([
    Input()
], AuthenticatorComponentCore.prototype, "usernameAttributes", null);

// tslint:disable
const template$1 = `
<div class="amplify-authenticator amplify-authenticator-ionic ">

<amplify-auth-sign-in-ionic
  *ngIf="!shouldHide('SignIn')"
  [authState]="authState"
  [usernameAttributes]="_usernameAttributes"
  [hide]="hide"
></amplify-auth-sign-in-ionic>

<amplify-auth-sign-up-ionic
  *ngIf="!shouldHide('SignUp')"
  [authState]="authState"
  [signUpConfig]="_signUpConfig"
  [usernameAttributes]="_usernameAttributes"
  [hide]="hide"
></amplify-auth-sign-up-ionic>

<amplify-auth-confirm-sign-up-ionic
  *ngIf="!shouldHide('ConfirmSignUp')"
  [authState]="authState"
  [usernameAttributes]="_usernameAttributes"
  [hide]="hide"
></amplify-auth-confirm-sign-up-ionic>

<amplify-auth-confirm-sign-in-ionic
  *ngIf="!shouldHide('ConfirmSignIn')"
  [authState]="authState"
  [hide]="hide"
></amplify-auth-confirm-sign-in-ionic>

<amplify-auth-forgot-password-ionic
  *ngIf="!shouldHide('ForgotPassword')"
  [authState]="authState"
  [usernameAttributes]="_usernameAttributes"
  [hide]="hide"
></amplify-auth-forgot-password-ionic>

<amplify-auth-greetings-ionic
  *ngIf="!shouldHide('Greetings')"
  [authState]="authState"
  [usernameAttributes]="_usernameAttributes"
></amplify-auth-greetings-ionic>

<amplify-auth-require-new-password-ionic
  *ngIf="!shouldHide('RequireNewPassword')"
  [authState]="authState"
  [hide]="hide"
></amplify-auth-require-new-password-ionic>
</div>
`;
let AuthenticatorIonicComponent = class AuthenticatorIonicComponent extends AuthenticatorComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
AuthenticatorIonicComponent.ɵfac = function AuthenticatorIonicComponent_Factory(t) { return new (t || AuthenticatorIonicComponent)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
AuthenticatorIonicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthenticatorIonicComponent, selectors: [["amplify-authenticator-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 7, consts: [[1, "amplify-authenticator", "amplify-authenticator-ionic"], [3, "authState", "usernameAttributes", "hide", 4, "ngIf"], [3, "authState", "signUpConfig", "usernameAttributes", "hide", 4, "ngIf"], [3, "authState", "hide", 4, "ngIf"], [3, "authState", "usernameAttributes", 4, "ngIf"], [3, "authState", "usernameAttributes", "hide"], [3, "authState", "signUpConfig", "usernameAttributes", "hide"], [3, "authState", "hide"], [3, "authState", "usernameAttributes"]], template: function AuthenticatorIonicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AuthenticatorIonicComponent_amplify_auth_sign_in_ionic_1_Template, 1, 3, "amplify-auth-sign-in-ionic", 1);
        ɵngcc0.ɵɵtemplate(2, AuthenticatorIonicComponent_amplify_auth_sign_up_ionic_2_Template, 1, 4, "amplify-auth-sign-up-ionic", 2);
        ɵngcc0.ɵɵtemplate(3, AuthenticatorIonicComponent_amplify_auth_confirm_sign_up_ionic_3_Template, 1, 3, "amplify-auth-confirm-sign-up-ionic", 1);
        ɵngcc0.ɵɵtemplate(4, AuthenticatorIonicComponent_amplify_auth_confirm_sign_in_ionic_4_Template, 1, 2, "amplify-auth-confirm-sign-in-ionic", 3);
        ɵngcc0.ɵɵtemplate(5, AuthenticatorIonicComponent_amplify_auth_forgot_password_ionic_5_Template, 1, 3, "amplify-auth-forgot-password-ionic", 1);
        ɵngcc0.ɵɵtemplate(6, AuthenticatorIonicComponent_amplify_auth_greetings_ionic_6_Template, 1, 2, "amplify-auth-greetings-ionic", 4);
        ɵngcc0.ɵɵtemplate(7, AuthenticatorIonicComponent_amplify_auth_require_new_password_ionic_7_Template, 1, 2, "amplify-auth-require-new-password-ionic", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("SignIn"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("SignUp"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ConfirmSignUp"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ConfirmSignIn"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("ForgotPassword"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("Greetings"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shouldHide("RequireNewPassword"));
    } }, directives: function () { return [ɵngcc1.NgIf, SignInComponentIonic,
        SignUpComponentIonic,
        ConfirmSignUpComponentIonic,
        ConfirmSignInComponentIonic,
        ForgotPasswordComponentIonic,
        GreetingComponentIonic,
        RequireNewPasswordComponentIonic]; }, encapsulation: 2 });
AuthenticatorIonicComponent.ctorParameters = () => [
    { type: AmplifyService }
];

// tslint:disable
let AuthenticatorComponent = class AuthenticatorComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.hide = [];
        this.usernameAttributes = 'username';
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(AuthenticatorIonicComponent, {
                hide: this.hide,
                signUpConfig: this.signUpConfig,
                usernameAttributes: this.usernameAttributes,
            })
            : new ComponentMount(AuthenticatorComponentCore, {
                hide: this.hide,
                signUpConfig: this.signUpConfig,
                usernameAttributes: this.usernameAttributes,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
AuthenticatorComponent.ɵfac = function AuthenticatorComponent_Factory(t) { return new (t || AuthenticatorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
AuthenticatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthenticatorComponent, selectors: [["amplify-authenticator"]], inputs: { hide: "hide", usernameAttributes: "usernameAttributes", framework: "framework", signUpConfig: "signUpConfig" }, decls: 2, vars: 0, consts: [[1, "amplify-component"], ["component-host", ""]], template: function AuthenticatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AuthenticatorComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
AuthenticatorComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], AuthenticatorComponent.prototype, "framework", void 0);
__decorate([
    Input()
], AuthenticatorComponent.prototype, "hide", void 0);
__decorate([
    Input()
], AuthenticatorComponent.prototype, "signUpConfig", void 0);
__decorate([
    Input()
], AuthenticatorComponent.prototype, "usernameAttributes", void 0);
AuthenticatorComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], AuthenticatorComponent);

// tslint:disable
/*
 * Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
// Auth
const signIn = {
    section: 'sign-in-section',
    headerSection: 'sign-in-header-section',
    bodySection: 'sign-in-body-section',
    footerSection: 'sign-in-footer-section',
    usernameInput: 'username-input',
    passwordInput: 'sign-in-password-input',
    forgotPasswordLink: 'sign-in-forgot-password-link',
    signInButton: 'sign-in-sign-in-button',
    createAccountLink: 'sign-in-create-account-link',
    signInError: 'authenticator-error',
};
const signOut = {
    button: 'sign-out-button',
    section: 'sign-out-section',
};
const signUp = {
    section: 'sign-up-section',
    headerSection: 'sign-up-header-section',
    bodySection: 'sign-up-body-section',
    nonPhoneNumberInput: 'sign-up-non-phone-number-input',
    phoneNumberInput: 'sign-up-phone-number-input',
    dialCodeSelect: 'sign-up-dial-code-select',
    footerSection: 'sign-up-footer-section',
    createAccountButton: 'sign-up-create-account-button',
    signInLink: 'sign-up-sign-in-link',
    signUpButton: 'sign-up-sign-up-button',
    signInButton: 'sign-up-sign-in-button',
    confirmButton: 'sign-up-confirm-button',
};
const verifyContact = {
    section: 'verify-contact-section',
    headerSection: 'verify-contact-header-section',
    bodySection: 'verify-contact-body-section',
    submitButton: 'verify-contact-submit-button',
    verifyButton: 'verify-contact-verify-button',
    skipLink: 'verify-contact-skip-link',
};
const TOTPSetup = {
    component: 'totp-setup-component',
};
const requireNewPassword = {
    section: 'require-new-password-section',
    headerSection: 'require-new-password-header-section',
    footerSection: 'require-new-password-footer-section',
    bodySection: 'require-new-password-body-section',
    newPasswordInput: 'require-new-password-new-password-input',
    backToSignInLink: 'require-new-password-back-to-sign-in-link',
    submitButton: 'require-new-password-submit-button',
};
const loading = {
    section: 'loading-secton',
};
const greetings = {
    navBar: 'greetings-nav-bar',
    nav: 'greetings-nav',
    navRight: 'greetings-nav-right',
};
// TODO: Change Angular Component (Greeting) to match React Component (Greetings)
const greeting = {
    signOutButton: 'sign-out-button',
    signOutLink: 'greeting-sign-out-link',
    navRight: 'greetings-nav-right',
};
const federatedSignIn = {
    section: 'federated-sign-in-section',
    bodySection: 'federated-sign-in-body-section',
    signInButtons: 'federated-sign-in-buttons',
};
const confirmSignUp = {
    section: 'confirm-sign-up-section',
    headerSection: 'confirm-sign-up-header-section',
    bodySection: 'confirm-sign-up-body-section',
    usernameInput: 'confirm-sign-up-username-input',
    confirmationCodeInput: 'confirm-sign-up-confirmation-code-input',
    resendCodeLink: 'confirm-sign-up-resend-code-link',
    confirmButton: 'confirm-sign-up-confirm-button',
    backToSignInLink: 'confirm-sign-up-back-to-sign-in-link',
};
const confirmSignIn = {
    section: 'confirm-sign-in-section',
    headerSection: 'confirm-sign-in-header-section',
    bodySection: 'confirm-sign-in-body-section',
    codeInput: 'confirm-sign-in-code-input',
    confirmButton: 'confirm-sign-in-confirm-button',
    backToSignInLink: 'confirm-sign-in-back-to-sign-in-link',
};
const setMFAComp = {
    section: 'set-mfa-section',
    headerSection: 'set-mfa-header-section',
    bodySection: 'set-mfa-header-body-section',
    smsInput: 'set-mfa-sms-input',
    totpInput: 'set-mfa-totp-input',
    noMfaInput: 'set-mfa-nomfa-input',
    verificationCodeInput: 'set-mfa-verification-code-input',
    setMfaButton: 'set-mfa-set-mfa-button',
    verifyTotpTokenButton: 'set-mfa-verify-totp-token-button',
    cancelButton: 'set-mfa-cancel-button',
};
const forgotPassword = {
    section: 'forgot-password-section',
    headerSection: 'forgot-password-header-section',
    bodySection: 'forgot-password-body-section',
    submitButton: 'forgot-password-submit-button',
    sendCodeButton: 'forgot-password-send-code-button',
    resendCodeLink: 'forgot-password-resend-code-link',
    backToSignInLink: 'forgot-password-back-to-sign-in-link',
    usernameInput: 'username-input',
    codeInput: 'forgot-password-code-input',
    newPasswordInput: 'forgot-password-new-password-input',
};
const sumerianScene = {
    container: 'sumerian-scene-container',
    sumerianScene: 'sumerian-scene',
    loading: 'sumerian-scene-loading',
    loadingLogo: 'sumerian-scene-loading-logo',
    loadingSceneName: 'sumerian-scene-loading-scene-name',
    loadingBar: 'sumerian-scene-loading-bar',
    errorText: 'sumerian-scene-error-text',
    bar: 'sumerian-scene-bar',
    actions: 'sumerian-scene-actions',
};
const genericAttrs = {
    usernameInput: 'username-input',
    emailInput: 'email-input',
    phoneNumberInput: 'phone-number-input',
    dialCodeSelect: 'dial-code-select',
};
const auth = {
    signIn,
    signOut,
    signUp,
    verifyContact,
    TOTPSetup,
    requireNewPassword,
    loading,
    genericAttrs,
    greetings,
    greeting,
    federatedSignIn,
    confirmSignUp,
    confirmSignIn,
    setMFAComp,
    forgotPassword,
};

// tslint:disable
const template$2 = `
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="${auth.confirmSignIn.section}">
    <div class="amplify-form-body" data-test="${auth.confirmSignIn.bodySection}">
    <div class="amplify-form-header" data-test="${auth.confirmSignIn.headerSection}">{{ this.amplifyService.i18n().get('Confirm Sign in') }}</div>
      <div class="amplify-form-row" *ngIf="!shouldHide('SignIn')">
        <label class="amplify-input-label" for="code">
          {{ this.amplifyService.i18n().get('Confirmation Code *') }}
        </label>
        <input #code
          (change)="setCode(code.value)"
          (keyup)="setCode(code.value)"
          (keyup.enter)="onConfirm()"
          class="amplify-form-input"
          type="text"
          placeholder="{{ this.amplifyService.i18n().get('Enter your Code') }}"
          data-test="${auth.confirmSignIn.codeInput}"
        />
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-left">
          <div class="amplify-form-actions-left">
            <a 
              class="amplify-form-link"
              (click)="onSignIn()"
              data-test="${auth.confirmSignIn.backToSignInLink}"
              >
                {{ this.amplifyService.i18n().get('Back to Sign in') }}
            </a>
          </div>
        </div>
        <div class="amplify-form-cell-right">
          <button
            class="amplify-form-button"
            data-test="${auth.confirmSignIn.confirmButton}"
            (click)="onConfirm()"
            >
              {{ this.amplifyService.i18n().get('Confirm') }}</button>
        </div>
      </div>
      </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let ConfirmSignInComponentCore = class ConfirmSignInComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this.hide = [];
        this.logger = this.amplifyService.logger('ConfiSignInComponent');
    }
    set data(data) {
        this.hide = data.hide ? data.hide : this.hide;
        this._authState = data.authState;
        this._show = data.authState.state === 'confirmSignIn';
    }
    set authState(authState) {
        this._authState = authState;
        this._show = authState.state === 'confirmSignIn';
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    setCode(code) {
        this.code = code;
    }
    onConfirm() {
        const { user } = this._authState;
        const { challengeName } = user;
        const mfaType = challengeName === 'SOFTWARE_TOKEN_MFA' ? challengeName : null;
        this.amplifyService
            .auth()
            .confirmSignIn(user, this.code, mfaType)
            .then(() => {
            this.onAlertClose();
            this.amplifyService.setAuthState({ state: 'signedIn', user });
        })
            .catch(err => this._setError(err));
    }
    onSignIn() {
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signIn', user: null });
    }
    onAlertClose() {
        this._setError(null);
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
};
ConfirmSignInComponentCore.ɵfac = function ConfirmSignInComponentCore_Factory(t) { return new (t || ConfirmSignInComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ConfirmSignInComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignInComponentCore, selectors: [["amplify-auth-confirm-sign-in-core"]], inputs: { hide: "hide", data: "data", authState: "authState" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "confirm-sign-in-section", 1, "amplify-form-container"], ["data-test", "confirm-sign-in-body-section", 1, "amplify-form-body"], ["data-test", "confirm-sign-in-header-section", 1, "amplify-form-header"], ["class", "amplify-form-row", 4, "ngIf"], [1, "amplify-form-actions"], [1, "amplify-form-cell-left"], [1, "amplify-form-actions-left"], ["data-test", "confirm-sign-in-back-to-sign-in-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-form-cell-right"], ["data-test", "confirm-sign-in-confirm-button", 1, "amplify-form-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-row"], ["for", "code", 1, "amplify-input-label"], ["type", "text", "data-test", "confirm-sign-in-code-input", 1, "amplify-form-input", 3, "placeholder", "change", "keyup", "keyup.enter"], ["code", ""], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ConfirmSignInComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ConfirmSignInComponentCore_div_0_Template, 15, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
ConfirmSignInComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], ConfirmSignInComponentCore.prototype, "data", null);
__decorate([
    Input()
], ConfirmSignInComponentCore.prototype, "authState", null);
__decorate([
    Input()
], ConfirmSignInComponentCore.prototype, "hide", void 0);
ConfirmSignInComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], ConfirmSignInComponentCore);

const template$3 = `
<div class="amplify-form-container" *ngIf="_show" data-test="${auth.confirmSignIn.section}">
  <div class="amplify-form-body" data-test="${auth.confirmSignIn.bodySection}">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="${auth.confirmSignIn.headerSection}"
      >
        {{ this.amplifyService.i18n().get('Confirm your sign in code') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Code *') }}
        </ion-label>
        <ion-input
          #code
          type="text"
          class="amplify-form-input"
          (keyup)="setCode(code.value)"
          (keyup.enter)="onConfirm()"
          data-test="${auth.confirmSignIn.codeInput}"
        ></ion-input>
      </ion-item>
    </ion-list>

    <div class="amplify-form-actions">
      <div>
        <ion-button expand="block" color="primary"
          (click)="onConfirm()"
          data-test="${auth.confirmSignIn.confirmButton}"
        >{{ this.amplifyService.i18n().get('Confirm Code') }}</ion-button>
      </div>
    </div>
  </div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
`;
let ConfirmSignInComponentIonic = class ConfirmSignInComponentIonic extends ConfirmSignInComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
ConfirmSignInComponentIonic.ɵfac = function ConfirmSignInComponentIonic_Factory(t) { return new (t || ConfirmSignInComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ConfirmSignInComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignInComponentIonic, selectors: [["amplify-auth-confirm-sign-in-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-form-container", "data-test", "confirm-sign-in-section", 4, "ngIf"], ["data-test", "confirm-sign-in-section", 1, "amplify-form-container"], ["data-test", "confirm-sign-in-body-section", 1, "amplify-form-body"], ["data-test", "confirm-sign-in-header-section", 1, "amplify-form-header", "amplify-form-header-ionic"], ["lines", "none"], ["position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "data-test", "confirm-sign-in-code-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["code", ""], [1, "amplify-form-actions"], ["expand", "block", "color", "primary", "data-test", "confirm-sign-in-confirm-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ConfirmSignInComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ConfirmSignInComponentIonic_div_0_Template, 15, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
ConfirmSignInComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
ConfirmSignInComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], ConfirmSignInComponentIonic);

// tslint:disable
let ConfirmSignInComponent = class ConfirmSignInComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(ConfirmSignInComponentIonic, {
                authState: this.authState,
                hide: this.hide,
            })
            : new ComponentMount(ConfirmSignInComponentCore, {
                authState: this.authState,
                hide: this.hide,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
ConfirmSignInComponent.ɵfac = function ConfirmSignInComponent_Factory(t) { return new (t || ConfirmSignInComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
ConfirmSignInComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignInComponent, selectors: [["amplify-auth-confirm-sign-in"]], inputs: { hide: "hide", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function ConfirmSignInComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ConfirmSignInComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
ConfirmSignInComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], ConfirmSignInComponent.prototype, "framework", void 0);
__decorate([
    Input()
], ConfirmSignInComponent.prototype, "authState", void 0);
__decorate([
    Input()
], ConfirmSignInComponent.prototype, "hide", void 0);
ConfirmSignInComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], ConfirmSignInComponent);

// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
function includes(ary, match) {
    return ary.filter(item => item === match).length > 0;
}
const labelMap = {
    email: 'Email',
    phone_number: 'Phone Number',
    username: 'Username',
};
const composePhoneNumber = (countryCode, local_phone_number) => {
    return `+${countryCode}${local_phone_number.replace(/[-()]/g, '')}`;
};

// tslint:disable
const template$4 = `
<div class="amplify-container" *ngIf="_show">
<div class="amplify-form-container" data-test="${auth.confirmSignUp.section}">
  <div class="amplify-form-body" data-test="${auth.confirmSignUp.bodySection}">
    <div
      class="amplify-form-header"
      data-test="${auth.confirmSignUp.headerSection}"
    >
      {{ this.amplifyService.i18n().get('Confirm Sign up') }}</div>
    <div class="amplify-form-row">
      <label class="amplify-input-label" for="amplifyUsername">
        {{ this.amplifyService.i18n().get(getUsernameLabel()) }}
      </label>
      <input
        #amplifyUsername
        class="amplify-form-input"
        type="text"
        disabled
        placeholder="{{ this.amplifyService.i18n().get(getUsernameLabel()) }}"
        [value]="username"
        data-test="${auth.confirmSignUp.usernameInput}"
      />
    </div>
    <div class="amplify-form-row">
      <label class="amplify-input-label" for="code">
        {{ this.amplifyService.i18n().get('Confirmation Code *') }}
      </label>
      <input #code
        (change)="setCode(code.value)"
        (keyup)="setCode(code.value)"
        (keyup.enter)="onConfirm()"
        class="amplify-form-input"
        type="text"
        placeholder="{{ this.amplifyService.i18n().get('Enter your Code') }}"
        data-test="${auth.confirmSignUp.confirmationCodeInput}"
      />
      <span class="amplify-form-action">{{ this.amplifyService.i18n().get('Lost your code?') }}
        <a class="amplify-form-link"
            (click)="onResend()"
            data-test="${auth.confirmSignUp.resendCodeLink}"
          >{{ this.amplifyService.i18n().get('Resend Code') }}</a></span>
    </div>
    <div class="amplify-form-actions">
      <div class="amplify-form-cell-left">
        <div class="amplify-form-actions-left">
          <a
            class="amplify-form-link"
            (click)="onSignIn()"
            data-test="${auth.confirmSignUp.backToSignInLink}"
            >
            {{ this.amplifyService.i18n().get('Back to Sign in') }}
          </a>
        </div>
      </div>
      <div class="amplify-form-cell-right">
        <button
          class="amplify-form-button"
          (click)="onConfirm()"
          data-test="${auth.confirmSignUp.confirmButton}"
          >{{ this.amplifyService.i18n().get('Confirm') }}</button>
      </div>
    </div>
  </div>
</div>
<div class="amplify-alert" *ngIf="errorMessage">
  <div class="amplify-alert-body">
    <span class="amplify-alert-icon">&#9888;</span>
    <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
    <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
  </div>
</div>
</div>
`;
let ConfirmSignUpComponentCore = class ConfirmSignUpComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.hide = [];
        this.logger = this.amplifyService.logger('ConfirmSignUpComponent');
    }
    set data(data) {
        this.hide = data.hide ? data.hide : this.hide;
        this._authState = data.authState;
        this._show = data.authState.state === 'confirmSignUp';
        this.username = data.authState.user
            ? data.authState.user.username || ''
            : '';
    }
    set authState(authState) {
        this._authState = authState;
        this._show = authState.state === 'confirmSignUp';
        this.username = authState.user ? authState.user.username || '' : '';
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    setUsername(username) {
        this.username = username;
    }
    setCode(code) {
        this.code = code;
    }
    onConfirm() {
        this.amplifyService
            .auth()
            .confirmSignUp(this.username, this.code)
            .then(() => this.logger.info('confirm success'))
            .catch(err => this._setError(err));
    }
    onResend() {
        this.amplifyService
            .auth()
            .resendSignUp(this.username)
            .then(() => this.logger.info('code resent'))
            .catch(err => this._setError(err));
    }
    onSignIn() {
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signIn', user: null });
    }
    onAlertClose() {
        this._setError(null);
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
    getUsernameLabel() {
        return (labelMap[this._usernameAttributes] || this._usernameAttributes);
    }
};
ConfirmSignUpComponentCore.ɵfac = function ConfirmSignUpComponentCore_Factory(t) { return new (t || ConfirmSignUpComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ConfirmSignUpComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignUpComponentCore, selectors: [["amplify-auth-confirm-sign-up-core"]], inputs: { hide: "hide", data: "data", authState: "authState", usernameAttributes: "usernameAttributes" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "confirm-sign-up-section", 1, "amplify-form-container"], ["data-test", "confirm-sign-up-body-section", 1, "amplify-form-body"], ["data-test", "confirm-sign-up-header-section", 1, "amplify-form-header"], [1, "amplify-form-row"], ["for", "amplifyUsername", 1, "amplify-input-label"], ["type", "text", "disabled", "", "data-test", "confirm-sign-up-username-input", 1, "amplify-form-input", 3, "placeholder", "value"], ["amplifyUsername", ""], ["for", "code", 1, "amplify-input-label"], ["type", "text", "data-test", "confirm-sign-up-confirmation-code-input", 1, "amplify-form-input", 3, "placeholder", "change", "keyup", "keyup.enter"], ["code", ""], [1, "amplify-form-action"], ["data-test", "confirm-sign-up-resend-code-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-form-actions"], [1, "amplify-form-cell-left"], [1, "amplify-form-actions-left"], ["data-test", "confirm-sign-up-back-to-sign-in-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-form-cell-right"], ["data-test", "confirm-sign-up-confirm-button", 1, "amplify-form-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ConfirmSignUpComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ConfirmSignUpComponentCore_div_0_Template, 28, 11, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
ConfirmSignUpComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], ConfirmSignUpComponentCore.prototype, "data", null);
__decorate([
    Input()
], ConfirmSignUpComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], ConfirmSignUpComponentCore.prototype, "authState", null);
__decorate([
    Input()
], ConfirmSignUpComponentCore.prototype, "usernameAttributes", null);
ConfirmSignUpComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], ConfirmSignUpComponentCore);

// tslint:disable
const template$5 = `
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="${auth.confirmSignUp.section}"
  >
  <div class="amplify-form-body" data-test="${auth.confirmSignUp.bodySection}">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="${auth.confirmSignUp.headerSection}"
      >
      {{ this.amplifyService.i18n().get('Confirm your sign up code') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get(getUsernameLabel()) }}
        </ion-label>
        <ion-input type="text"
          class="amplify-form-input"
          (keyup)="setUsername($event.target.value)"
          [value]="username"
          data-test="${auth.confirmSignUp.usernameInput}"
        ></ion-input>
      </ion-item>

      <ion-item lines="none">
        <ion-label  class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Code *') }}
        </ion-label>
        <ion-input
          #code
          type="text"
          class="amplify-form-input"
          (keyup)="setCode(code.value)"
          (keyup.enter)="onConfirm()"
          data-test="${auth.confirmSignUp.confirmationCodeInput}"
        ></ion-input>
      </ion-item>
    </ion-list>

    <div class="amplify-form-actions">
      <div>
        <ion-button
          expand="block"
          color="primary"
          (click)="onConfirm()"
          data-test="${auth.confirmSignUp.confirmButton}"
          >
          {{ this.amplifyService.i18n().get('Confirm Code') }}</ion-button>
      </div>
    <div class="amplify-form-row">
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Have an account?') }}
        <a
          class="amplify-form-link"
          (click)="onSignIn()"
          data-test="${auth.confirmSignUp.backToSignInLink}"
          >
          {{ this.amplifyService.i18n().get('Sign In') }}
        </a>
      </div>
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Lost your code?') }}
        <a
          class="amplify-form-link"
          (click)="onResend()"
          data-test="${auth.confirmSignUp.resendCodeLink}"
          >
          {{ this.amplifyService.i18n().get('Resend') }}
        </a>
      </div>
    </div>
  </div>
</div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
`;
let ConfirmSignUpComponentIonic = class ConfirmSignUpComponentIonic extends ConfirmSignUpComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
ConfirmSignUpComponentIonic.ɵfac = function ConfirmSignUpComponentIonic_Factory(t) { return new (t || ConfirmSignUpComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ConfirmSignUpComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignUpComponentIonic, selectors: [["amplify-auth-confirm-sign-up-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-authenticator amplify-authenticator-ionic", "data-test", "confirm-sign-up-section", 4, "ngIf"], ["data-test", "confirm-sign-up-section", 1, "amplify-authenticator", "amplify-authenticator-ionic"], ["data-test", "confirm-sign-up-body-section", 1, "amplify-form-body"], ["data-test", "confirm-sign-up-header-section", 1, "amplify-form-header", "amplify-form-header-ionic"], ["lines", "none"], ["position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "data-test", "confirm-sign-up-username-input", 1, "amplify-form-input", 3, "value", "keyup"], ["type", "text", "data-test", "confirm-sign-up-confirmation-code-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["code", ""], [1, "amplify-form-actions"], ["expand", "block", "color", "primary", "data-test", "confirm-sign-up-confirm-button", 3, "click"], [1, "amplify-form-row"], [1, "amplify-form-signup"], ["data-test", "confirm-sign-up-back-to-sign-in-link", 1, "amplify-form-link", 3, "click"], ["data-test", "confirm-sign-up-resend-code-link", 1, "amplify-form-link", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ConfirmSignUpComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ConfirmSignUpComponentIonic_div_0_Template, 28, 10, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
ConfirmSignUpComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
ConfirmSignUpComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], ConfirmSignUpComponentIonic);

// tslint:disable
let ConfirmSignUpComponent = class ConfirmSignUpComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.usernameAttributes = 'username';
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(ConfirmSignUpComponentIonic, {
                authState: this.authState,
                usernameAttributes: this.usernameAttributes,
                hide: this.hide,
            })
            : new ComponentMount(ConfirmSignUpComponentCore, {
                authState: this.authState,
                usernameAttributes: this.usernameAttributes,
                hide: this.hide,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
ConfirmSignUpComponent.ɵfac = function ConfirmSignUpComponent_Factory(t) { return new (t || ConfirmSignUpComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
ConfirmSignUpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ConfirmSignUpComponent, selectors: [["amplify-auth-confirm-sign-up"]], inputs: { usernameAttributes: "usernameAttributes", hide: "hide", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function ConfirmSignUpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ConfirmSignUpComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
ConfirmSignUpComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], ConfirmSignUpComponent.prototype, "framework", void 0);
__decorate([
    Input()
], ConfirmSignUpComponent.prototype, "authState", void 0);
__decorate([
    Input()
], ConfirmSignUpComponent.prototype, "usernameAttributes", void 0);
__decorate([
    Input()
], ConfirmSignUpComponent.prototype, "hide", void 0);
ConfirmSignUpComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], ConfirmSignUpComponent);

var UsernameAttributes;
(function (UsernameAttributes) {
    UsernameAttributes["EMAIL"] = "email";
    UsernameAttributes["PHONE_NUMBER"] = "phone_number";
    UsernameAttributes["USERNAME"] = "username";
})(UsernameAttributes || (UsernameAttributes = {}));

// tslint:disable
const template$6 = `
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="${auth.signIn.section}">
    <div class="amplify-form-body" data-test="${auth.signIn.bodySection}">
      <div class="amplify-form-header" data-test="${auth.signIn.headerSection}">
        {{ this.amplifyService.i18n().get('Sign in to your account') }}
      </div>
      <amplify-auth-username-field-core
        [usernameAttributes]="_usernameAttributes"
        (usernameFieldChanged)="onUsernameFieldChanged($event)"
      ></amplify-auth-username-field-core>
      <div class="amplify-form-row amplify-signin-password">
        <label class="amplify-input-label" for="passwordField">
          {{ this.amplifyService.i18n().get('Password *') }}
        </label>
        <input #passwordField
          (keyup)="setPassword(passwordField.value)"
          (keyup.enter)="onSignIn()"
          class="amplify-form-input"
          type="password"
          required
          placeholder="{{ this.amplifyService.i18n().get('Enter your password') }}"
          data-test="${auth.signIn.passwordInput}"
        />
        <span class="amplify-form-action" *ngIf="!shouldHide('ForgotPassword')">
          {{ this.amplifyService.i18n().get('Forgot Password?') }}
          <a class="amplify-form-link"
            (click)="onForgotPassword()"
            data-test="${auth.signIn.forgotPasswordLink}"
          >{{ this.amplifyService.i18n().get('Reset password') }}</a>
        </span>
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-right">
          <button class="amplify-form-button"
            (click)="onSignIn()"
            data-test="${auth.signIn.signInButton}"
          >{{ this.amplifyService.i18n().get('Sign In') }}</button>
        </div>
        <div class="amplify-form-cell-left" *ngIf="!shouldHide('SignUp')">
          <div class="amplify-form-signup">
            {{ this.amplifyService.i18n().get('No account?') }}
            <a
              class="amplify-form-link"
              (click)="onSignUp()"
              data-test="${auth.signIn.createAccountLink}"
              >
              {{ this.amplifyService.i18n().get('Create account') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div
        class="amplify-alert-message"
        data-test="${auth.signIn.signInError}"
        >
          {{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let SignInComponentCore = class SignInComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.local_phone_number = '';
        this.country_code = '1';
        this.email = '';
        this.signInUsername = '';
        this.hide = [];
        this.logger = this.amplifyService.logger('SignInComponent');
        this.onUsernameFieldChanged = this.onUsernameFieldChanged.bind(this);
    }
    set data(data) {
        this.hide = data.hide ? data.hide : this.hide;
        this._usernameAttributes = data.usernameAttributes;
        this._authState = data.authState;
        this._show = includes(['signIn', 'signedOut', 'signedUp'], data.authState.state);
    }
    set authState(authState) {
        this._authState = authState;
        this._show = includes(['signIn', 'signedOut', 'signedUp'], authState.state);
        this.username = authState.user ? authState.user.username || '' : '';
        this.email = authState.user ? authState.user.email || '' : '';
        this.country_code =
            authState.user && authState.user.country_code
                ? authState.user.country_code
                : this.country_code;
        this.local_phone_number = authState.user
            ? authState.user.local_phone_number || ''
            : '';
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    setUsername(username) {
        this.username = username;
    }
    setPassword(password) {
        this.password = password;
    }
    onSignIn() {
        this.amplifyService
            .auth()
            .signIn(this.getSignInUsername(), this.password)
            .then(user => {
            if (user['challengeName'] === 'SMS_MFA' ||
                user['challengeName'] === 'SOFTWARE_TOKEN_MFA') {
                this.amplifyService.setAuthState({ state: 'confirmSignIn', user });
            }
            else if (user['challengeName'] === 'NEW_PASSWORD_REQUIRED') {
                this.amplifyService.setAuthState({
                    state: 'requireNewPassword',
                    user,
                });
            }
            else if (user['challengeName'] === 'CUSTOM_CHALLENGE' &&
                user.challengeParam &&
                user.challengeParam.trigger === 'true') {
                this.amplifyService.setAuthState({
                    state: 'customConfirmSignIn',
                    user,
                });
            }
        })
            .catch(err => {
            this._setError(err);
        });
    }
    onAlertClose() {
        this._setError(null);
    }
    getUserObj() {
        const user = this.username || this.email || this.local_phone_number
            ? {
                username: this.username,
                email: this.email,
                local_phone_number: this.local_phone_number,
                courtry_code: this.country_code,
            }
            : null;
        return user;
    }
    onForgotPassword() {
        const user = this.getUserObj();
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'forgotPassword', user });
    }
    onSignUp() {
        const user = this.getUserObj();
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signUp', user });
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
        this.logger.error(this.errorMessage);
    }
    onUsernameFieldChanged(event) {
        this.email = event.email || this.email;
        this.username = event.username || this.username;
        this.country_code = event.country_code || this.country_code;
        this.local_phone_number =
            event.local_phone_number || this.local_phone_number;
    }
    getSignInUsername() {
        switch (this._usernameAttributes) {
            case UsernameAttributes.EMAIL:
                return this.email;
            case UsernameAttributes.PHONE_NUMBER:
                return composePhoneNumber(this.country_code, this.local_phone_number);
            default:
                return this.username;
        }
    }
};
SignInComponentCore.ɵfac = function SignInComponentCore_Factory(t) { return new (t || SignInComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SignInComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignInComponentCore, selectors: [["amplify-auth-sign-in-core"]], inputs: { hide: "hide", data: "data", authState: "authState", usernameAttributes: "usernameAttributes" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "sign-in-section", 1, "amplify-form-container"], ["data-test", "sign-in-body-section", 1, "amplify-form-body"], ["data-test", "sign-in-header-section", 1, "amplify-form-header"], [3, "usernameAttributes", "usernameFieldChanged"], [1, "amplify-form-row", "amplify-signin-password"], ["for", "passwordField", 1, "amplify-input-label"], ["type", "password", "required", "", "data-test", "sign-in-password-input", 1, "amplify-form-input", 3, "placeholder", "keyup", "keyup.enter"], ["passwordField", ""], ["class", "amplify-form-action", 4, "ngIf"], [1, "amplify-form-actions"], [1, "amplify-form-cell-right"], ["data-test", "sign-in-sign-in-button", 1, "amplify-form-button", 3, "click"], ["class", "amplify-form-cell-left", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-action"], ["data-test", "sign-in-forgot-password-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-form-cell-left"], [1, "amplify-form-signup"], ["data-test", "sign-in-create-account-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], ["data-test", "authenticator-error", 1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function SignInComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SignInComponentCore_div_0_Template, 18, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, UsernameFieldComponentCore]; }, encapsulation: 2 });
SignInComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], SignInComponentCore.prototype, "data", null);
__decorate([
    Input()
], SignInComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], SignInComponentCore.prototype, "authState", null);
__decorate([
    Input()
], SignInComponentCore.prototype, "usernameAttributes", null);
SignInComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], SignInComponentCore);

// tslint:disable
const template$7 = `
<div
  class="amplify-authenticator"
  *ngIf="_show"
  data-test="${auth.signIn.section}"
  >
  <div class="amplify-form-body" data-test="${auth.signIn.bodySection}">
    <div class="amplify-form-header" data-test="${auth.signIn.headerSection}">
      {{ this.amplifyService.i18n().get('Sign in to your account') }}
    </div>
    <ion-list lines="none">
      <amplify-auth-username-field-ionic
        [usernameAttributes]="_usernameAttributes"
        (usernameFieldChanged)="onUsernameFieldChanged($event)"
      ></amplify-auth-username-field-ionic>
      <ion-item lines="none">
        <ion-label class="amplify-input-label" for="password" position="stacked">
          {{ this.amplifyService.i18n().get('Password *') }}
        </ion-label>
        <ion-input
          #password
          type="password"
          class="amplify-form-input"
          (keyup)="setPassword(password.value)"
          (keyup.enter)="onSignIn()"
          data-test="${auth.signIn.passwordInput}"
        ></ion-input>
      </ion-item>
    </ion-list>
    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button expand="block" color="primary"
          (click)="onSignIn()"
          data-test="${auth.signIn.signInButton}"
          >{{ this.amplifyService.i18n().get('Sign In') }}</ion-button>
      </div>

      <div class="amplify-form-row">
        <div class="amplify-form-signup" *ngIf="!shouldHide('SignUp')">
          {{ this.amplifyService.i18n().get('No account?') }}
          <a
            class="amplify-form-link"
            (click)="onSignUp()"
            data-test="${auth.signIn.createAccountLink}"
            >
            {{ this.amplifyService.i18n().get('Create account') }}
          </a>
        </div>
        <div class="amplify-form-signup" *ngIf="!shouldHide('ForgotPassword')">
          <a class="amplify-form-link" (click)="onForgotPassword()" data-test="${auth.signIn.forgotPasswordLink}">
            {{ this.amplifyService.i18n().get('Reset Password') }}
          </a>
        </div>
      </div>

    </div>
  </div>

  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let SignInComponentIonic = class SignInComponentIonic extends SignInComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
SignInComponentIonic.ɵfac = function SignInComponentIonic_Factory(t) { return new (t || SignInComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SignInComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignInComponentIonic, selectors: [["amplify-auth-sign-in-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-authenticator", "data-test", "sign-in-section", 4, "ngIf"], ["data-test", "sign-in-section", 1, "amplify-authenticator"], ["data-test", "sign-in-body-section", 1, "amplify-form-body"], ["data-test", "sign-in-header-section", 1, "amplify-form-header"], ["lines", "none"], [3, "usernameAttributes", "usernameFieldChanged"], ["for", "password", "position", "stacked", 1, "amplify-input-label"], ["type", "password", "data-test", "sign-in-password-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["password", ""], [1, "amplify-form-actions"], [1, "amplify-form-row"], ["expand", "block", "color", "primary", "data-test", "sign-in-sign-in-button", 3, "click"], ["class", "amplify-form-signup", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-signup"], ["data-test", "sign-in-create-account-link", 1, "amplify-form-link", 3, "click"], ["data-test", "sign-in-forgot-password-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function SignInComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SignInComponentIonic_div_0_Template, 19, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, UsernameFieldComponentIonic]; }, encapsulation: 2 });
SignInComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
SignInComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], SignInComponentIonic);

// tslint:disable
let SignInComponent = class SignInComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.usernameAttributes = 'username';
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework === 'ionic'
            ? new ComponentMount(SignInComponentIonic, {
                authState: this.authState,
                hide: this.hide,
                usernameAttributes: this.usernameAttributes,
            })
            : new ComponentMount(SignInComponentCore, {
                authState: this.authState,
                hide: this.hide,
                usernameAttributes: this.usernameAttributes,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
SignInComponent.ɵfac = function SignInComponent_Factory(t) { return new (t || SignInComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
SignInComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignInComponent, selectors: [["amplify-auth-sign-in"]], inputs: { usernameAttributes: "usernameAttributes", hide: "hide", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function SignInComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, SignInComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
SignInComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], SignInComponent.prototype, "framework", void 0);
__decorate([
    Input()
], SignInComponent.prototype, "authState", void 0);
__decorate([
    Input()
], SignInComponent.prototype, "usernameAttributes", void 0);
__decorate([
    Input()
], SignInComponent.prototype, "hide", void 0);
SignInComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], SignInComponent);

// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
var defaultSignUpFieldAssets = [
    {
        label: 'Username',
        key: 'username',
        required: false,
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 3,
    },
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 4,
    },
];
const signUpWithEmailFields = [
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 3,
    },
];
const signUpWithPhoneNumberFields = [
    {
        label: 'Phone Number',
        key: 'phone_number',
        required: true,
        displayOrder: 1,
    },
    {
        label: 'Password',
        key: 'password',
        required: true,
        type: 'password',
        displayOrder: 2,
    },
    {
        label: 'Email',
        key: 'email',
        required: true,
        type: 'email',
        displayOrder: 3,
    },
];

// tslint:disable
const template$8 = `
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="${auth.signUp.section}">
    <div class="amplify-form-body" data-test="${auth.signUp.bodySection}">
      <div
        class="amplify-form-header"
        data-test="${auth.signUp.headerSection}"
        >{{ this.amplifyService.i18n().get(this.header) }}</div>
      <div class="amplify-form-row" *ngFor="let field of signUpFields">
        <div *ngIf="field.key !== 'phone_number'">
          <label class="amplify-input-label">
            {{ this.amplifyService.i18n().get(field.label) }}
            <span *ngIf="field.required">*</span>
          </label>
          <input #{{field.key}}
            class="amplify-form-input"
            [ngClass]="{'amplify-input-invalid ': field.invalid}"
            type={{field.type}}
            [placeholder]="this.amplifyService.i18n().get(field.label)"
            [(ngModel)]="user[field.key]"
            name="field.key"
            data-test="${auth.signUp.nonPhoneNumberInput}"
            />
            <div *ngIf="field.key === 'password'" class="amplify-form-extra-details">
              {{passwordPolicy}}
            </div>
        </div>
        <div *ngIf="field.key === 'phone_number'">
          <amplify-auth-phone-field-core
            [label]="field.label"
            [required]="field.required"
            [placeholder]="field.placeholder"
            [defaultCountryCode]="country_code"
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
          ></amplify-auth-phone-field-core>
        </div>
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-left" *ngIf="!shouldHide('SignIn')">
          <div class="amplify-form-signup">
            {{ this.amplifyService.i18n().get('Have an account?') }}
            <a class="amplify-form-link" (click)="onSignIn()" data-test="${auth.signUp.signInLink}">
              {{ this.amplifyService.i18n().get('Sign in') }}
            </a>
          </div>
        </div>
        <div class="amplify-form-cell-right">
          <button class="amplify-form-button"
          (click)="onSignUp()"
          data-test="${auth.signUp.createAccountButton}"
          >{{ this.amplifyService.i18n().get('Create Account') }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
class SignUpField {
}
let SignUpComponentCore = class SignUpComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.user = {};
        this.country_code = '1';
        this.header = 'Create a new account';
        this.defaultSignUpFields = defaultSignUpFieldAssets;
        this.signUpFields = this.defaultSignUpFields;
        this.hiddenFields = [];
        this.hide = [];
        this.logger = this.amplifyService.logger('SignUpComponent');
    }
    set data(data) {
        this._authState = data.authState;
        this._show = data.authState.state === 'signUp';
        this._usernameAttributes = data.usernameAttributes;
        if (data.signUpConfig) {
            this._signUpConfig = data.signUpConfig;
            if (this._signUpConfig.defaultCountryCode) {
                this.country_code = this._signUpConfig.defaultCountryCode;
            }
            if (this._signUpConfig.signUpFields) {
                this.signUpFields = this._signUpConfig.signUpFields;
            }
            if (this._signUpConfig.header) {
                this.header = this._signUpConfig.header;
            }
            if (this._signUpConfig.hiddenDefaults) {
                this.hiddenFields = this._signUpConfig.hiddenDefaults;
            }
            if (this._usernameAttributes === UsernameAttributes.EMAIL) {
                this.signUpFields = signUpWithEmailFields;
                this.defaultSignUpFields = signUpWithEmailFields;
            }
            else if (this._usernameAttributes === UsernameAttributes.PHONE_NUMBER) {
                this.signUpFields = signUpWithPhoneNumberFields;
                this.defaultSignUpFields = signUpWithPhoneNumberFields;
            }
            if (this._signUpConfig.passwordPolicy) {
                this.passwordPolicy = this._signUpConfig.passwordPolicy;
            }
        }
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
        if (this._usernameAttributes === UsernameAttributes.EMAIL) {
            this.signUpFields = signUpWithEmailFields;
            this.defaultSignUpFields = signUpWithEmailFields;
        }
        else if (this._usernameAttributes === UsernameAttributes.PHONE_NUMBER) {
            this.signUpFields = signUpWithPhoneNumberFields;
            this.defaultSignUpFields = signUpWithPhoneNumberFields;
        }
    }
    set authState(authState) {
        this._authState = authState;
        this._show = authState.state === 'signUp';
    }
    set signUpConfig(signUpConfig) {
        if (signUpConfig) {
            this._signUpConfig = signUpConfig;
            if (this._signUpConfig.defaultCountryCode) {
                this.country_code = this._signUpConfig.defaultCountryCode;
            }
            if (this._signUpConfig.signUpFields) {
                this.signUpFields = this._signUpConfig.signUpFields;
            }
            if (this._signUpConfig.header) {
                this.header = this._signUpConfig.header;
            }
            if (this._signUpConfig.hiddenDefaults) {
                this.hiddenFields = this._signUpConfig.hiddenDefaults;
            }
            if (this._signUpConfig.passwordPolicy) {
                this.passwordPolicy = this._signUpConfig.passwordPolicy;
            }
        }
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            this.logger.warn('Auth module not registered on AmplifyService provider');
        }
        this.sortFields();
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    onSignUp() {
        // validate  required inputs
        const validation = this.validate();
        if (validation && validation.length > 0) {
            return this._setError(`The following fields need to be filled out: ${validation.join(', ')}`);
        }
        // create user attribute property
        this.user.attributes = {};
        // format phone number if it is a signUpField
        const phoneNumberRequested = this.signUpFields.find(el => {
            return el.key === 'phone_number';
        });
        if (phoneNumberRequested) {
            this.user.phone_number = composePhoneNumber(this.country_code, this.local_phone_number);
        }
        // create user key and value arrays
        const userKeys = Object.keys(this.user);
        const userValues = userKeys.map(key => this.user[key]);
        // format data for Cognito user pool
        userKeys.forEach((key, index) => {
            if (key !== 'username' && key !== 'password' && key !== 'attributes') {
                // needsPrefix determines if a custom attribute is indicated
                // and prepends 'custom:' to the key before sending to Cognito if needed
                const newKey = `${this.needPrefix(key) ? 'custom:' : ''}${key}`;
                this.user.attributes[newKey] = userValues[index];
            }
        });
        let labelCheck = false;
        this.signUpFields.forEach(field => {
            if (field.label === this.getUsernameLabel()) {
                this.amplifyService.logger(`Changing the username to the value of ${field.label}`, 'DEBUG');
                this.user.username =
                    this.user.attributes[field.key] || this.user.username;
                labelCheck = true;
            }
        });
        if (!labelCheck && !this.user.username) {
            // if the customer customized the username field in the sign up form
            // He needs to either set the key of that field to 'username'
            // Or make the label of the field the same as the 'usernameAttributes'
            throw new Error(`Couldn't find the label: ${this.getUsernameLabel()}, in sign up fields according to usernameAttributes!`);
        }
        this.amplifyService
            .auth()
            .signUp(this.user)
            .then(user => {
            const username = this.user.username;
            this.user = {};
            this.onAlertClose();
            this.amplifyService.setAuthState({
                state: 'confirmSignUp',
                user: { username: username },
            });
        })
            .catch(err => this._setError(err));
    }
    onSignIn() {
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signIn', user: null });
    }
    needPrefix(key) {
        const field = this.signUpFields.find(e => e.key === key);
        if (key.indexOf('custom:') !== 0) {
            return field.custom;
        }
        else if (key.indexOf('custom:') === 0 && field.custom === false) {
            this.logger.warn('Custom prefix prepended to key but custom field flag is set to false');
        }
        return null;
    }
    onConfirmSignUp() {
        this.onAlertClose();
        this.amplifyService.setAuthState({
            state: 'confirmSignUp',
            user: { username: this.user.username },
        });
    }
    sortFields() {
        if (this.hiddenFields.length > 0) {
            this.defaultSignUpFields = this.defaultSignUpFields.filter(d => {
                return !this.hiddenFields.includes(d.key);
            });
        }
        if (this._signUpConfig &&
            this._signUpConfig.signUpFields &&
            this._signUpConfig.signUpFields.length > 0) {
            if (!this._signUpConfig.hideAllDefaults) {
                // see if fields passed to component should override defaults
                this.defaultSignUpFields.forEach((f, i) => {
                    const matchKey = this.signUpFields.findIndex(d => {
                        return d.key === f.key;
                    });
                    if (matchKey === -1) {
                        this.signUpFields.push(f);
                    }
                });
            }
            /*
        sort fields based on following rules:
        1. Fields with displayOrder are sorted before those without displayOrder
        2. Fields with conflicting displayOrder are sorted alphabetically by key
        3. Fields without displayOrder are sorted alphabetically by key
      */
            this.signUpFields.sort((a, b) => {
                if (a.displayOrder && b.displayOrder) {
                    if (a.displayOrder < b.displayOrder) {
                        return -1;
                    }
                    else if (a.displayOrder > b.displayOrder) {
                        return 1;
                    }
                    else {
                        if (a.key < b.key) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    }
                }
                else if (!a.displayOrder && b.displayOrder) {
                    return 1;
                }
                else if (a.displayOrder && !b.displayOrder) {
                    return -1;
                }
                else if (!a.displayOrder && !b.displayOrder) {
                    if (a.key < b.key) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }
            });
            this.signUpFields = this.removeHiddenFields();
        }
    }
    onAlertClose() {
        this._setError(null);
    }
    removeHiddenFields() {
        return this.signUpFields.filter(f => {
            return !f.displayOrder || f.displayOrder !== -1;
        });
    }
    validate() {
        const invalids = [];
        this.signUpFields.map(el => {
            if (el.key !== 'phone_number') {
                if (el.required && !this.user[el.key]) {
                    el.invalid = true;
                    invalids.push(this.amplifyService.i18n().get(el.label));
                }
                else {
                    el.invalid = false;
                }
            }
            else {
                if (el.required && (!this.country_code || !this.local_phone_number)) {
                    el.invalid = true;
                    invalids.push(this.amplifyService.i18n().get(el.label));
                }
                else {
                    el.invalid = false;
                }
            }
        });
        return invalids;
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
    getUsernameLabel() {
        return (labelMap[this._usernameAttributes] || this._usernameAttributes);
    }
    onPhoneFieldChanged(event) {
        this.country_code = event.country_code;
        this.local_phone_number = event.local_phone_number;
    }
};
SignUpComponentCore.ɵfac = function SignUpComponentCore_Factory(t) { return new (t || SignUpComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SignUpComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignUpComponentCore, selectors: [["amplify-auth-sign-up-core"]], inputs: { hide: "hide", data: "data", usernameAttributes: "usernameAttributes", authState: "authState", signUpConfig: "signUpConfig" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "sign-up-section", 1, "amplify-form-container"], ["data-test", "sign-up-body-section", 1, "amplify-form-body"], ["data-test", "sign-up-header-section", 1, "amplify-form-header"], ["class", "amplify-form-row", 4, "ngFor", "ngForOf"], [1, "amplify-form-actions"], ["class", "amplify-form-cell-left", 4, "ngIf"], [1, "amplify-form-cell-right"], ["data-test", "sign-up-create-account-button", 1, "amplify-form-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-row"], [4, "ngIf"], [1, "amplify-input-label"], ["name", "field.key", "data-test", "sign-up-non-phone-number-input", 1, "amplify-form-input", 3, "ngClass", "type", "placeholder", "ngModel", "ngModelChange"], ["{{field.key}}", ""], ["class", "amplify-form-extra-details", 4, "ngIf"], [1, "amplify-form-extra-details"], [3, "label", "required", "placeholder", "defaultCountryCode", "phoneFieldChanged"], [1, "amplify-form-cell-left"], [1, "amplify-form-signup"], ["data-test", "sign-up-sign-in-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function SignUpComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SignUpComponentCore_div_0_Template, 12, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.DefaultValueAccessor, ɵngcc1.NgClass, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, PhoneFieldComponentCore]; }, encapsulation: 2 });
SignUpComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], SignUpComponentCore.prototype, "data", null);
__decorate([
    Input()
], SignUpComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], SignUpComponentCore.prototype, "usernameAttributes", null);
__decorate([
    Input()
], SignUpComponentCore.prototype, "authState", null);
__decorate([
    Input()
], SignUpComponentCore.prototype, "signUpConfig", null);
SignUpComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], SignUpComponentCore);

// tslint:disable
const template$9 = `
<div
  class="amplify-authenticator"
  *ngIf="_show"
  data-test="${auth.signUp.section}"
  >
  <div class="amplify-form-body" data-test="${auth.signUp.bodySection}">
    <div class="amplify-form-header" data-test="${auth.signUp.headerSection}">
      {{ this.amplifyService.i18n().get(this.header) }}</div>
    <ion-list lines="none">
      <ion-item lines="none" *ngFor="let field of signUpFields">
        <ion-label class="amplify-input-label"
        position="stacked"
        *ngIf="field.key !== 'phone_number'"
        >
          {{ this.amplifyService.i18n().get(field.label) }}
          <span *ngIf="field.required">*</span>
        </ion-label>
        <ion-input
          [ngClass]="{'amplify-input-invalid ': field.invalid}"
          *ngIf="field.key !== 'phone_number'"
          #{{field.key}}
          type="text"
          class="amplify-form-input"
          type={{field.type}}
          [placeholder]="this.amplifyService.i18n().get(field.label)"
          (keyup)="setProp($event.target)"
          name={{field.key}}
          data-test="${auth.signUp.nonPhoneNumberInput}"
        ></ion-input>
        <ion-content *ngIf="field.key === 'phone_number'" class="amplify-phone-ion-content">
          <amplify-auth-phone-field-ionic
            [label]="field.label"
            [required]="field.required"
            [placeholder]="field.placeholder"
            [defaultCountryCode]="country_code"
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
          ></amplify-auth-phone-field-ionic>
        </ion-content>
      </ion-item>
    </ion-list>
    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button expand="block" color="primary"
          (click)="onSignUp()"
          data-test="${auth.signUp.createAccountButton}"
        >{{ this.amplifyService.i18n().get('Create Account') }}</ion-button>
      </div>
      <div class="amplify-form-row">
        <div class="amplify-form-signup">
          {{ this.amplifyService.i18n().get('Have an account?') }}
          <a class="amplify-form-link" (click)="onSignIn()" data-test="${auth.signUp.signInButton}">
            {{ this.amplifyService.i18n().get('Sign In') }}
          </a>
        </div>
        <div class="amplify-form-signup" *ngIf="!shouldHide('SignUp')">
          {{ this.amplifyService.i18n().get('Have a code?') }}
          <a
            class="amplify-form-link"
            (click)="onConfirmSignUp()"
            data-test="${auth.signUp.confirmButton}"
            >
            {{ this.amplifyService.i18n().get('Confirm') }}
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let SignUpComponentIonic = class SignUpComponentIonic extends SignUpComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
    setProp(target) {
        return (this.user[target.name] = target.value);
    }
};
SignUpComponentIonic.ɵfac = function SignUpComponentIonic_Factory(t) { return new (t || SignUpComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SignUpComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignUpComponentIonic, selectors: [["amplify-auth-sign-up-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-authenticator", "data-test", "sign-up-section", 4, "ngIf"], ["data-test", "sign-up-section", 1, "amplify-authenticator"], ["data-test", "sign-up-body-section", 1, "amplify-form-body"], ["data-test", "sign-up-header-section", 1, "amplify-form-header"], ["lines", "none"], ["lines", "none", 4, "ngFor", "ngForOf"], [1, "amplify-form-actions"], [1, "amplify-form-row"], ["expand", "block", "color", "primary", "data-test", "sign-up-create-account-button", 3, "click"], [1, "amplify-form-signup"], ["data-test", "sign-up-sign-in-button", 1, "amplify-form-link", 3, "click"], ["class", "amplify-form-signup", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], ["class", "amplify-input-label", "position", "stacked", 4, "ngIf"], ["type", "text", "class", "amplify-form-input", "data-test", "sign-up-non-phone-number-input", 3, "ngClass", "type", "placeholder", "name", "keyup", 4, "ngIf"], ["class", "amplify-phone-ion-content", 4, "ngIf"], ["position", "stacked", 1, "amplify-input-label"], [4, "ngIf"], ["type", "text", "data-test", "sign-up-non-phone-number-input", 1, "amplify-form-input", 3, "ngClass", "type", "placeholder", "name", "keyup"], ["{{field.key}}", ""], [1, "amplify-phone-ion-content"], [3, "label", "required", "placeholder", "defaultCountryCode", "phoneFieldChanged"], ["data-test", "sign-up-confirm-button", 1, "amplify-form-link", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function SignUpComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SignUpComponentIonic_div_0_Template, 17, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass, PhoneFieldComponentIonic]; }, encapsulation: 2 });
SignUpComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
SignUpComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], SignUpComponentIonic);

// tslint:disable
let SignUpComponent = class SignUpComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.usernameAttributes = 'username';
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(SignUpComponentIonic, {
                authState: this.authState,
                signUpConfig: this.signUpConfig,
                usernameAttributes: this.usernameAttributes,
                hide: this.hide,
            })
            : new ComponentMount(SignUpComponentCore, {
                authState: this.authState,
                signUpConfig: this.signUpConfig,
                usernameAttributes: this.usernameAttributes,
                hide: this.hide,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
SignUpComponent.ɵfac = function SignUpComponent_Factory(t) { return new (t || SignUpComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
SignUpComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SignUpComponent, selectors: [["amplify-auth-sign-up"]], inputs: { usernameAttributes: "usernameAttributes", hide: "hide", framework: "framework", authState: "authState", signUpConfig: "signUpConfig" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function SignUpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, SignUpComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
SignUpComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], SignUpComponent.prototype, "framework", void 0);
__decorate([
    Input()
], SignUpComponent.prototype, "authState", void 0);
__decorate([
    Input()
], SignUpComponent.prototype, "signUpConfig", void 0);
__decorate([
    Input()
], SignUpComponent.prototype, "usernameAttributes", void 0);
__decorate([
    Input()
], SignUpComponent.prototype, "hide", void 0);
SignUpComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], SignUpComponent);

// tslint:disable
const template$a = `
<div class="amplify-container" *ngIf="_show">
<div class="amplify-form-container" data-test="${auth.requireNewPassword.section}">
  <div class="amplify-form-body" data-test="${auth.requireNewPassword.bodySection}">
  <div class="amplify-form-header" data-test="${auth.requireNewPassword.headerSection}">
    {{ this.amplifyService.i18n().get('You are required to update your password') }}
  </div>
  <div class="amplify-form-row">
    <label class="amplify-input-label" for="password">
      {{ this.amplifyService.i18n().get('Password *') }}
    </label>
    <input #password
      (keyup)="setPassword(password.value)"
      (keyup.enter)="onSubmit()"
      class="amplify-form-input"
      type="password"
      placeholder="{{ this.amplifyService.i18n().get('Password') }}"
      data-test="${auth.requireNewPassword.newPasswordInput}"
    />
    </div>
    <div class="amplify-form-actions">
      <div class="amplify-form-cell-left">
        <a class="amplify-form-link"
          (click)="onSignIn()"
          data-test="${auth.requireNewPassword.backToSignInLink}"
        >{{ this.amplifyService.i18n().get('Back to Sign In') }}</a>
      </div>
      <div class="amplify-form-cell-right">
        <button class="amplify-form-button"
          (click)="onSubmit()"
          data-test="${auth.requireNewPassword.submitButton}"
        >{{ this.amplifyService.i18n().get('Submit') }}</button>
      </div>
    </div>
  </div>
</div>
<div class="amplify-alert" *ngIf="errorMessage">
<div class="amplify-alert-body">
  <span class="amplify-alert-icon">&#9888;</span>
  <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
  <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
</div>
</div>
</div>
`;
let RequireNewPasswordComponentCore = class RequireNewPasswordComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this.hide = [];
        this.logger = this.amplifyService.logger('RequireNewPasswordComponent');
    }
    set authState(authState) {
        this._authState = authState;
        this._show = authState.state === 'requireNewPassword';
    }
    set data(data) {
        this._authState = data.authState;
        this._show = data.authState.state === 'requireNewPassword';
        this.hide = data.hide ? data.hide : this.hide;
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    setPassword(password) {
        this.password = password;
    }
    onSubmit() {
        const { user } = this._authState;
        const { requiredAttributes } = user.challengeParam;
        this.amplifyService
            .auth()
            .completeNewPassword(user, this.password, requiredAttributes)
            .then(() => {
            this.onAlertClose();
            this.amplifyService.setAuthState({ state: 'signIn', user });
        })
            .catch(err => this._setError(err));
    }
    onSignIn() {
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signIn', user: null });
    }
    onAlertClose() {
        this._setError(null);
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
};
RequireNewPasswordComponentCore.ɵfac = function RequireNewPasswordComponentCore_Factory(t) { return new (t || RequireNewPasswordComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
RequireNewPasswordComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RequireNewPasswordComponentCore, selectors: [["amplify-auth-require-new-password-core"]], inputs: { hide: "hide", authState: "authState", data: "data" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "require-new-password-section", 1, "amplify-form-container"], ["data-test", "require-new-password-body-section", 1, "amplify-form-body"], ["data-test", "require-new-password-header-section", 1, "amplify-form-header"], [1, "amplify-form-row"], ["for", "password", 1, "amplify-input-label"], ["type", "password", "data-test", "require-new-password-new-password-input", 1, "amplify-form-input", 3, "placeholder", "keyup", "keyup.enter"], ["password", ""], [1, "amplify-form-actions"], [1, "amplify-form-cell-left"], ["data-test", "require-new-password-back-to-sign-in-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-form-cell-right"], ["data-test", "require-new-password-submit-button", 1, "amplify-form-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function RequireNewPasswordComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RequireNewPasswordComponentCore_div_0_Template, 18, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
RequireNewPasswordComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], RequireNewPasswordComponentCore.prototype, "authState", null);
__decorate([
    Input()
], RequireNewPasswordComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], RequireNewPasswordComponentCore.prototype, "data", null);
RequireNewPasswordComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], RequireNewPasswordComponentCore);

// tslint:disable
const template$b = `
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="${auth.requireNewPassword.section}"
  >
  <div class="amplify-form-body" data-test="${auth.requireNewPassword.bodySection}">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="${auth.requireNewPassword.headerSection}"
      >
      {{ this.amplifyService.i18n().get('Reset your password') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Password') }}
        </ion-label>
        <ion-input
          #password
          type="password"
          class="amplify-form-input"
          (keyup)="setPassword(password.value)"
          (keyup.enter)="onSubmit()"
          data-test="${auth.requireNewPassword.newPasswordInput}"
        ></ion-input>
      </ion-item>

    </ion-list>

    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button
          expand="block"
          (click)="onSignIn()"
          data-test="${auth.requireNewPassword.backToSignInLink}"
        >{{ this.amplifyService.i18n().get('Back to Sign In') }}</ion-button>
      </div>
      <div class="amplify-form-row">
        <ion-button
          expand="block"
          (click)="onSubmit()"
          data-test="${auth.requireNewPassword.submitButton}"
        >Submit</ion-button>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ errorMessage }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let RequireNewPasswordComponentIonic = class RequireNewPasswordComponentIonic extends RequireNewPasswordComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
RequireNewPasswordComponentIonic.ɵfac = function RequireNewPasswordComponentIonic_Factory(t) { return new (t || RequireNewPasswordComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
RequireNewPasswordComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RequireNewPasswordComponentIonic, selectors: [["amplify-auth-require-new-password-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-authenticator amplify-authenticator-ionic", "data-test", "require-new-password-section", 4, "ngIf"], ["data-test", "require-new-password-section", 1, "amplify-authenticator", "amplify-authenticator-ionic"], ["data-test", "require-new-password-body-section", 1, "amplify-form-body"], ["data-test", "require-new-password-header-section", 1, "amplify-form-header", "amplify-form-header-ionic"], ["lines", "none"], ["position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "password", "data-test", "require-new-password-new-password-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["password", ""], [1, "amplify-form-actions"], [1, "amplify-form-row"], ["expand", "block", "data-test", "require-new-password-back-to-sign-in-link", 3, "click"], ["expand", "block", "data-test", "require-new-password-submit-button", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function RequireNewPasswordComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RequireNewPasswordComponentIonic_div_0_Template, 18, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
RequireNewPasswordComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
RequireNewPasswordComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], RequireNewPasswordComponentIonic);

// tslint:disable
let RequireNewPasswordComponent = class RequireNewPasswordComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const requireNewPasswordComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(RequireNewPasswordComponentIonic, {
                authState: this.authState,
                hide: this.hide,
            })
            : new ComponentMount(RequireNewPasswordComponentCore, {
                authState: this.authState,
                hide: this.hide,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(requireNewPasswordComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data =
            requireNewPasswordComponent.data;
    }
};
RequireNewPasswordComponent.ɵfac = function RequireNewPasswordComponent_Factory(t) { return new (t || RequireNewPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
RequireNewPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RequireNewPasswordComponent, selectors: [["amplify-auth-require-new-password"]], inputs: { hide: "hide", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function RequireNewPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, RequireNewPasswordComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
RequireNewPasswordComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], RequireNewPasswordComponent.prototype, "framework", void 0);
__decorate([
    Input()
], RequireNewPasswordComponent.prototype, "authState", void 0);
__decorate([
    Input()
], RequireNewPasswordComponent.prototype, "hide", void 0);
RequireNewPasswordComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], RequireNewPasswordComponent);

// tslint:disable
const template$c = `
<div class="amplify-greeting" *ngIf="signedIn">
    <div class="amplify-greeting-text">{{ greeting }}</div>
    <div class="amplify-greeting-flex-spacer"></div>
    <a class="amplify-form-link amplify-greeting-sign-out"
      (click)="onSignOut()"
      data-test="${auth.greeting.signOutButton}"
    >{{ this.amplifyService.i18n().get('Sign Out') }}</a>
</div>
`;
let GreetingComponentCore = class GreetingComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.logger = this.amplifyService.logger('GreetingComponent');
        this.subscribe();
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    subscribe() {
        this.amplifyService.authStateChange$.subscribe(state => this.setAuthState(state));
    }
    setAuthState(authState) {
        this.authState = authState;
        this.signedIn = authState.state === 'signedIn';
        let username = '';
        if (authState.user) {
            if (this._usernameAttributes === UsernameAttributes.EMAIL) {
                username = authState.user.attributes
                    ? authState.user.attributes.email
                    : authState.user.username;
            }
            else if (this._usernameAttributes === UsernameAttributes.PHONE_NUMBER) {
                username = authState.user.attributes
                    ? authState.user.attributes.phone_number
                    : authState.user.username;
            }
            else {
                username = authState.user.username;
            }
        }
        this.greeting = this.signedIn
            ? this.amplifyService
                .i18n()
                .get('Hello, {{username}}')
                .replace('{{username}}', username)
            : '';
    }
    onSignOut() {
        this.amplifyService.auth().signOut();
    }
};
GreetingComponentCore.ɵfac = function GreetingComponentCore_Factory(t) { return new (t || GreetingComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
GreetingComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GreetingComponentCore, selectors: [["amplify-auth-greetings-core"]], inputs: { usernameAttributes: "usernameAttributes", authState: "authState" }, decls: 1, vars: 1, consts: [["class", "amplify-greeting", 4, "ngIf"], [1, "amplify-greeting"], [1, "amplify-greeting-text"], [1, "amplify-greeting-flex-spacer"], ["data-test", "sign-out-button", 1, "amplify-form-link", "amplify-greeting-sign-out", 3, "click"]], template: function GreetingComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, GreetingComponentCore_div_0_Template, 6, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.signedIn);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
GreetingComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], GreetingComponentCore.prototype, "authState", void 0);
__decorate([
    Input()
], GreetingComponentCore.prototype, "usernameAttributes", null);
GreetingComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], GreetingComponentCore);

// tslint:disable
const template$d = `
<div class="amplify-greeting" *ngIf="signedIn">
    <div class="amplify-greeting-text">{{ greeting }}</div>
    <div class="amplify-greeting-flex-spacer"></div>
    <ion-button
        class="amplify-greeting-sign-out"
        size="small"
        *ngIf="signedIn"
        (click)="onSignOut()"
        data-test="${auth.greeting.signOutButton}"
      >{{ this.amplifyService.i18n().get('Sign Out') }}</ion-button>
</div>
`;
let GreetingComponentIonic = class GreetingComponentIonic extends GreetingComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
GreetingComponentIonic.ɵfac = function GreetingComponentIonic_Factory(t) { return new (t || GreetingComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
GreetingComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GreetingComponentIonic, selectors: [["amplify-auth-greetings-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-greeting", 4, "ngIf"], [1, "amplify-greeting"], [1, "amplify-greeting-text"], [1, "amplify-greeting-flex-spacer"], ["class", "amplify-greeting-sign-out", "size", "small", "data-test", "sign-out-button", 3, "click", 4, "ngIf"], ["size", "small", "data-test", "sign-out-button", 1, "amplify-greeting-sign-out", 3, "click"]], template: function GreetingComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, GreetingComponentIonic_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.signedIn);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
GreetingComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
GreetingComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], GreetingComponentIonic);

// tslint:disable
let GreetingComponent = class GreetingComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.usernameAttributes = 'username';
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(GreetingComponentIonic, {
                authState: this.authState,
                usernameAttributes: this.usernameAttributes,
            })
            : new ComponentMount(GreetingComponentCore, {
                authState: this.authState,
                usernameAttributes: this.usernameAttributes,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
GreetingComponent.ɵfac = function GreetingComponent_Factory(t) { return new (t || GreetingComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
GreetingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GreetingComponent, selectors: [["amplify-auth-greetings"]], inputs: { usernameAttributes: "usernameAttributes", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function GreetingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, GreetingComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
GreetingComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], GreetingComponent.prototype, "framework", void 0);
__decorate([
    Input()
], GreetingComponent.prototype, "authState", void 0);
__decorate([
    Input()
], GreetingComponent.prototype, "usernameAttributes", void 0);
GreetingComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], GreetingComponent);

const template$e = `
<div class="amplify-container" *ngIf="_show">
  <div class="amplify-form-container" data-test="${auth.forgotPassword.section}">
    <div class="amplify-form-body" data-test="${auth.forgotPassword.bodySection}">
    <div class="amplify-form-header" data-test="${auth.forgotPassword.headerSection}">
      {{ this.amplifyService.i18n().get('Reset your password') }}
    </div>
    <div class="amplify-form-text" *ngIf="!code_sent">
      {{ this.amplifyService.i18n().get('You will receive a verification code') }}
    </div>
    <div class="amplify-form-text" *ngIf="code_sent">
      {{ this.amplifyService.i18n().get('Enter the code you received and set a new password') }}
    </div>
    <amplify-auth-username-field-core
      *ngIf="!code_sent"
      [usernameAttributes]="_usernameAttributes"
      (usernameFieldChanged)="onUsernameFieldChanged($event)"
    ></amplify-auth-username-field-core>
      <div class="amplify-form-row" *ngIf="code_sent">
      <label class="amplify-input-label" for="code">
        {{ this.amplifyService.i18n().get('Confirmation Code *') }}
      </label>
      <input #code
        (keyup)="setCode(code.value)"
        class="amplify-form-input"
        type="text"
        autocomplete="off"
        placeholder="{{ this.amplifyService.i18n().get('Enter code') }}"
        data-test="${auth.forgotPassword.codeInput}"
      />
      </div>
      <div class="amplify-form-row" *ngIf="code_sent">
      <label class="amplify-input-label" for="password">
        {{ this.amplifyService.i18n().get('New Password *') }}
      </label>
      <input #password
        (keyup)="setPassword(password.value)"
        (keyup.enter)="onSubmit()"
        class="amplify-form-input"
        type="password"
        autocomplete="off"
        placeholder="{{ this.amplifyService.i18n().get('Password') }}"
        data-test="${auth.forgotPassword.newPasswordInput}"
      />
      </div>
      <div class="amplify-form-actions">
        <div class="amplify-form-cell-right">
          <button class="amplify-form-button"
            *ngIf="!code_sent"
            (click)="onSend()"
            data-test="${auth.forgotPassword.sendCodeButton}"
            >
              {{ this.amplifyService.i18n().get('Submit') }}</button>
          <button class="amplify-form-button"
            *ngIf="code_sent"
            (click)="onSubmit()"
            data-test="${auth.forgotPassword.submitButton}"
            >
              {{ this.amplifyService.i18n().get('Verify') }}</button>
        </div>
        <div class="amplify-form-cell-left">
          <div class="amplify-form-actions-left">
            <a
              *ngIf="code_sent"
              class="amplify-form-link"
              (click)="onSend()"
              data-test="${auth.forgotPassword.resendCodeLink}"
              >
              {{ this.amplifyService.i18n().get('Resend Code') }}
            </a>
            <a
              *ngIf="!code_sent"
              class="amplify-form-link"
              (click)="onSignIn()"
              data-test="${auth.forgotPassword.backToSignInLink}"
              >
              {{ this.amplifyService.i18n().get('Back to Sign in') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
`;
let ForgotPasswordComponentCore = class ForgotPasswordComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.code_sent = false;
        this.country_code = '1';
        this.hide = [];
        this.logger = this.amplifyService.logger('ForgotPasswordComponent');
    }
    set data(data) {
        this._authState = data.authState;
        this._show = data.authState.state === 'forgotPassword';
        this._usernameAttributes = data.usernameAttributes;
        this.hide = data.hide ? data.hide : this.hide;
        this.username =
            data.authState.user && data.authState.user.username
                ? data.authState.user.username
                : '';
    }
    shouldHide(comp) {
        return this.hide.filter(item => item === comp).length > 0;
    }
    set authState(authState) {
        this._authState = authState;
        this._show = authState.state === 'forgotPassword';
        this.email =
            authState.user && authState.user.email ? authState.user.email : '';
        this.country_code =
            authState.user && authState.user.contry_code
                ? authState.user.country_code
                : '1';
        this.local_phone_number =
            authState.user && authState.user.local_phone_number
                ? authState.user.local_phone_number
                : '';
        this.username =
            authState.user && authState.user.username ? authState.user.username : '';
    }
    ngOnInit() {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
    }
    setCode(code) {
        this.code = code;
    }
    setPassword(password) {
        this.password = password;
    }
    getforgotPwUsername() {
        switch (this._usernameAttributes) {
            case UsernameAttributes.EMAIL:
                return this.email;
            case UsernameAttributes.PHONE_NUMBER:
                return composePhoneNumber(this.country_code, this.local_phone_number);
            default:
                return this.username;
        }
    }
    onSend() {
        let forgotPwUsername = this.getforgotPwUsername();
        if (!forgotPwUsername) {
            this.errorMessage = 'Username cannot be empty';
            return;
        }
        this.amplifyService
            .auth()
            .forgotPassword(forgotPwUsername)
            .then(() => {
            this.code_sent = true;
        })
            .catch(err => {
            this._setError(err);
            this.code_sent = false;
        });
    }
    onSubmit() {
        this.amplifyService
            .auth()
            .forgotPasswordSubmit(this.getforgotPwUsername(), this.code, this.password)
            .then(() => {
            const user = { username: this.username };
            this.onAlertClose();
            this.amplifyService.setAuthState({ state: 'signIn', user });
        })
            .catch(err => this._setError(err));
    }
    onSignIn() {
        this.onAlertClose();
        this.amplifyService.setAuthState({ state: 'signIn', user: null });
    }
    onAlertClose() {
        this._setError(null);
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
    getUsernameLabel() {
        return (labelMap[this._usernameAttributes] || this._usernameAttributes);
    }
    onUsernameFieldChanged(event) {
        this.email = event.email || this.email;
        this.username = event.username || this.username;
        this.country_code = event.country_code || this.country_code;
        this.local_phone_number =
            event.local_phone_number || this.local_phone_number;
    }
};
ForgotPasswordComponentCore.ɵfac = function ForgotPasswordComponentCore_Factory(t) { return new (t || ForgotPasswordComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ForgotPasswordComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordComponentCore, selectors: [["amplify-auth-forgot-password-core"]], inputs: { hide: "hide", data: "data", authState: "authState", usernameAttributes: "usernameAttributes" }, decls: 1, vars: 1, consts: [["class", "amplify-container", 4, "ngIf"], [1, "amplify-container"], ["data-test", "forgot-password-section", 1, "amplify-form-container"], ["data-test", "forgot-password-body-section", 1, "amplify-form-body"], ["data-test", "forgot-password-header-section", 1, "amplify-form-header"], ["class", "amplify-form-text", 4, "ngIf"], [3, "usernameAttributes", "usernameFieldChanged", 4, "ngIf"], ["class", "amplify-form-row", 4, "ngIf"], [1, "amplify-form-actions"], [1, "amplify-form-cell-right"], ["class", "amplify-form-button", "data-test", "forgot-password-send-code-button", 3, "click", 4, "ngIf"], ["class", "amplify-form-button", "data-test", "forgot-password-submit-button", 3, "click", 4, "ngIf"], [1, "amplify-form-cell-left"], [1, "amplify-form-actions-left"], ["class", "amplify-form-link", "data-test", "forgot-password-resend-code-link", 3, "click", 4, "ngIf"], ["class", "amplify-form-link", "data-test", "forgot-password-back-to-sign-in-link", 3, "click", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-text"], [3, "usernameAttributes", "usernameFieldChanged"], [1, "amplify-form-row"], ["for", "code", 1, "amplify-input-label"], ["type", "text", "autocomplete", "off", "data-test", "forgot-password-code-input", 1, "amplify-form-input", 3, "placeholder", "keyup"], ["code", ""], ["for", "password", 1, "amplify-input-label"], ["type", "password", "autocomplete", "off", "data-test", "forgot-password-new-password-input", 1, "amplify-form-input", 3, "placeholder", "keyup", "keyup.enter"], ["password", ""], ["data-test", "forgot-password-send-code-button", 1, "amplify-form-button", 3, "click"], ["data-test", "forgot-password-submit-button", 1, "amplify-form-button", 3, "click"], ["data-test", "forgot-password-resend-code-link", 1, "amplify-form-link", 3, "click"], ["data-test", "forgot-password-back-to-sign-in-link", 1, "amplify-form-link", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ForgotPasswordComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ForgotPasswordComponentCore_div_0_Template, 19, 11, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, UsernameFieldComponentCore]; }, encapsulation: 2 });
ForgotPasswordComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], ForgotPasswordComponentCore.prototype, "data", null);
__decorate([
    Input()
], ForgotPasswordComponentCore.prototype, "hide", void 0);
__decorate([
    Input()
], ForgotPasswordComponentCore.prototype, "authState", null);
__decorate([
    Input()
], ForgotPasswordComponentCore.prototype, "usernameAttributes", null);
ForgotPasswordComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], ForgotPasswordComponentCore);

// tslint:disable
const template$f = `
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="${auth.forgotPassword.section}"
  >
  <div class="amplify-form-body" data-test="${auth.forgotPassword.bodySection}">
  <div
    class="amplify-form-header amplify-form-header-ionic"
    data-test="${auth.forgotPassword.headerSection}"
    >
    {{ this.amplifyService.i18n().get('Reset your password') }}
  </div>
  <div class="amplify-form-text" *ngIf="!code_sent">
    {{ this.amplifyService.i18n().get('You will receive a verification code to reset your password') }}
  </div>

  <ion-list>
    <amplify-auth-username-field-ionic
      [usernameAttributes]="_usernameAttributes"
      (usernameFieldChanged)="onUsernameFieldChanged($event)"
    ></amplify-auth-username-field-ionic>
    <ion-item lines="none" *ngIf="code_sent">
      <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
        {{ this.amplifyService.i18n().get('Code *') }}
      </ion-label>
      <ion-input
        #code
        type="text"
        class="amplify-form-input"
        (keyup)="setCode(code.value)"
        data-test="${auth.forgotPassword.codeInput}"
      ></ion-input>
    </ion-item>
    <ion-item lines="none" *ngIf="code_sent">
      <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
        {{ this.amplifyService.i18n().get('Password *') }}
      </ion-label>
      <ion-input
        #password
        type="password"
        class="amplify-form-input"
        (keyup)="setPassword(password.value)"
        (keyup.enter)="onSubmit()"
        data-test="${auth.forgotPassword.newPasswordInput}"
      ></ion-input>
    </ion-item>
  </ion-list>
  <div class="amplify-form-actions">
    <div>
      <ion-button expand="block" color="primary"
        (click)="onSend()"
        *ngIf="!code_sent"
        data-test="${auth.forgotPassword.submitButton}"
      >
        {{ this.amplifyService.i18n().get('Submit') }}</ion-button>
      <ion-button expand="block" color="primary"
      *ngIf="code_sent"
      (click)="onSubmit()"
      >{{ this.amplifyService.i18n().get('Verify') }}</ion-button>
    </div>
    <div class="amplify-form-row">
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Have an account?') }}
        <a class="amplify-form-link" (click)="onSignIn()">
          {{ this.amplifyService.i18n().get('Sign In') }}
        </a>
      </div>
      <div class="amplify-form-signup">
        {{ this.amplifyService.i18n().get('Lost your code?') }}
        <a
          class="amplify-form-link"
          (click)="onSend()"
          data-test="${auth.forgotPassword.resendCodeLink}"
          >
          {{ this.amplifyService.i18n().get('Resend') }}
        </a>
      </div>
    </div>
  </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ this.amplifyService.i18n().get(errorMessage) }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>

</div>
`;
let ForgotPasswordComponentIonic = class ForgotPasswordComponentIonic extends ForgotPasswordComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
    onCodeChange(val) {
        this.country_code = val;
    }
    onNumberChange(val) {
        this.local_phone_number = val;
    }
    setUsername(username) {
        this.username = username;
    }
    setEmail(email) {
        this.email = email;
    }
};
ForgotPasswordComponentIonic.ɵfac = function ForgotPasswordComponentIonic_Factory(t) { return new (t || ForgotPasswordComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ForgotPasswordComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordComponentIonic, selectors: [["amplify-auth-forgot-password-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "amplify-authenticator amplify-authenticator-ionic", "data-test", "forgot-password-section", 4, "ngIf"], ["data-test", "forgot-password-section", 1, "amplify-authenticator", "amplify-authenticator-ionic"], ["data-test", "forgot-password-body-section", 1, "amplify-form-body"], ["data-test", "forgot-password-header-section", 1, "amplify-form-header", "amplify-form-header-ionic"], ["class", "amplify-form-text", 4, "ngIf"], [3, "usernameAttributes", "usernameFieldChanged"], ["lines", "none", 4, "ngIf"], [1, "amplify-form-actions"], ["expand", "block", "color", "primary", "data-test", "forgot-password-submit-button", 3, "click", 4, "ngIf"], ["expand", "block", "color", "primary", 3, "click", 4, "ngIf"], [1, "amplify-form-row"], [1, "amplify-form-signup"], [1, "amplify-form-link", 3, "click"], ["data-test", "forgot-password-resend-code-link", 1, "amplify-form-link", 3, "click"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-form-text"], ["lines", "none"], ["position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "data-test", "forgot-password-code-input", 1, "amplify-form-input", 3, "keyup"], ["code", ""], ["type", "password", "data-test", "forgot-password-new-password-input", 1, "amplify-form-input", 3, "keyup", "keyup.enter"], ["password", ""], ["expand", "block", "color", "primary", "data-test", "forgot-password-submit-button", 3, "click"], ["expand", "block", "color", "primary", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function ForgotPasswordComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ForgotPasswordComponentIonic_div_0_Template, 23, 12, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._show);
    } }, directives: function () { return [ɵngcc1.NgIf, UsernameFieldComponentIonic]; }, encapsulation: 2 });
ForgotPasswordComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
ForgotPasswordComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], ForgotPasswordComponentIonic);

// tslint:disable
let ForgotPasswordComponent = class ForgotPasswordComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.usernameAttributes = 'username';
        this.hide = [];
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const authComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(ForgotPasswordComponentIonic, {
                authState: this.authState,
                hide: this.hide,
                usernameAttributes: this.usernameAttributes,
            })
            : new ComponentMount(ForgotPasswordComponentCore, {
                authState: this.authState,
                hide: this.hide,
                usernameAttributes: this.usernameAttributes,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(authComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = authComponent.data;
    }
};
ForgotPasswordComponent.ɵfac = function ForgotPasswordComponent_Factory(t) { return new (t || ForgotPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
ForgotPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ForgotPasswordComponent, selectors: [["amplify-auth-forgot-password"]], inputs: { usernameAttributes: "usernameAttributes", hide: "hide", framework: "framework", authState: "authState" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function ForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, ForgotPasswordComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
ForgotPasswordComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], ForgotPasswordComponent.prototype, "framework", void 0);
__decorate([
    Input()
], ForgotPasswordComponent.prototype, "authState", void 0);
__decorate([
    Input()
], ForgotPasswordComponent.prototype, "usernameAttributes", void 0);
__decorate([
    Input()
], ForgotPasswordComponent.prototype, "hide", void 0);
ForgotPasswordComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], ForgotPasswordComponent);

// tslint:disable
const template$g = `
<div class="amplify-amplify-form-row amplify-signin-username">
    <div *ngIf="this._usernameAttributes === 'email'">
        <label class="amplify-input-label" for="emailField"> {{ this.amplifyService.i18n().get('Email') }} *</label>
        <input
            #emailField
            class="amplify-form-input"
            type="email"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setEmail($event.target.value)"
            data-test="${auth.genericAttrs.emailInput}"
        />
    </div>
    <div *ngIf="this._usernameAttributes === 'phone_number'">
        <amplify-auth-phone-field-core
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
        ></amplify-auth-phone-field-core>
    </div>
    <div *ngIf="this._usernameAttributes !== 'email' && this._usernameAttributes !== 'phone_number'">
        <label class="amplify-input-label" for="usernameField"> {{ this.amplifyService.i18n().get(getUsernameLabel()) }} *</label>
        <input
            #usernameField
            class="amplify-form-input"
            type="text"
            value="{{this.username}}"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setUsername($event.target.value)"
            data-test="${auth.genericAttrs.usernameInput}"
        />
    </div>
</div>
`;
let UsernameFieldComponentCore = class UsernameFieldComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = UsernameAttributes.USERNAME;
        this._placeholder = '';
        this.usernameFieldChanged = new EventEmitter();
        this.onPhoneFieldChanged = this.onPhoneFieldChanged.bind(this);
    }
    set data(data) {
        this._usernameAttributes = data.usernameAttributes;
        this._placeholder = data.placeholder;
    }
    set usernameAttributes(usernameAttributes) {
        this._usernameAttributes = usernameAttributes;
    }
    set placeholder(placeholder) {
        this._placeholder = placeholder;
    }
    ngOnInit() {
        if (window &&
            window.location &&
            window.location.search &&
            this._usernameAttributes !== 'email' &&
            this._usernameAttributes !== 'phone_number') {
            const searchParams = new URLSearchParams(window.location.search);
            const username = searchParams ? searchParams.get('username') : undefined;
            this.setUsername(username);
            this.username = username;
        }
    }
    ngOnDestroy() { }
    setUsername(username) {
        this.usernameFieldChanged.emit({
            username,
        });
    }
    setEmail(email) {
        this.usernameFieldChanged.emit({
            email,
        });
    }
    getUsernameLabel() {
        return (labelMap[this._usernameAttributes] || this._usernameAttributes);
    }
    getPlaceholder() {
        return this.amplifyService
            .i18n()
            .get(`${this.getUsernameLabel()}` || this._placeholder);
    }
    onPhoneFieldChanged(event) {
        this.usernameFieldChanged.emit(Object.assign({}, event));
    }
};
UsernameFieldComponentCore.ɵfac = function UsernameFieldComponentCore_Factory(t) { return new (t || UsernameFieldComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
UsernameFieldComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UsernameFieldComponentCore, selectors: [["amplify-auth-username-field-core"]], inputs: { data: "data", usernameAttributes: "usernameAttributes", placeholder: "placeholder" }, outputs: { usernameFieldChanged: "usernameFieldChanged" }, decls: 4, vars: 3, consts: [[1, "amplify-amplify-form-row", "amplify-signin-username"], [4, "ngIf"], ["for", "emailField", 1, "amplify-input-label"], ["type", "email", "data-test", "email-input", 1, "amplify-form-input", 3, "placeholder", "keyup"], ["emailField", ""], [3, "phoneFieldChanged"], ["for", "usernameField", 1, "amplify-input-label"], ["type", "text", "data-test", "username-input", 1, "amplify-form-input", 3, "value", "placeholder", "keyup"], ["usernameField", ""]], template: function UsernameFieldComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, UsernameFieldComponentCore_div_1_Template, 5, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, UsernameFieldComponentCore_div_2_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵtemplate(3, UsernameFieldComponentCore_div_3_Template, 5, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes === "email");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes === "phone_number");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes !== "email" && ctx._usernameAttributes !== "phone_number");
    } }, directives: function () { return [ɵngcc1.NgIf, PhoneFieldComponentCore]; }, encapsulation: 2 });
UsernameFieldComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], UsernameFieldComponentCore.prototype, "data", null);
__decorate([
    Input()
], UsernameFieldComponentCore.prototype, "usernameAttributes", null);
__decorate([
    Input()
], UsernameFieldComponentCore.prototype, "placeholder", null);
__decorate([
    Output()
], UsernameFieldComponentCore.prototype, "usernameFieldChanged", void 0);
UsernameFieldComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], UsernameFieldComponentCore);

// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
class country {
}
const countrylist = [
    { countryCode: 'US', value: '1', label: 'USA (+1)' },
    { countryCode: 'GB', value: '44', label: 'UK (+44)' },
    { countryCode: 'DZ', value: '213', label: 'Algeria (+213)' },
    { countryCode: 'AD', value: '376', label: 'Andorra (+376)' },
    { countryCode: 'AO', value: '244', label: 'Angola (+244)' },
    { countryCode: 'AI', value: '1264', label: 'Anguilla (+1264)' },
    { countryCode: 'AG', value: '1268', label: 'Antigua & Barbuda (+1268)' },
    { countryCode: 'AR', value: '54', label: 'Argentina (+54)' },
    { countryCode: 'AM', value: '374', label: 'Armenia (+374)' },
    { countryCode: 'AW', value: '297', label: 'Aruba (+297)' },
    { countryCode: 'AU', value: '61', label: 'Australia (+61)' },
    { countryCode: 'AT', value: '43', label: 'Austria (+43)' },
    { countryCode: 'AZ', value: '994', label: 'Azerbaijan (+994)' },
    { countryCode: 'BS', value: '1242', label: 'Bahamas (+1242)' },
    { countryCode: 'BH', value: '973', label: 'Bahrain (+973)' },
    { countryCode: 'BD', value: '880', label: 'Bangladesh (+880)' },
    { countryCode: 'BB', value: '1246', label: 'Barbados (+1246)' },
    { countryCode: 'BY', value: '375', label: 'Belarus (+375)' },
    { countryCode: 'BE', value: '32', label: 'Belgium (+32)' },
    { countryCode: 'BZ', value: '501', label: 'Belize (+501)' },
    { countryCode: 'BJ', value: '229', label: 'Benin (+229)' },
    { countryCode: 'BM', value: '1441', label: 'Bermuda (+1441)' },
    { countryCode: 'BT', value: '975', label: 'Bhutan (+975)' },
    { countryCode: 'BO', value: '591', label: 'Bolivia (+591)' },
    { countryCode: 'BA', value: '387', label: 'Bosnia Herzegovina (+387)' },
    { countryCode: 'BW', value: '267', label: 'Botswana (+267)' },
    { countryCode: 'BR', value: '55', label: 'Brazil (+55)' },
    { countryCode: 'BN', value: '673', label: 'Brunei (+673)' },
    { countryCode: 'BG', value: '359', label: 'Bulgaria (+359)' },
    { countryCode: 'BF', value: '226', label: 'Burkina Faso (+226)' },
    { countryCode: 'BI', value: '257', label: 'Burundi (+257)' },
    { countryCode: 'KH', value: '855', label: 'Cambodia (+855)' },
    { countryCode: 'CM', value: '237', label: 'Cameroon (+237)' },
    { countryCode: 'CA', value: '1', label: 'Canada (+1)' },
    { countryCode: 'CV', value: '238', label: 'Cape Verde Islands (+238)' },
    { countryCode: 'KY', value: '1345', label: 'Cayman Islands (+1345)' },
    { countryCode: 'CF', value: '236', label: 'Central African Republic (+236)' },
    { countryCode: 'CL', value: '56', label: 'Chile (+56)' },
    { countryCode: 'CN', value: '86', label: 'China (+86)' },
    { countryCode: 'CO', value: '57', label: 'Colombia (+57)' },
    { countryCode: 'KM', value: '269', label: 'Comoros (+269)' },
    { countryCode: 'CG', value: '242', label: 'Congo (+242)' },
    { countryCode: 'CK', value: '682', label: 'Cook Islands (+682)' },
    { countryCode: 'CR', value: '506', label: 'Costa Rica (+506)' },
    { countryCode: 'HR', value: '385', label: 'Croatia (+385)' },
    { countryCode: 'CU', value: '53', label: 'Cuba (+53)' },
    { countryCode: 'CW', value: '599', label: 'Curacao (+599)' },
    { countryCode: 'CY', value: '90392', label: 'Cyprus North (+90392)' },
    { countryCode: 'CY', value: '357', label: 'Cyprus South (+357)' },
    { countryCode: 'CZ', value: '420', label: 'Czech Republic (+420)' },
    { countryCode: 'DK', value: '45', label: 'Denmark (+45)' },
    { countryCode: 'DJ', value: '253', label: 'Djibouti (+253)' },
    { countryCode: 'DM', value: '1809', label: 'Dominica (+1809)' },
    { countryCode: 'DO', value: '1809', label: 'Dominican Republic (+1809)' },
    { countryCode: 'EC', value: '593', label: 'Ecuador (+593)' },
    { countryCode: 'EG', value: '20', label: 'Egypt (+20)' },
    { countryCode: 'SV', value: '503', label: 'El Salvador (+503)' },
    { countryCode: 'GQ', value: '240', label: 'Equatorial Guinea (+240)' },
    { countryCode: 'ER', value: '291', label: 'Eritrea (+291)' },
    { countryCode: 'EE', value: '372', label: 'Estonia (+372)' },
    { countryCode: 'ET', value: '251', label: 'Ethiopia (+251)' },
    { countryCode: 'FK', value: '500', label: 'Falkland Islands (+500)' },
    { countryCode: 'FO', value: '298', label: 'Faroe Islands (+298)' },
    { countryCode: 'FJ', value: '679', label: 'Fiji (+679)' },
    { countryCode: 'FI', value: '358', label: 'Finland (+358)' },
    { countryCode: 'FR', value: '33', label: 'France (+33)' },
    { countryCode: 'GF', value: '594', label: 'French Guiana (+594)' },
    { countryCode: 'PF', value: '689', label: 'French Polynesia (+689)' },
    { countryCode: 'GA', value: '241', label: 'Gabon (+241)' },
    { countryCode: 'GM', value: '220', label: 'Gambia (+220)' },
    { countryCode: 'GE', value: '7880', label: 'Georgia (+7880)' },
    { countryCode: 'DE', value: '49', label: 'Germany (+49)' },
    { countryCode: 'GH', value: '233', label: 'Ghana (+233)' },
    { countryCode: 'GI', value: '350', label: 'Gibraltar (+350)' },
    { countryCode: 'GR', value: '30', label: 'Greece (+30)' },
    { countryCode: 'GL', value: '299', label: 'Greenland (+299)' },
    { countryCode: 'GD', value: '1473', label: 'Grenada (+1473)' },
    { countryCode: 'GP', value: '590', label: 'Guadeloupe (+590)' },
    { countryCode: 'GU', value: '671', label: 'Guam (+671)' },
    { countryCode: 'GT', value: '502', label: 'Guatemala (+502)' },
    { countryCode: 'GN', value: '224', label: 'Guinea (+224)' },
    { countryCode: 'GW', value: '245', label: 'Guinea - Bissau (+245)' },
    { countryCode: 'GY', value: '592', label: 'Guyana (+592)' },
    { countryCode: 'HT', value: '509', label: 'Haiti (+509)' },
    { countryCode: 'HN', value: '504', label: 'Honduras (+504)' },
    { countryCode: 'HK', value: '852', label: 'Hong Kong (+852)' },
    { countryCode: 'HU', value: '36', label: 'Hungary (+36)' },
    { countryCode: 'IS', value: '354', label: 'Iceland (+354)' },
    { countryCode: 'IN', value: '91', label: 'India (+91)' },
    { countryCode: 'ID', value: '62', label: 'Indonesia (+62)' },
    { countryCode: 'IR', value: '98', label: 'Iran (+98)' },
    { countryCode: 'IQ', value: '964', label: 'Iraq (+964)' },
    { countryCode: 'IE', value: '353', label: 'Ireland (+353)' },
    { countryCode: 'IL', value: '972', label: 'Israel (+972)' },
    { countryCode: 'IT', value: '39', label: 'Italy (+39)' },
    { countryCode: 'JM', value: '1876', label: 'Jamaica (+1876)' },
    { countryCode: 'JP', value: '81', label: 'Japan (+81)' },
    { countryCode: 'JO', value: '962', label: 'Jordan (+962)' },
    { countryCode: 'KZ', value: '7', label: 'Kazakhstan (+7)' },
    { countryCode: 'KE', value: '254', label: 'Kenya (+254)' },
    { countryCode: 'KI', value: '686', label: 'Kiribati (+686)' },
    { countryCode: 'KP', value: '850', label: 'Korea North (+850)' },
    { countryCode: 'KR', value: '82', label: 'Korea South (+82)' },
    { countryCode: 'KW', value: '965', label: 'Kuwait (+965)' },
    { countryCode: 'KG', value: '996', label: 'Kyrgyzstan (+996)' },
    { countryCode: 'LA', value: '856', label: 'Laos (+856)' },
    { countryCode: 'LV', value: '371', label: 'Latvia (+371)' },
    { countryCode: 'LB', value: '961', label: 'Lebanon (+961)' },
    { countryCode: 'LS', value: '266', label: 'Lesotho (+266)' },
    { countryCode: 'LR', value: '231', label: 'Liberia (+231)' },
    { countryCode: 'LY', value: '218', label: 'Libya (+218)' },
    { countryCode: 'LI', value: '417', label: 'Liechtenstein (+417)' },
    { countryCode: 'LT', value: '370', label: 'Lithuania (+370)' },
    { countryCode: 'LU', value: '352', label: 'Luxembourg (+352)' },
    { countryCode: 'MO', value: '853', label: 'Macao (+853)' },
    { countryCode: 'MK', value: '389', label: 'Macedonia (+389)' },
    { countryCode: 'MG', value: '261', label: 'Madagascar (+261)' },
    { countryCode: 'MW', value: '265', label: 'Malawi (+265)' },
    { countryCode: 'MY', value: '60', label: 'Malaysia (+60)' },
    { countryCode: 'MV', value: '960', label: 'Maldives (+960)' },
    { countryCode: 'ML', value: '223', label: 'Mali (+223)' },
    { countryCode: 'MT', value: '356', label: 'Malta (+356)' },
    { countryCode: 'MH', value: '692', label: 'Marshall Islands (+692)' },
    { countryCode: 'MQ', value: '596', label: 'Martinique (+596)' },
    { countryCode: 'MR', value: '222', label: 'Mauritania (+222)' },
    { countryCode: 'YT', value: '269', label: 'Mayotte (+269)' },
    { countryCode: 'MX', value: '52', label: 'Mexico (+52)' },
    { countryCode: 'FM', value: '691', label: 'Micronesia (+691)' },
    { countryCode: 'MD', value: '373', label: 'Moldova (+373)' },
    { countryCode: 'MC', value: '377', label: 'Monaco (+377)' },
    { countryCode: 'MN', value: '976', label: 'Mongolia (+976)' },
    { countryCode: 'MS', value: '1664', label: 'Montserrat (+1664)' },
    { countryCode: 'MA', value: '212', label: 'Morocco (+212)' },
    { countryCode: 'MZ', value: '258', label: 'Mozambique (+258)' },
    { countryCode: 'MN', value: '95', label: 'Myanmar (+95)' },
    { countryCode: 'NA', value: '264', label: 'Namibia (+264)' },
    { countryCode: 'NR', value: '674', label: 'Nauru (+674)' },
    { countryCode: 'NP', value: '977', label: 'Nepal (+977)' },
    { countryCode: 'NL', value: '31', label: 'Netherlands (+31)' },
    { countryCode: 'NC', value: '687', label: 'New Caledonia (+687)' },
    { countryCode: 'NZ', value: '64', label: 'New Zealand (+64)' },
    { countryCode: 'NI', value: '505', label: 'Nicaragua (+505)' },
    { countryCode: 'NE', value: '227', label: 'Niger (+227)' },
    { countryCode: 'NG', value: '234', label: 'Nigeria (+234)' },
    { countryCode: 'NU', value: '683', label: 'Niue (+683)' },
    { countryCode: 'NF', value: '672', label: 'Norfolk Islands (+672)' },
    { countryCode: 'NP', value: '670', label: 'Northern Marianas (+670)' },
    { countryCode: 'NO', value: '47', label: 'Norway (+47)' },
    { countryCode: 'OM', value: '968', label: 'Oman (+968)' },
    { countryCode: 'PW', value: '680', label: 'Palau (+680)' },
    { countryCode: 'PA', value: '507', label: 'Panama (+507)' },
    { countryCode: 'PG', value: '675', label: 'Papua New Guinea (+675)' },
    { countryCode: 'PY', value: '595', label: 'Paraguay (+595)' },
    { countryCode: 'PE', value: '51', label: 'Peru (+51)' },
    { countryCode: 'PH', value: '63', label: 'Philippines (+63)' },
    { countryCode: 'PL', value: '48', label: 'Poland (+48)' },
    { countryCode: 'PT', value: '351', label: 'Portugal (+351)' },
    { countryCode: 'PR', value: '1787', label: 'Puerto Rico (+1787)' },
    { countryCode: 'QA', value: '974', label: 'Qatar (+974)' },
    { countryCode: 'RE', value: '262', label: 'Reunion (+262)' },
    { countryCode: 'RO', value: '40', label: 'Romania (+40)' },
    { countryCode: 'RU', value: '7', label: 'Russia (+7)' },
    { countryCode: 'RW', value: '250', label: 'Rwanda (+250)' },
    { countryCode: 'SM', value: '378', label: 'San Marino (+378)' },
    { countryCode: 'ST', value: '239', label: 'Sao Tome & Principe (+239)' },
    { countryCode: 'SA', value: '966', label: 'Saudi Arabia (+966)' },
    { countryCode: 'SN', value: '221', label: 'Senegal (+221)' },
    { countryCode: 'CS', value: '381', label: 'Serbia (+381)' },
    { countryCode: 'SC', value: '248', label: 'Seychelles (+248)' },
    { countryCode: 'SL', value: '232', label: 'Sierra Leone (+232)' },
    { countryCode: 'SX', value: '1', label: 'Sint Maarten (+1)' },
    { countryCode: 'SG', value: '65', label: 'Singapore (+65)' },
    { countryCode: 'SK', value: '421', label: 'Slovak Republic (+421)' },
    { countryCode: 'SI', value: '386', label: 'Slovenia (+386)' },
    { countryCode: 'SB', value: '677', label: 'Solomon Islands (+677)' },
    { countryCode: 'SO', value: '252', label: 'Somalia (+252)' },
    { countryCode: 'ZA', value: '27', label: 'South Africa (+27)' },
    { countryCode: 'ES', value: '34', label: 'Spain (+34)' },
    { countryCode: 'LK', value: '94', label: 'Sri Lanka (+94)' },
    { countryCode: 'SH', value: '290', label: 'St. Helena (+290)' },
    { countryCode: 'KN', value: '1869', label: 'St. Kitts (+1869)' },
    { countryCode: 'SC', value: '1758', label: 'St. Lucia (+1758)' },
    { countryCode: 'SD', value: '249', label: 'Sudan (+249)' },
    { countryCode: 'SR', value: '597', label: 'Suriname (+597)' },
    { countryCode: 'SZ', value: '268', label: 'Swaziland (+268)' },
    { countryCode: 'SE', value: '46', label: 'Sweden (+46)' },
    { countryCode: 'CH', value: '41', label: 'Switzerland (+41)' },
    { countryCode: 'SI', value: '963', label: 'Syria (+963)' },
    { countryCode: 'TW', value: '886', label: 'Taiwan (+886)' },
    { countryCode: 'TJ', value: '7', label: 'Tajikstan (+7)' },
    { countryCode: 'TH', value: '66', label: 'Thailand (+66)' },
    { countryCode: 'TG', value: '228', label: 'Togo (+228)' },
    { countryCode: 'TO', value: '676', label: 'Tonga (+676)' },
    { countryCode: 'TT', value: '1868', label: 'Trinidad & Tobago (+1868)' },
    { countryCode: 'TN', value: '216', label: 'Tunisia (+216)' },
    { countryCode: 'TR', value: '90', label: 'Turkey (+90)' },
    { countryCode: 'TM', value: '7', label: 'Turkmenistan (+7)' },
    { countryCode: 'TM', value: '993', label: 'Turkmenistan (+993)' },
    { countryCode: 'TC', value: '1649', label: 'Turks & Caicos Islands (+1649)' },
    { countryCode: 'TV', value: '688', label: 'Tuvalu (+688)' },
    { countryCode: 'UG', value: '256', label: 'Uganda (+256)' },
    { countryCode: 'UA', value: '380', label: 'Ukraine (+380)' },
    { countryCode: 'AE', value: '971', label: 'United Arab Emirates (+971)' },
    { countryCode: 'UY', value: '598', label: 'Uruguay (+598)' },
    { countryCode: 'UZ', value: '7', label: 'Uzbekistan (+7)' },
    { countryCode: 'VU', value: '678', label: 'Vanuatu (+678)' },
    { countryCode: 'VA', value: '379', label: 'Vatican City (+379)' },
    { countryCode: 'VE', value: '58', label: 'Venezuela (+58)' },
    { countryCode: 'VN', value: '84', label: 'Vietnam (+84)' },
    { countryCode: 'VG', value: '84', label: 'Virgin Islands - British (+1284)' },
    { countryCode: 'VI', value: '84', label: 'Virgin Islands - US (+1340)' },
    { countryCode: 'WF', value: '681', label: 'Wallis and Futuna (+681)' },
    { countryCode: 'YE', value: '969', label: 'Yemen (North) (+969)' },
    { countryCode: 'YE', value: '967', label: 'Yemen (South) (+967)' },
    { countryCode: 'ZM', value: '260', label: 'Zambia (+260)' },
    { countryCode: 'ZW', value: '263', label: 'Zimbabwe (+263)' },
];

// tslint:disable
const template$h = `
<div>
    <label class="amplify-input-label" for="localPhoneNumberField">
        {{ this.amplifyService.i18n().get(this._label) }}
        <span *ngIf="_required">*</span>
    </label>
    <div class="amplify-input-group">
        <div class="amplify-input-group-item">
            <select 
            #countryCodeField
            name="countryCode"
            class="amplify-select-phone-country"
            [(ngModel)]="_country_code"
            (change)="setCountryCode($event.target.value)"
            data-test="${auth.genericAttrs.dialCodeSelect}"
            >
            <option *ngFor="let country of _countries"
                value={{country.value}}>
                {{country.label}}
            </option>
            </select>
        </div>
        <div class="amplify-input-group-item">
            <input
                #localPhoneNumberField
                class="amplify-form-input"
                placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
                name="local_phone_number"
                type="tel"
                (keyup)="setLocalPhoneNumber($event.target.value)"
                data-test="${auth.genericAttrs.phoneNumberInput}"
            />
        </div>
    </div>
</div>
`;
let PhoneFieldComponentCore = class PhoneFieldComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._placeholder = '';
        this._label = 'Phone Number';
        this._required = true;
        this._country_code = '1';
        this._local_phone_number = '';
        this.phoneFieldChanged = new EventEmitter();
        this._countries = countrylist;
    }
    set data(data) {
        this._placeholder = data.placeholder || this._placeholder;
        this._label = data.label || this._label;
        this._country_code = data.defaultCountryCode || this._country_code;
        this._required =
            data.required === undefined ? this._required : data.required;
    }
    set placeholder(placeholder) {
        this._placeholder = placeholder;
    }
    set label(label) {
        this._label = label;
    }
    set required(required) {
        this._required = required;
    }
    set defaultCountryCode(defaultCountryCode) {
        this._country_code = defaultCountryCode;
    }
    ngOnInit() { }
    ngOnDestroy() { }
    setCountryCode(country_code) {
        this._country_code = country_code;
        this.phoneFieldChanged.emit({
            country_code: this._country_code,
            local_phone_number: this._local_phone_number,
        });
    }
    setLocalPhoneNumber(local_phone_number) {
        this._local_phone_number = local_phone_number;
        this.phoneFieldChanged.emit({
            country_code: this._country_code,
            local_phone_number: this._local_phone_number,
        });
    }
    getPlaceholder() {
        return this.amplifyService
            .i18n()
            .get(`Enter your phone number` || this._placeholder);
    }
};
PhoneFieldComponentCore.ɵfac = function PhoneFieldComponentCore_Factory(t) { return new (t || PhoneFieldComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
PhoneFieldComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhoneFieldComponentCore, selectors: [["amplify-auth-phone-field-core"]], inputs: { data: "data", placeholder: "placeholder", label: "label", required: "required", defaultCountryCode: "defaultCountryCode" }, outputs: { phoneFieldChanged: "phoneFieldChanged" }, decls: 12, vars: 5, consts: [["for", "localPhoneNumberField", 1, "amplify-input-label"], [4, "ngIf"], [1, "amplify-input-group"], [1, "amplify-input-group-item"], ["name", "countryCode", "data-test", "dial-code-select", 1, "amplify-select-phone-country", 3, "ngModel", "ngModelChange", "change"], ["countryCodeField", ""], [3, "value", 4, "ngFor", "ngForOf"], ["name", "local_phone_number", "type", "tel", "data-test", "phone-number-input", 1, "amplify-form-input", 3, "placeholder", "keyup"], ["localPhoneNumberField", ""], [3, "value"]], template: function PhoneFieldComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "label", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, PhoneFieldComponentCore_span_3_Template, 2, 0, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "select", 4, 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function PhoneFieldComponentCore_Template_select_ngModelChange_6_listener($event) { return ctx._country_code = $event; })("change", function PhoneFieldComponentCore_Template_select_change_6_listener($event) { return ctx.setCountryCode($event.target.value); });
        ɵngcc0.ɵɵtemplate(8, PhoneFieldComponentCore_option_8_Template, 2, 2, "option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 3);
        ɵngcc0.ɵɵelementStart(10, "input", 7, 8);
        ɵngcc0.ɵɵlistener("keyup", function PhoneFieldComponentCore_Template_input_keyup_10_listener($event) { return ctx.setLocalPhoneNumber($event.target.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.amplifyService.i18n().get(ctx._label), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._required);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx._country_code);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._countries);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.amplifyService.i18n().get(ctx.getPlaceholder()));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.SelectControlValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc1.NgForOf, ɵngcc2.NgSelectOption, ɵngcc2.ɵangular_packages_forms_forms_x], encapsulation: 2 });
PhoneFieldComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], PhoneFieldComponentCore.prototype, "data", null);
__decorate([
    Input()
], PhoneFieldComponentCore.prototype, "placeholder", null);
__decorate([
    Input()
], PhoneFieldComponentCore.prototype, "label", null);
__decorate([
    Input()
], PhoneFieldComponentCore.prototype, "required", null);
__decorate([
    Input()
], PhoneFieldComponentCore.prototype, "defaultCountryCode", null);
__decorate([
    Output()
], PhoneFieldComponentCore.prototype, "phoneFieldChanged", void 0);
PhoneFieldComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], PhoneFieldComponentCore);

// tslint:disable
const template$i = `
<div class="amplify-album">
  <div class="amplify-album-container">
    <amplify-s3-image-core
      class="amplify-image-container"
      *ngFor="let item of list"
      path="{{item.path}}"
      [options]="_options"
      (selected)="onImageSelected($event)"
    ></amplify-s3-image-core>
  </div>
</div>
`;
let S3AlbumComponentCore = class S3AlbumComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._options = {};
        this.selected = new EventEmitter();
        this.logger = this.amplifyService.logger('S3AlbumComponent');
    }
    ngOnInit() {
        if (!this.amplifyService.storage()) {
            throw new Error('Storage module not registered on AmplifyService provider');
        }
        this.getList(this._path, this._options);
    }
    onImageSelected(event) {
        this.selected.emit(event);
    }
    set data(data) {
        if (!data.path) {
            return;
        }
        this._path = data.path;
        this._options = data.options;
    }
    set path(path) {
        this._path = path;
    }
    set options(options) {
        this._options = options;
    }
    getList(path, options) {
        if (!path) {
            return;
        }
        this.amplifyService
            .storage()
            .list(path, options)
            .then(data => {
            this.list = data.map(item => {
                return { path: item.key };
            });
        })
            .catch(e => console.error(e));
    }
};
S3AlbumComponentCore.ɵfac = function S3AlbumComponentCore_Factory(t) { return new (t || S3AlbumComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
S3AlbumComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3AlbumComponentCore, selectors: [["amplify-s3-album-core"]], inputs: { data: "data", path: "path", options: "options" }, outputs: { selected: "selected" }, decls: 3, vars: 1, consts: [[1, "amplify-album"], [1, "amplify-album-container"], ["class", "amplify-image-container", 3, "path", "options", "selected", 4, "ngFor", "ngForOf"], [1, "amplify-image-container", 3, "path", "options", "selected"]], template: function S3AlbumComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, S3AlbumComponentCore_amplify_s3_image_core_2_Template, 1, 2, "amplify-s3-image-core", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: function () { return [ɵngcc1.NgForOf, S3ImageComponentCore]; }, encapsulation: 2 });
S3AlbumComponentCore.ctorParameters = () => [
    { type: AmplifyService }
];
__decorate([
    Output()
], S3AlbumComponentCore.prototype, "selected", void 0);
__decorate([
    Input()
], S3AlbumComponentCore.prototype, "data", null);
__decorate([
    Input()
], S3AlbumComponentCore.prototype, "path", null);
__decorate([
    Input()
], S3AlbumComponentCore.prototype, "options", null);

// tslint:disable
const template$j = `
<div class="amplify-album">
  <div class="amplify-album-container">
    <amplify-s3-image-core
      class="amplify-image-container"
      *ngFor="let item of list"
      path="{{item.path}}"
      (selected)="onImageSelected($event)"
    ></amplify-s3-image-core>
  </div>
</div>
`;
let S3AlbumComponentIonic = class S3AlbumComponentIonic extends S3AlbumComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
S3AlbumComponentIonic.ɵfac = function S3AlbumComponentIonic_Factory(t) { return new (t || S3AlbumComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
S3AlbumComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3AlbumComponentIonic, selectors: [["amplify-s3-album-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [[1, "amplify-album"], [1, "amplify-album-container"], ["class", "amplify-image-container", 3, "path", "selected", 4, "ngFor", "ngForOf"], [1, "amplify-image-container", 3, "path", "selected"]], template: function S3AlbumComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, S3AlbumComponentIonic_amplify_s3_image_core_2_Template, 1, 1, "amplify-s3-image-core", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: [ɵngcc1.NgForOf], encapsulation: 2 });
S3AlbumComponentIonic.ctorParameters = () => [
    { type: AmplifyService }
];

let S3AlbumComponent = class S3AlbumComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.selected = new EventEmitter();
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const albumComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(S3AlbumComponentIonic, {
                path: this.path,
                options: this.options,
            })
            : new ComponentMount(S3AlbumComponentCore, {
                path: this.path,
                options: this.options,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(albumComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = albumComponent.data;
        componentRef.instance.selected.subscribe(e => {
            this.selected.emit(e);
        });
    }
};
S3AlbumComponent.ɵfac = function S3AlbumComponent_Factory(t) { return new (t || S3AlbumComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
S3AlbumComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3AlbumComponent, selectors: [["amplify-s3-album"]], inputs: { framework: "framework", path: "path", options: "options" }, outputs: { selected: "selected" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function S3AlbumComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, S3AlbumComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
S3AlbumComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], S3AlbumComponent.prototype, "framework", void 0);
__decorate([
    Input()
], S3AlbumComponent.prototype, "path", void 0);
__decorate([
    Input()
], S3AlbumComponent.prototype, "options", void 0);
__decorate([
    Output()
], S3AlbumComponent.prototype, "selected", void 0);
S3AlbumComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], S3AlbumComponent);

// tslint:disable
const template$k = `
  <img
    class="amplify-image"
    (click)="onImageClicked()"
    src="{{url}}"
  />
`;
let S3ImageComponentCore = class S3ImageComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this._options = {};
        this.selected = new EventEmitter();
        this.logger = this.amplifyService.logger('S3ImageComponent');
    }
    set data(data) {
        if (!data.path) {
            return;
        }
        this._path = data.path;
        this._options = data.options;
    }
    set path(path) {
        this._path = path;
    }
    set options(options) {
        this._options = options;
    }
    ngOnInit() {
        if (!this._path) {
            return;
        }
        if (!this.amplifyService.storage()) {
            throw new Error('Storage module not registered on AmplifyService provider');
        }
        this.getImage(this._path, this._options);
    }
    onImageClicked() {
        this.selected.emit(this.url);
    }
    getImage(path, options) {
        this.amplifyService
            .storage()
            .get(path, options)
            .then(url => (this.url = url))
            .catch(e => console.error(e));
    }
};
S3ImageComponentCore.ɵfac = function S3ImageComponentCore_Factory(t) { return new (t || S3ImageComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
S3ImageComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3ImageComponentCore, selectors: [["amplify-s3-image-core"]], inputs: { data: "data", path: "path", options: "options" }, outputs: { selected: "selected" }, decls: 1, vars: 1, consts: [[1, "amplify-image", 3, "src", "click"]], template: function S3ImageComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "img", 0);
        ɵngcc0.ɵɵlistener("click", function S3ImageComponentCore_Template_img_click_0_listener() { return ctx.onImageClicked(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.url, ɵngcc0.ɵɵsanitizeUrl);
    } }, encapsulation: 2 });
S3ImageComponentCore.ctorParameters = () => [
    { type: AmplifyService }
];
__decorate([
    Output()
], S3ImageComponentCore.prototype, "selected", void 0);
__decorate([
    Input()
], S3ImageComponentCore.prototype, "data", null);
__decorate([
    Input()
], S3ImageComponentCore.prototype, "path", null);
__decorate([
    Input()
], S3ImageComponentCore.prototype, "options", null);

// tslint:disable
const template$l = `
  <img
    class="amplify-image"
    (click)="onImageClicked()"
    src="{{url}}"
  />
`;
let S3ImageComponentIonic = class S3ImageComponentIonic extends S3ImageComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
S3ImageComponentIonic.ɵfac = function S3ImageComponentIonic_Factory(t) { return new (t || S3ImageComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
S3ImageComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3ImageComponentIonic, selectors: [["amplify-s3-image-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[1, "amplify-image", 3, "src", "click"]], template: function S3ImageComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "img", 0);
        ɵngcc0.ɵɵlistener("click", function S3ImageComponentIonic_Template_img_click_0_listener() { return ctx.onImageClicked(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.url, ɵngcc0.ɵɵsanitizeUrl);
    } }, encapsulation: 2 });
S3ImageComponentIonic.ctorParameters = () => [
    { type: AmplifyService }
];

// tslint:disable
let S3ImageComponent = class S3ImageComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.selected = new EventEmitter();
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const imageComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(S3ImageComponentIonic, {
                path: this.path,
                options: this.options,
            })
            : new ComponentMount(S3ImageComponentCore, {
                path: this.path,
                options: this.options,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(imageComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = imageComponent.data;
        componentRef.instance.selected.subscribe(e => {
            this.selected.emit(e);
        });
    }
};
S3ImageComponent.ɵfac = function S3ImageComponent_Factory(t) { return new (t || S3ImageComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
S3ImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: S3ImageComponent, selectors: [["amplify-s3-image"]], inputs: { framework: "framework", path: "path", options: "options" }, outputs: { selected: "selected" }, decls: 2, vars: 0, consts: [["component-host", ""]], template: function S3ImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, S3ImageComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
S3ImageComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], S3ImageComponent.prototype, "framework", void 0);
__decorate([
    Input()
], S3ImageComponent.prototype, "path", void 0);
__decorate([
    Input()
], S3ImageComponent.prototype, "options", void 0);
__decorate([
    Output()
], S3ImageComponent.prototype, "selected", void 0);
S3ImageComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], S3ImageComponent);

// tslint:disable
const template$m = `
<div class="amplify-photo-picker">
<div class="amplify-photo-picker-container">
  <div class="amplify-form-header">Select Photos</div>
  <div class="amplify-photo-picker-upload" *ngIf="!hasPhoto"></div>
  <div class="amplify-photo-picker-preview">
    <img
      class="amplify-photo-picker-preview"
      src="{{photoUrl}}"
      *ngIf="hasPhoto"
      (error)="onPhotoError()"
    />
  </div>
  <div class="amplify-upload-input">
    <input type="file" 
      accept="image/*"
      (change)="pick($event)"/>
      <button 
        *ngIf="hasPhoto" 
        class="amplify-form-button amplify-upload-button" 
        (click)="uploadFile()">
        Upload Photo
      </button>
  </div>
</div>
<div class="amplify-alert" *ngIf="errorMessage">
  <div class="amplify-alert-body">
    <span class="amplify-alert-icon">&#9888;</span>
    <div class="amplify-alert-message">{{ errorMessage }}</div>
    <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
  </div>
</div>
</div>
`;
let PhotoPickerComponentCore = class PhotoPickerComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this.hasPhoto = false;
        this.uploading = false;
        this.s3ImageFile = null;
        this.s3ImagePath = '';
        this._storageOptions = {};
        this.picked = new EventEmitter();
        this.loaded = new EventEmitter();
        this.uploaded = new EventEmitter();
        this.logger = this.amplifyService.logger('PhotoPickerComponent');
    }
    set url(url) {
        this.photoUrl = url;
        this.hasPhoto = true;
    }
    set storageOptions(storageOptions) {
        this._storageOptions = Object.assign(this._storageOptions, storageOptions);
    }
    set path(path) {
        this.s3ImagePath = path;
    }
    set data(data) {
        this.photoUrl = data.url;
        this.s3ImagePath = data.path;
        this._storageOptions = Object.assign(this._storageOptions, data.storageOptions);
        this.hasPhoto = true;
    }
    ngOnInit() {
        if (!this.amplifyService.storage()) {
            throw new Error('Storage module not registered on AmplifyService provider');
        }
    }
    pick(evt) {
        const file = evt.target.files[0];
        if (!file) {
            return;
        }
        if (!this._storageOptions.contentType) {
            this._storageOptions.contentType = file.type;
        }
        const { name, size, type } = file;
        this.picked.emit(file);
        this.s3ImagePath = `${this.s3ImagePath}/${file.name}`;
        this.s3ImageFile = file;
        const that = this;
        const reader = new FileReader();
        reader.onload = function (e) {
            const target = e.target;
            const url = target.result;
            that.photoUrl = url;
            that.hasPhoto = true;
            that.loaded.emit(url);
        };
        reader.readAsDataURL(file);
    }
    uploadFile() {
        this.uploading = true;
        this.amplifyService
            .storage()
            .put(this.s3ImagePath, this.s3ImageFile, this._storageOptions)
            .then(result => {
            this.uploaded.emit(result);
            this.completeFileUpload();
        })
            .catch(error => {
            this.completeFileUpload(error);
        });
    }
    completeFileUpload(error) {
        if (error) {
            return this._setError(error);
        }
        this.s3ImagePath = '';
        this.photoUrl = null;
        this.s3ImageFile = null;
        this.uploading = false;
    }
    onPhotoError() {
        this.hasPhoto = false;
    }
    onAlertClose() {
        this._setError(null);
    }
    _setError(err) {
        if (!err) {
            this.errorMessage = null;
            return;
        }
        this.errorMessage = err.message || err;
    }
};
PhotoPickerComponentCore.ɵfac = function PhotoPickerComponentCore_Factory(t) { return new (t || PhotoPickerComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
PhotoPickerComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhotoPickerComponentCore, selectors: [["amplify-photo-picker-core"]], inputs: { url: "url", storageOptions: "storageOptions", path: "path", data: "data" }, outputs: { picked: "picked", loaded: "loaded", uploaded: "uploaded" }, decls: 11, vars: 4, consts: [[1, "amplify-photo-picker"], [1, "amplify-photo-picker-container"], [1, "amplify-form-header"], ["class", "amplify-photo-picker-upload", 4, "ngIf"], [1, "amplify-photo-picker-preview"], ["class", "amplify-photo-picker-preview", 3, "src", "error", 4, "ngIf"], [1, "amplify-upload-input"], ["type", "file", "accept", "image/*", 3, "change"], ["class", "amplify-form-button amplify-upload-button", 3, "click", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-photo-picker-upload"], [1, "amplify-photo-picker-preview", 3, "src", "error"], [1, "amplify-form-button", "amplify-upload-button", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function PhotoPickerComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "Select Photos");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, PhotoPickerComponentCore_div_4_Template, 1, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, PhotoPickerComponentCore_img_6_Template, 1, 1, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "input", 7);
        ɵngcc0.ɵɵlistener("change", function PhotoPickerComponentCore_Template_input_change_8_listener($event) { return ctx.pick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, PhotoPickerComponentCore_button_9_Template, 2, 0, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, PhotoPickerComponentCore_div_10_Template, 8, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
PhotoPickerComponentCore.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Input()
], PhotoPickerComponentCore.prototype, "url", null);
__decorate([
    Input()
], PhotoPickerComponentCore.prototype, "storageOptions", null);
__decorate([
    Input()
], PhotoPickerComponentCore.prototype, "path", null);
__decorate([
    Input()
], PhotoPickerComponentCore.prototype, "data", null);
__decorate([
    Output()
], PhotoPickerComponentCore.prototype, "picked", void 0);
__decorate([
    Output()
], PhotoPickerComponentCore.prototype, "loaded", void 0);
__decorate([
    Output()
], PhotoPickerComponentCore.prototype, "uploaded", void 0);
PhotoPickerComponentCore = __decorate([ __param(0, Inject(AmplifyService))
], PhotoPickerComponentCore);

const template$n = `
<div class="amplify-photo-picker">
<div class="amplify-photo-picker-container">
  <div class="amplify-form-header">Select Photos</div>
  <div class="amplify-photo-picker-upload" *ngIf="!hasPhoto"></div>
  <div class="amplify-photo-picker-preview">
    <img
      class="amplify-photo-picker-preview"
      src="{{photoUrl}}"
      *ngIf="hasPhoto"
      (error)="onPhotoError()"
    />
  </div>
  <div class="amplify-upload-input">
    <input type="file" 
      accept="image/*"
      (change)="pick($event)"/>
      <button 
        *ngIf="hasPhoto" 
        class="amplify-form-button amplify-upload-button" 
        (click)="uploadFile()">
        Upload Photo
      </button>
  </div>
</div>
<div class="amplify-alert" *ngIf="errorMessage">
  <div class="amplify-alert-body">
    <span class="amplify-alert-icon">&#9888;</span>
    <div class="amplify-alert-message">{{ errorMessage }}</div>
    <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
  </div>
</div>
</div>
`;
let PhotoPickerIonicComponent = class PhotoPickerIonicComponent extends PhotoPickerComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
PhotoPickerIonicComponent.ɵfac = function PhotoPickerIonicComponent_Factory(t) { return new (t || PhotoPickerIonicComponent)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
PhotoPickerIonicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhotoPickerIonicComponent, selectors: [["amplify-photo-picker-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 4, consts: [[1, "amplify-photo-picker"], [1, "amplify-photo-picker-container"], [1, "amplify-form-header"], ["class", "amplify-photo-picker-upload", 4, "ngIf"], [1, "amplify-photo-picker-preview"], ["class", "amplify-photo-picker-preview", 3, "src", "error", 4, "ngIf"], [1, "amplify-upload-input"], ["type", "file", "accept", "image/*", 3, "change"], ["class", "amplify-form-button amplify-upload-button", 3, "click", 4, "ngIf"], ["class", "amplify-alert", 4, "ngIf"], [1, "amplify-photo-picker-upload"], [1, "amplify-photo-picker-preview", 3, "src", "error"], [1, "amplify-form-button", "amplify-upload-button", 3, "click"], [1, "amplify-alert"], [1, "amplify-alert-body"], [1, "amplify-alert-icon"], [1, "amplify-alert-message"], [1, "amplify-alert-close", 3, "click"]], template: function PhotoPickerIonicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "Select Photos");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, PhotoPickerIonicComponent_div_4_Template, 1, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, PhotoPickerIonicComponent_img_6_Template, 1, 1, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "input", 7);
        ɵngcc0.ɵɵlistener("change", function PhotoPickerIonicComponent_Template_input_change_8_listener($event) { return ctx.pick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, PhotoPickerIonicComponent_button_9_Template, 2, 0, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, PhotoPickerIonicComponent_div_10_Template, 8, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasPhoto);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
PhotoPickerIonicComponent.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
PhotoPickerIonicComponent = __decorate([ __param(0, Inject(AmplifyService))
], PhotoPickerIonicComponent);

// tslint:disable
let PhotoPickerComponent = class PhotoPickerComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.picked = new EventEmitter();
        this.loaded = new EventEmitter();
        this.uploaded = new EventEmitter();
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const photoPickerComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(PhotoPickerIonicComponent, {
                url: this.url,
                path: this.path,
                storageOptions: this.storageOptions,
            })
            : new ComponentMount(PhotoPickerComponentCore, {
                url: this.url,
                path: this.path,
                storageOptions: this.storageOptions,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(photoPickerComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = photoPickerComponent.data;
        componentRef.instance.picked.subscribe(e => {
            this.picked.emit(e);
        });
        componentRef.instance.loaded.subscribe(e => {
            this.loaded.emit(e);
        });
        componentRef.instance.uploaded.subscribe(e => {
            this.uploaded.emit(e);
        });
    }
};
PhotoPickerComponent.ɵfac = function PhotoPickerComponent_Factory(t) { return new (t || PhotoPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
PhotoPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhotoPickerComponent, selectors: [["amplify-photo-picker"]], inputs: { framework: "framework", url: "url", path: "path", storageOptions: "storageOptions" }, outputs: { picked: "picked", loaded: "loaded", uploaded: "uploaded" }, decls: 2, vars: 0, consts: [[1, "amplify-component"], ["component-host", ""]], template: function PhotoPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PhotoPickerComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
PhotoPickerComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], PhotoPickerComponent.prototype, "framework", void 0);
__decorate([
    Input()
], PhotoPickerComponent.prototype, "url", void 0);
__decorate([
    Input()
], PhotoPickerComponent.prototype, "path", void 0);
__decorate([
    Input()
], PhotoPickerComponent.prototype, "storageOptions", void 0);
__decorate([
    Output()
], PhotoPickerComponent.prototype, "picked", void 0);
__decorate([
    Output()
], PhotoPickerComponent.prototype, "loaded", void 0);
__decorate([
    Output()
], PhotoPickerComponent.prototype, "uploaded", void 0);
PhotoPickerComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], PhotoPickerComponent);

// tslint:disable
require('../assets/js/aws-lex-audio.js');
const template$o = `
<div class="amplify-interactions">
	<div class="amplify-interactions-container">
		<div class="amplify-form-container">
			<div class="amplify-form-row">
				<div class="amplify-interactions-conversation">
					<div *ngFor="let message of messages">
						<div class="amplify-interactions-input">{{message.me}}</div>
						<div class="amplify-interactions-input-timestamp">{{message.meSentTime}}</div>
						<div class="amplify-interactions-response">{{message.bot}}</div>
						<div class="amplify-interactions-response-timestamp">{{message.botSentTime}}</div>
					</div>
				</div>
			</div>
			<div class="amplify-interactions-actions">
				<input #inputValue
					type='text'
					class="amplify-form-input"
					placeholder="{{currentVoiceState}}"
					[value]="inputText"
					(keyup.enter)="onSubmit(inputValue.value)"
					(change)="onInputChange($event.target.value)"
					[disabled]="inputDisabled"
					*ngIf="textEnabled">
				<input #inputValue
					type='text'
					class="amplify-form-input"
					placeholder="{{currentVoiceState}}"
					[disabled]="!textEnabled"
					*ngIf="!textEnabled">

				<button
					type="button"
					*ngIf="voiceEnabled"
					ng-style="{float: 'right'}"
					(click)="micButtonHandler()"
					[disabled]="micButtonDisabled"
				>
					{{micText}}
				</button>
				<button
					type="button"
					*ngIf="textEnabled"
					ng-style="{float: 'right'}"
					class="amplify-interactions-button"
					[disabled]="inputDisabled"
					ng-click="!inputDisabled || onSubmit(inputValue.value)"
				></button>
			</div>
		</div>
	</div>
</div>
`;
const STATES = {
    INITIAL: { MESSAGE: 'Type your message or click  🎤', ICON: '🎤' },
    LISTENING: { MESSAGE: 'Listening... click 🔴 again to cancel', ICON: '🔴' },
    SENDING: { MESSAGE: 'Please wait...', ICON: '🔊' },
    SPEAKING: { MESSAGE: 'Speaking...', ICON: '...' },
};
const defaultVoiceConfig = {
    silenceDetectionConfig: {
        time: 2000,
        amplitude: 0.2,
    },
};
let ChatbotComponentCore = class ChatbotComponentCore {
    constructor(ref, amplifyService) {
        this.amplifyService = amplifyService;
        this.inputText = '';
        this.clearComplete = false;
        this.messages = [];
        this.completions = {};
        this.currentVoiceState = STATES.INITIAL.MESSAGE;
        this.inputDisabled = false;
        this.micText = STATES.INITIAL.ICON;
        this.voiceConfig = defaultVoiceConfig;
        this.continueConversation = false;
        this.micButtonDisabled = false;
        this.conversationModeOn = false;
        this.voiceEnabled = false;
        this.textEnabled = true;
        this.complete = new EventEmitter();
        this.onSilenceHandler = () => {
            if (!this.continueConversation) {
                return;
            }
            this.audioControl.exportWAV(blob => {
                this.currentVoiceState = STATES.SENDING.MESSAGE;
                this.audioInput = blob;
                this.micText = STATES.SENDING.ICON;
                this.micButtonDisabled = true;
                this.lexResponseHandler();
            });
            this.ref.detectChanges();
        };
        this.ref = ref;
        this.continueConversation = false;
        this.logger = this.amplifyService.logger('ChatbotComponent');
    }
    set data(data) {
        this.botName = data.bot;
        this.chatTitle = data.title;
        this.clearComplete = data.clearComplete;
        this.conversationModeOn = isUndefined(data.conversationModeOn)
            ? false
            : data.conversationModeOn;
        this.voiceEnabled = isUndefined(data.voiceEnabled)
            ? false
            : data.voiceEnabled;
        this.textEnabled = isUndefined(data.textEnabled) ? true : data.textEnabled;
        this.voiceConfig = data.voiceConfig || this.voiceConfig;
        this.performOnComplete = this.performOnComplete.bind(this);
        this.amplifyService
            .interactions()
            .onComplete(this.botName, this.performOnComplete);
        if (!this.textEnabled && this.voiceEnabled) {
            this.currentVoiceState = 'Click the mic button';
            STATES.INITIAL.MESSAGE = 'Click the mic button';
        }
        if (!this.voiceEnabled && this.textEnabled) {
            this.currentVoiceState = 'Type a message';
            STATES.INITIAL.MESSAGE = 'Type a message';
        }
        if (this.voiceEnabled) {
            this.audioControl = new LexAudio.audioControl();
        }
    }
    set bot(botName) {
        this.botName = botName;
        this.performOnComplete = this.performOnComplete.bind(this);
        this.amplifyService
            .interactions()
            .onComplete(botName, this.performOnComplete);
    }
    set title(title) {
        this.chatTitle = title;
    }
    set clearOnComplete(clearComplete) {
        this.clearComplete = clearComplete;
    }
    ngOnInit() {
        if (!this.amplifyService.interactions()) {
            throw new Error('Interactions module not registered on AmplifyService provider');
        }
    }
    performOnComplete(evt) {
        this.complete.emit(evt);
        if (this.clearComplete) {
            this.messages = [];
        }
    }
    onInputChange(value) {
        this.inputText = value;
    }
    onSubmit(e) {
        if (!this.inputText) {
            return;
        }
        const message = {
            me: this.inputText,
            meSentTime: new Date().toLocaleTimeString(),
            bot: '',
            botSentTime: '',
        };
        this.amplifyService
            .interactions()
            .send(this.botName, this.inputText)
            .then((response) => {
            this.inputText = '';
            message.bot = response.message;
            message.botSentTime = new Date().toLocaleTimeString();
            this.messages.push(message);
        })
            .catch(error => this.logger.error(error));
    }
    reset() {
        this.audioControl.clear();
        this.inputText = '';
        this.currentVoiceState = STATES.INITIAL.MESSAGE;
        this.inputDisabled = false;
        this.micText = STATES.INITIAL.ICON;
        this.continueConversation = false;
        this.micButtonDisabled = false;
        this.ref.detectChanges();
    }
    onError(error) {
        this.logger.error(error);
    }
    lexResponseHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.continueConversation) {
                return;
            }
            const interactionsMessage = {
                content: this.audioInput,
                options: {
                    messageType: 'voice',
                },
            };
            const response = yield this.amplifyService
                .interactions()
                .send(this.botName, interactionsMessage);
            this.lexResponse = response;
            this.currentVoiceState = STATES.SPEAKING.MESSAGE;
            this.micText = STATES.SPEAKING.ICON;
            this.micButtonDisabled = true;
            const message = {
                me: this.lexResponse.inputTranscript,
                meSentTime: new Date().toLocaleTimeString(),
                bot: '',
                botSentTime: '',
            };
            this.inputText = '';
            message.bot = this.lexResponse.message;
            message.botSentTime = new Date().toLocaleTimeString();
            this.messages.push(message);
            this.doneSpeakingHandler();
            this.ref.detectChanges();
        });
    }
    doneSpeakingHandler() {
        if (!this.continueConversation) {
            return;
        }
        if (this.lexResponse.contentType === 'audio/mpeg') {
            this.audioControl.play(this.lexResponse.audioStream, () => {
                if (this.lexResponse.dialogState === 'ReadyForFulfillment' ||
                    this.lexResponse.dialogState === 'Fulfilled' ||
                    this.lexResponse.dialogState === 'Failed' ||
                    !this.conversationModeOn) {
                    this.inputDisabled = false;
                    this.currentVoiceState = STATES.INITIAL.MESSAGE;
                    this.micText = STATES.INITIAL.ICON;
                    this.micButtonDisabled = false;
                    this.continueConversation = false;
                    this.ref.detectChanges();
                }
                else {
                    this.currentVoiceState = STATES.LISTENING.MESSAGE;
                    this.micText = STATES.LISTENING.ICON;
                    this.micButtonDisabled = false;
                    this.audioControl.startRecording(this.onSilenceHandler, null, this.voiceConfig.silenceDetectionConfig);
                    this.ref.detectChanges();
                }
            });
        }
        else {
            this.inputDisabled = false;
            this.currentVoiceState = STATES.INITIAL.MESSAGE;
            this.micText = STATES.INITIAL.ICON;
            this.micButtonDisabled = false;
            this.continueConversation = false;
            this.ref.detectChanges();
        }
    }
    micButtonHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.continueConversation) {
                this.reset();
                this.ref.detectChanges();
            }
            else {
                this.inputDisabled = true;
                this.continueConversation = true;
                this.currentVoiceState = STATES.LISTENING.MESSAGE;
                this.micText = STATES.LISTENING.ICON;
                this.micButtonDisabled = false;
                this.audioControl.startRecording(this.onSilenceHandler, null, this.voiceConfig.silenceDetectionConfig);
                this.ref.detectChanges();
            }
        });
    }
};
ChatbotComponentCore.ɵfac = function ChatbotComponentCore_Factory(t) { return new (t || ChatbotComponentCore)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ChatbotComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatbotComponentCore, selectors: [["amplify-interactions-core"]], inputs: { data: "data", bot: "bot", title: "title", clearOnComplete: "clearOnComplete" }, outputs: { complete: "complete" }, decls: 11, vars: 5, consts: [[1, "amplify-interactions"], [1, "amplify-interactions-container"], [1, "amplify-form-container"], [1, "amplify-form-row"], [1, "amplify-interactions-conversation"], [4, "ngFor", "ngForOf"], [1, "amplify-interactions-actions"], ["type", "text", "class", "amplify-form-input", 3, "placeholder", "value", "disabled", "keyup.enter", "change", 4, "ngIf"], ["type", "text", "class", "amplify-form-input", 3, "placeholder", "disabled", 4, "ngIf"], ["type", "button", "ng-style", "{float: 'right'}", 3, "disabled", "click", 4, "ngIf"], ["type", "button", "ng-style", "{float: 'right'}", "class", "amplify-interactions-button", "ng-click", "!inputDisabled || onSubmit(inputValue.value)", 3, "disabled", 4, "ngIf"], [1, "amplify-interactions-input"], [1, "amplify-interactions-input-timestamp"], [1, "amplify-interactions-response"], [1, "amplify-interactions-response-timestamp"], ["type", "text", 1, "amplify-form-input", 3, "placeholder", "value", "disabled", "keyup.enter", "change"], ["inputValue", ""], ["type", "text", 1, "amplify-form-input", 3, "placeholder", "disabled"], ["type", "button", "ng-style", "{float: 'right'}", 3, "disabled", "click"], ["type", "button", "ng-style", "{float: 'right'}", "ng-click", "!inputDisabled || onSubmit(inputValue.value)", 1, "amplify-interactions-button", 3, "disabled"]], template: function ChatbotComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ChatbotComponentCore_div_5_Template, 9, 4, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtemplate(7, ChatbotComponentCore_input_7_Template, 2, 3, "input", 7);
        ɵngcc0.ɵɵtemplate(8, ChatbotComponentCore_input_8_Template, 2, 2, "input", 8);
        ɵngcc0.ɵɵtemplate(9, ChatbotComponentCore_button_9_Template, 2, 2, "button", 9);
        ɵngcc0.ɵɵtemplate(10, ChatbotComponentCore_button_10_Template, 1, 1, "button", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.textEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.voiceEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textEnabled);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf], encapsulation: 2 });
ChatbotComponentCore.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
__decorate([
    Output()
], ChatbotComponentCore.prototype, "complete", void 0);
__decorate([
    Input()
], ChatbotComponentCore.prototype, "data", null);
__decorate([
    Input()
], ChatbotComponentCore.prototype, "bot", null);
__decorate([
    Input()
], ChatbotComponentCore.prototype, "title", null);
__decorate([
    Input()
], ChatbotComponentCore.prototype, "clearOnComplete", null);
ChatbotComponentCore = __decorate([ __param(1, Inject(AmplifyService))
], ChatbotComponentCore);

// tslint:disable
const template$p = `
<div class="amplify-interactions-container">
	<div class="amplify-form-container">
		<ion-grid>
			<ion-row *ngIf="chatTitle"> 
				<ion-col>
					<ion-row>
						<ion-col align-self-start>
							<div>
								<ion-chip color="primary">
									<ion-label>{{chatTitle}}</ion-label>
								</ion-chip>
							</div>
						</ion-col>
						<ion-col align-self-end>
							&nbsp;
						</ion-col>
					</ion-row>
				</ion-col>
			</ion-row>
			<ion-row *ngFor="let message of messages">
				<ion-col>
					<ion-row>
						<ion-col align-self-start>
							<div>
								&nbsp;
							</div>
						</ion-col>
						<ion-col align-self-end>
							<ion-chip style="float:right">
								<ion-label>{{message.me}}</ion-label>
							</ion-chip>
						</ion-col>
					</ion-row>
					<ion-row>
						<ion-col align-self-start>
							<ion-chip color="primary">
								<ion-label>{{message.bot}}</ion-label>
							</ion-chip>
						</ion-col>
						<ion-col align-self-end>
							<div>
								&nbsp;
							</div>
						</ion-col>
					</ion-row>
				</ion-col>
			</ion-row>
		</ion-grid>
		<div class="amplify-form-row">
		    <ion-input #inputValue
				type='text'
		        class="amplify-form-input amplify-form-input-interactions-ionic"
		        placeholder="{{currentVoiceState}}"
		        [value]="inputText"
		        (keyup.enter)="onSubmit(inputValue.value)"
				(ionChange)="onInputChange($event.target.value)"
				[disabled]="inputDisabled"
				*ngIf="textEnabled"></ion-input>
			<ion-input #inputValue
				type='text'
				class="amplify-form-input amplify-form-input-interactions-ionic"
				placeholder="{{currentVoiceState}}"
				[disabled]="!textEnabled"
				*ngIf="!textEnabled"></ion-input>
			<ion-button 
				expand="block"
				*ngIf="voiceEnabled"
				ng-style="{float: 'right'}"
				(click)="micButtonHandler()"
				[disabled]="micButtonDisabled"
			>
				{{micText}}
			</ion-button>
			<ion-button
				expand="block"
				*ngIf="textEnabled"
				ng-style="{float: 'right'}"
				(click)="inputDisabled === false || onSubmit(inputValue.value)"
			>
				Send
			</ion-button>
		</div>
	</div>
</div>
`;
let ChatbotComponentIonic = class ChatbotComponentIonic extends ChatbotComponentCore {
    constructor(ref, amplifyService) {
        super(ref, amplifyService);
        this.amplifyService = amplifyService;
    }
};
ChatbotComponentIonic.ɵfac = function ChatbotComponentIonic_Factory(t) { return new (t || ChatbotComponentIonic)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
ChatbotComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatbotComponentIonic, selectors: [["amplify-interactions-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 6, consts: [[1, "amplify-interactions-container"], [1, "amplify-form-container"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "amplify-form-row"], ["type", "text", "class", "amplify-form-input amplify-form-input-interactions-ionic", 3, "placeholder", "value", "disabled", "keyup.enter", "ionChange", 4, "ngIf"], ["type", "text", "class", "amplify-form-input amplify-form-input-interactions-ionic", 3, "placeholder", "disabled", 4, "ngIf"], ["expand", "block", "ng-style", "{float: 'right'}", 3, "disabled", "click", 4, "ngIf"], ["expand", "block", "ng-style", "{float: 'right'}", 3, "click", 4, "ngIf"], ["align-self-start", ""], ["color", "primary"], ["align-self-end", ""], [2, "float", "right"], ["type", "text", 1, "amplify-form-input", "amplify-form-input-interactions-ionic", 3, "placeholder", "value", "disabled", "keyup.enter", "ionChange"], ["inputValue", ""], ["type", "text", 1, "amplify-form-input", "amplify-form-input-interactions-ionic", 3, "placeholder", "disabled"], ["expand", "block", "ng-style", "{float: 'right'}", 3, "disabled", "click"], ["expand", "block", "ng-style", "{float: 'right'}", 3, "click"]], template: function ChatbotComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ion-grid");
        ɵngcc0.ɵɵtemplate(3, ChatbotComponentIonic_ion_row_3_Template, 10, 1, "ion-row", 2);
        ɵngcc0.ɵɵtemplate(4, ChatbotComponentIonic_ion_row_4_Template, 18, 2, "ion-row", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, ChatbotComponentIonic_ion_input_6_Template, 2, 3, "ion-input", 5);
        ɵngcc0.ɵɵtemplate(7, ChatbotComponentIonic_ion_input_7_Template, 2, 2, "ion-input", 6);
        ɵngcc0.ɵɵtemplate(8, ChatbotComponentIonic_ion_button_8_Template, 2, 2, "ion-button", 7);
        ɵngcc0.ɵɵtemplate(9, ChatbotComponentIonic_ion_button_9_Template, 2, 0, "ion-button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.chatTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.messages);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.textEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.voiceEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textEnabled);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2 });
ChatbotComponentIonic.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
ChatbotComponentIonic = __decorate([ __param(1, Inject(AmplifyService))
], ChatbotComponentIonic);

// tslint:disable
let ChatBotComponent = class ChatBotComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.complete = new EventEmitter();
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const interactionParams = {
            bot: this.bot,
            title: this.title,
            clearComplete: this.clearComplete,
            conversationModeOn: this.conversationModeOn,
            voiceConfig: this.voiceConfig,
            voiceEnabled: this.voiceEnabled,
            textEnabled: this.textEnabled,
        };
        const interactionComponent = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(ChatbotComponentIonic, interactionParams)
            : new ComponentMount(ChatbotComponentCore, interactionParams);
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(interactionComponent.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = interactionComponent.data;
        componentRef.instance.complete.subscribe(e => {
            this.complete.emit(e);
        });
    }
};
ChatBotComponent.ɵfac = function ChatBotComponent_Factory(t) { return new (t || ChatBotComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
ChatBotComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChatBotComponent, selectors: [["amplify-interactions"]], inputs: { framework: "framework", bot: "bot", title: "title", clearComplete: "clearComplete", conversationModeOn: "conversationModeOn", voiceConfig: "voiceConfig", voiceEnabled: "voiceEnabled", textEnabled: "textEnabled" }, outputs: { complete: "complete" }, decls: 2, vars: 0, consts: [[1, "amplify-component"], ["component-host", ""]], template: function ChatBotComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ChatBotComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DynamicComponentDirective]; }, encapsulation: 2 });
ChatBotComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], ChatBotComponent.prototype, "framework", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "bot", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "title", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "clearComplete", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "conversationModeOn", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "voiceConfig", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "voiceEnabled", void 0);
__decorate([
    Input()
], ChatBotComponent.prototype, "textEnabled", void 0);
__decorate([
    Output()
], ChatBotComponent.prototype, "complete", void 0);
ChatBotComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], ChatBotComponent);

let DynamicComponentDirective = class DynamicComponentDirective {
    constructor(viewContainerRef, shared) {
        this.viewContainerRef = viewContainerRef;
        shared.registerContainer(viewContainerRef);
    }
};
DynamicComponentDirective.ɵfac = function DynamicComponentDirective_Factory(t) { return new (t || DynamicComponentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
DynamicComponentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DynamicComponentDirective, selectors: [["", "component-host", ""]] });
DynamicComponentDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
DynamicComponentDirective = __decorate([ __param(1, Inject('dynamic-component-service'))
], DynamicComponentDirective);

// tslint:disable
const template$q = `
<div class="amplify-form">
  <div class="form-header">
    <div class="form-title">{{ title }}</div>
  </div>
  <div class="form-body">
    <ng-content select="[form-body]"></ng-content>
  </div>
  <div class="form-footer">
    <ng-content select="[form-footer]"></ng-content>
  </div>
</div>
`;
let FormComponent = class FormComponent {
    set title(title) {
        this.title = title;
    }
};
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(); };
FormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormComponent, selectors: [["amplify-form"]], inputs: { title: "title" }, ngContentSelectors: _c2, decls: 8, vars: 1, consts: [[1, "amplify-form"], [1, "form-header"], [1, "form-title"], [1, "form-body"], [1, "form-footer"]], template: function FormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, encapsulation: 2 });
__decorate([
    Input()
], FormComponent.prototype, "title", null);

const template$r = `
<div id="sumerian-scene-container" class={{amplifyUI.sumerianSceneContainer}} data-test="${sumerianScene.container}">
  <div id="sumerian-scene-dom-id" class={{amplifyUI.sumerianScene}} data-test="${sumerianScene.sumerianScene}">
    <sumerian-scene-loading-core *ngIf="loading" loadPercentage={{loadPercentage}} sceneName={{sceneName}} sceneError={{sceneError}} data-test="${sumerianScene.loading}"></sumerian-scene-loading-core>
  </div>
  <div *ngIf="!loading" class={{amplifyUI.sceneBar}} data-test="${sumerianScene.bar}">
    <span class={{amplifyUI.sceneActions}} data-test="${sumerianScene.actions}">
      <div [ngClass]="[amplifyUI.tooltip, showEnableAudio ? amplifyUI.autoShowTooltip : '']" [attr.data-text]="showEnableAudio ? 'The scene is muted. Click to unmute.' : (muted ? 'Unmute' : 'Mute')" (click)="muted ? setMuted(false) : setMuted(true)">
        <button class={{amplifyUI.actionButton}}>
          <svg *ngIf="muted" width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/volumeOff" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M3.48026899,12.9630494 C3.63825091,12.9630494 3.79237961,13.0108921 3.92264322,13.1003479 L8.77467683,16.8113609 C9.29423971,17.1679383 10,16.7950396 10,16.1637406 L10,3.78619489 C10,3.15489596 9.29423971,2.78199725 8.77467683,3.13857463 L3.92264322,6.84545211 C3.79237961,6.93490793 3.63825091,6.9827506 3.48026899,6.9827506 L1.78294894,6.9827506 C1.3505185,6.9827506 1,7.33409518 1,7.76754476 L1,12.1781306 C1,12.6117048 1.3505185,12.9630494 1.78294894,12.9630494 L3.48026899,12.9630494 Z M17.2118156,7 L15.0918385,9.11997713 L12.9718614,7 L12,7.97174685 L14.1200917,10.091724 L12,12.2118156 L12.9718614,13.1835625 L15.0918385,11.0635854 L17.2118156,13.1835625 L18.1835625,12.2118156 L16.0635854,10.091724 L18.1835625,7.97174685 L17.2118156,7 Z" id="Fill-2" fill="#FFFFFF"></path>
            </g>
          </svg>
          <svg *ngIf="!muted" width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/volumeOn" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M3.48026899,12.9630494 L1.78294894,12.9630494 C1.3505185,12.9630494 1,12.6117048 1,12.1781306 L1,7.76754476 C1,7.33409518 1.3505185,6.9827506 1.78294894,6.9827506 L3.48026899,6.9827506 C3.63825091,6.9827506 3.79237961,6.93490793 3.92264322,6.84545211 L8.77467683,3.13857463 C9.29423971,2.78199725 10,3.15489596 10,3.78619489 L10,16.1637406 C10,16.7950396 9.29423971,17.1679383 8.77467683,16.8113609 L3.92264322,13.1003479 C3.79237961,13.0108921 3.63825091,12.9630494 3.48026899,12.9630494 Z M14.9270376,3.03232286 C15.1729267,3.03232286 15.4040399,3.12815658 15.5777627,3.3022351 C17.3699891,5.09889099 18.3570052,7.48235058 18.3570052,10.0135053 C18.3570052,12.54466 17.3699891,14.9281196 15.5777627,16.7247755 C15.4041045,16.898854 15.1729914,16.9947524 14.9270052,16.9947524 C14.6820861,16.9947524 14.4515549,16.899436 14.2777674,16.7263598 C13.9192316,16.3684383 13.9185203,15.7852882 14.2762477,15.4264291 C15.7222893,13.9769926 16.5186727,12.0545954 16.5186727,10.0135053 C16.5186727,7.97241524 15.7222893,6.05001801 14.2762154,4.60058152 C13.9184879,4.24175473 13.9191992,3.65857229 14.277832,3.30065081 C14.4514256,3.1275746 14.6819567,3.03232286 14.9270376,3.03232286 Z M13.5730665,6.11570485 C14.6133991,7.15574642 15.1862998,8.54003279 15.1862998,10.0134924 C15.1862998,11.4892799 14.6113945,12.8741159 13.5675376,13.9128965 C13.3942351,14.0855848 13.1639626,14.1806425 12.9191727,14.1806425 C12.6727016,14.1806425 12.4412975,14.0844531 12.2677039,13.9097926 C12.0944984,13.7358111 11.9994406,13.5047303 11.9999903,13.2592291 C12.0005723,13.0136956 12.096794,12.7831644 12.2708079,12.6100882 C12.9654406,11.9185917 13.3479995,10.996467 13.3479995,10.0134924 C13.3479995,9.03119677 12.966346,8.1086194 12.2733298,7.4157649 C11.9150203,7.05745543 11.9149233,6.47436998 12.2731358,6.11589885 C12.4467617,5.94224065 12.6775838,5.84666559 12.923085,5.84666559 C13.1685538,5.84666559 13.3993436,5.94220831 13.5730665,6.11570485 Z" id="Fill-2" fill="#FFFFFF"></path>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isVRCapable && !isVRPresentationActive" class={{amplifyUI.tooltip}} data-text="Enter VR" (click)="toggleVRPresentation()">
        <button class={{amplifyUI.actionButton}}>
          <svg width="19px" height="19px" viewBox="0 0 17 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="VRon" fill="#FFFFFF" fill-rule="nonzero">
                <path d="M15.7856977,0.02395184 L15.8915734,0.02395184 C16.5037405,0.02395184 17,0.520211324 17,1.13237842 L17,1.54663675 L17,8.8915038 C17,9.5034193 16.4560011,10 15.7856977,10 L12.0095825,10 C9.98324439,7.1593807 8.80676009,5.741338 8.48012959,5.74587199 C8.16206045,5.75028714 7.01003321,7.1683298 5.02404785,10 L1.21426911,10 C0.543965735,10 3.32031236e-05,9.5034193 3.32031236e-05,8.8915038 L3.32031236e-05,1.54663675 L3.32031236e-05,1.13237842 L3.32031236e-05,1.13237842 C3.32031236e-05,0.520211324 0.496292687,0.02395184 1.10845978,0.02395184 L1.21426911,0.02395184 L15.7856977,0.02395184 Z M4.5,6 C5.32842712,6 6,5.32842712 6,4.5 C6,3.67157288 5.32842712,3 4.5,3 C3.67157288,3 3,3.67157288 3,4.5 C3,5.32842712 3.67157288,6 4.5,6 Z M12.5,6 C13.3284271,6 14,5.32842712 14,4.5 C14,3.67157288 13.3284271,3 12.5,3 C11.6715729,3 11,3.67157288 11,4.5 C11,5.32842712 11.6715729,6 12.5,6 Z" id="Fill-1"></path>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isVRCapable && isVRPresentationActive" class={{amplifyUI.tooltip}} data-text="Exit VR" (click)="toggleVRPresentation()">
        <button class={{amplifyUI.actionButton}}>
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/VRon-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-7-Copy" transform="translate(1.000000, 3.000000)" fill="#FFFFFF">
                <path d="M15.7856977,3.02395184 L17,3.02395184 L17,4.13237842 L17,4.54663675 L17,11.8915038 C17,12.5034193 16.4560011,13 15.7856977,13 L12.0095825,13 C9.98324439,10.1593807 8.80676009,8.741338 8.48012959,8.74587199 C8.16206045,8.75028714 7.01003321,10.1683298 5.02404785,13 L1.21426911,13 C0.543965735,13 3.32031236e-05,12.5034193 3.32031236e-05,11.8915038 L3.32031236e-05,4.54663675 L3.32031236e-05,4.13237842 L3.32031236e-05,3.02395184 L1.21426911,3.02395184 L15.7856977,3.02395184 Z M4.5,9 C5.32842712,9 6,8.32842712 6,7.5 C6,6.67157288 5.32842712,6 4.5,6 C3.67157288,6 3,6.67157288 3,7.5 C3,8.32842712 3.67157288,9 4.5,9 Z M12.5,9 C13.3284271,9 14,8.32842712 14,7.5 C14,6.67157288 13.3284271,6 12.5,6 C11.6715729,6 11,6.67157288 11,7.5 C11,8.32842712 11.6715729,9 12.5,9 Z M2.5486669,0 L14.420089,0 C14.7977406,0 15.1613805,0.149260956 15.4374308,0.417695511 L16.9999668,2.00634766 L0,2.00634766 L1.58537972,0.395493117 C1.84682061,0.141306827 2.19106994,0 2.5486669,0 Z" id="Fill-1"></path>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="!isFullscreen" class={{amplifyUI.tooltip}} data-text="Fullscreen">
        <button class={{amplifyUI.actionButton}} (click)="maximize()">
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/screenfull" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M2.04162598,3 L2.04162598,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z M3,4 L16,4 L16,15 L3,15 L3,4 Z" id="Rectangle-Copy" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isFullscreen" class={{amplifyUI.tooltip}} data-text="Exit Fullscreen">
        <button class={{amplifyUI.actionButton}} (click)="minimize()">
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/screensmall" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M11,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 L2.04162598,10 L11,10 L11,16 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z" id="Rectangle" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
          </svg>
        </button>
      </div>
    </span>
  </div>
</div>
`;
let SumerianSceneComponentCore = class SumerianSceneComponentCore {
    constructor(amplifyService) {
        this.amplifyService = amplifyService;
        this.loading = false;
        this.loadPercentage = 0;
        this.muted = false;
        this.showEnableAudio = false;
        this.isVRCapable = false;
        this.isVRPresentationActive = false;
        this.isFullscreen = false;
        this.sceneError = null;
        this.progressCallback = progress => {
            const percentage = progress * 100;
            this.loadPercentage = percentage;
        };
        this.amplifyUI = AmplifyUI;
        this.logger = this.amplifyService.logger('SumerianSceneComponentCore');
    }
    set data(data) {
        this.sceneName = data.sceneName;
    }
    ngOnInit() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));
        document.addEventListener('mozfullscreenchange', this.onFullscreenChange.bind(this));
        document.addEventListener('MSFullscreenChange', this.onFullscreenChange.bind(this));
        if (!this.amplifyService.xr()) {
            throw new Error('XR module not registered on AmplifyService provider');
        }
        this.loadAndStartScene();
    }
    ngOnDestroy() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange.bind(this));
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));
        document.removeEventListener('mozfullscreenchange', this.onFullscreenChange.bind(this));
        document.removeEventListener('MSFullscreenChange', this.onFullscreenChange.bind(this));
    }
    loadAndStartScene() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            const sceneOptions = {
                progressCallback: this.progressCallback,
            };
            try {
                yield this.amplifyService
                    .xr()
                    .loadScene(this.sceneName, 'sumerian-scene-dom-id', sceneOptions);
            }
            catch (e) {
                this.sceneError = 'Failed to load scene';
                this.logger.error(this.sceneError, e);
                return;
            }
            this.amplifyService.xr().start(this.sceneName);
            this.loading = false;
            this.muted = this.amplifyService.xr().isMuted(this.sceneName);
            this.isVRCapable = this.amplifyService.xr().isVRCapable(this.sceneName);
            this.isVRPresentationActive = this.amplifyService
                .xr()
                .isVRPresentationActive(this.sceneName);
            this.amplifyService
                .xr()
                .onSceneEvent(this.sceneName, 'AudioEnabled', () => (this.showEnableAudio = false));
            this.amplifyService
                .xr()
                .onSceneEvent(this.sceneName, 'AudioDisabled', () => (this.showEnableAudio = true));
        });
    }
    setMuted(muted) {
        this.muted = muted;
        this.amplifyService.xr().setMuted(this.sceneName, muted);
        if (this.showEnableAudio) {
            this.amplifyService.xr().enableAudio(this.sceneName);
            this.showEnableAudio = false;
        }
    }
    toggleVRPresentation() {
        try {
            if (this.isVRPresentationActive) {
                this.amplifyService.xr().exitVR(this.sceneName);
            }
            else {
                this.amplifyService.xr().enterVR(this.sceneName);
            }
        }
        catch (e) {
            this.logger.error('Unable to start/stop WebVR System: ' + e.message);
            return;
        }
        this.isVRPresentationActive = !this.isVRPresentationActive;
    }
    onFullscreenChange() {
        const doc = document;
        this.isFullscreen = doc.fullscreenElement !== null;
    }
    maximize() {
        return __awaiter(this, void 0, void 0, function* () {
            const sceneDomElement = document.getElementById('sumerian-scene-container');
            const requestFullScreen = sceneDomElement.requestFullscreen ||
                sceneDomElement.msRequestFullscreen ||
                sceneDomElement.mozRequestFullScreen ||
                sceneDomElement.webkitRequestFullscreen;
            requestFullScreen.call(sceneDomElement);
        });
    }
    minimize() {
        return __awaiter(this, void 0, void 0, function* () {
            const doc = document;
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        });
    }
};
SumerianSceneComponentCore.ɵfac = function SumerianSceneComponentCore_Factory(t) { return new (t || SumerianSceneComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SumerianSceneComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SumerianSceneComponentCore, selectors: [["sumerian-scene-core"]], inputs: { data: "data", sceneName: "sceneName" }, decls: 4, vars: 8, consts: [["id", "sumerian-scene-container", "data-test", "sumerian-scene-container"], ["id", "sumerian-scene-dom-id", "data-test", "sumerian-scene"], ["data-test", "sumerian-scene-loading", 3, "loadPercentage", "sceneName", "sceneError", 4, "ngIf"], ["data-test", "sumerian-scene-bar", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-loading", 3, "loadPercentage", "sceneName", "sceneError"], ["data-test", "sumerian-scene-bar"], ["data-test", "sumerian-scene-actions"], [3, "ngClass", "click"], ["width", "19px", "height", "19px", "viewBox", "0 0 19 19", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 4, "ngIf"], ["data-text", "Enter VR", 3, "class", "click", 4, "ngIf"], ["data-text", "Exit VR", 3, "class", "click", 4, "ngIf"], ["data-text", "Fullscreen", 3, "class", 4, "ngIf"], ["data-text", "Exit Fullscreen", 3, "class", 4, "ngIf"], ["width", "19px", "height", "19px", "viewBox", "0 0 19 19", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["id", "icons/minis/volumeOff", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M3.48026899,12.9630494 C3.63825091,12.9630494 3.79237961,13.0108921 3.92264322,13.1003479 L8.77467683,16.8113609 C9.29423971,17.1679383 10,16.7950396 10,16.1637406 L10,3.78619489 C10,3.15489596 9.29423971,2.78199725 8.77467683,3.13857463 L3.92264322,6.84545211 C3.79237961,6.93490793 3.63825091,6.9827506 3.48026899,6.9827506 L1.78294894,6.9827506 C1.3505185,6.9827506 1,7.33409518 1,7.76754476 L1,12.1781306 C1,12.6117048 1.3505185,12.9630494 1.78294894,12.9630494 L3.48026899,12.9630494 Z M17.2118156,7 L15.0918385,9.11997713 L12.9718614,7 L12,7.97174685 L14.1200917,10.091724 L12,12.2118156 L12.9718614,13.1835625 L15.0918385,11.0635854 L17.2118156,13.1835625 L18.1835625,12.2118156 L16.0635854,10.091724 L18.1835625,7.97174685 L17.2118156,7 Z", "id", "Fill-2", "fill", "#FFFFFF"], ["id", "icons/minis/volumeOn", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M3.48026899,12.9630494 L1.78294894,12.9630494 C1.3505185,12.9630494 1,12.6117048 1,12.1781306 L1,7.76754476 C1,7.33409518 1.3505185,6.9827506 1.78294894,6.9827506 L3.48026899,6.9827506 C3.63825091,6.9827506 3.79237961,6.93490793 3.92264322,6.84545211 L8.77467683,3.13857463 C9.29423971,2.78199725 10,3.15489596 10,3.78619489 L10,16.1637406 C10,16.7950396 9.29423971,17.1679383 8.77467683,16.8113609 L3.92264322,13.1003479 C3.79237961,13.0108921 3.63825091,12.9630494 3.48026899,12.9630494 Z M14.9270376,3.03232286 C15.1729267,3.03232286 15.4040399,3.12815658 15.5777627,3.3022351 C17.3699891,5.09889099 18.3570052,7.48235058 18.3570052,10.0135053 C18.3570052,12.54466 17.3699891,14.9281196 15.5777627,16.7247755 C15.4041045,16.898854 15.1729914,16.9947524 14.9270052,16.9947524 C14.6820861,16.9947524 14.4515549,16.899436 14.2777674,16.7263598 C13.9192316,16.3684383 13.9185203,15.7852882 14.2762477,15.4264291 C15.7222893,13.9769926 16.5186727,12.0545954 16.5186727,10.0135053 C16.5186727,7.97241524 15.7222893,6.05001801 14.2762154,4.60058152 C13.9184879,4.24175473 13.9191992,3.65857229 14.277832,3.30065081 C14.4514256,3.1275746 14.6819567,3.03232286 14.9270376,3.03232286 Z M13.5730665,6.11570485 C14.6133991,7.15574642 15.1862998,8.54003279 15.1862998,10.0134924 C15.1862998,11.4892799 14.6113945,12.8741159 13.5675376,13.9128965 C13.3942351,14.0855848 13.1639626,14.1806425 12.9191727,14.1806425 C12.6727016,14.1806425 12.4412975,14.0844531 12.2677039,13.9097926 C12.0944984,13.7358111 11.9994406,13.5047303 11.9999903,13.2592291 C12.0005723,13.0136956 12.096794,12.7831644 12.2708079,12.6100882 C12.9654406,11.9185917 13.3479995,10.996467 13.3479995,10.0134924 C13.3479995,9.03119677 12.966346,8.1086194 12.2733298,7.4157649 C11.9150203,7.05745543 11.9149233,6.47436998 12.2731358,6.11589885 C12.4467617,5.94224065 12.6775838,5.84666559 12.923085,5.84666559 C13.1685538,5.84666559 13.3993436,5.94220831 13.5730665,6.11570485 Z", "id", "Fill-2", "fill", "#FFFFFF"], ["data-text", "Enter VR", 3, "click"], ["width", "19px", "height", "19px", "viewBox", "0 0 17 10", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["id", "Page-1", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "VRon", "fill", "#FFFFFF", "fill-rule", "nonzero"], ["d", "M15.7856977,0.02395184 L15.8915734,0.02395184 C16.5037405,0.02395184 17,0.520211324 17,1.13237842 L17,1.54663675 L17,8.8915038 C17,9.5034193 16.4560011,10 15.7856977,10 L12.0095825,10 C9.98324439,7.1593807 8.80676009,5.741338 8.48012959,5.74587199 C8.16206045,5.75028714 7.01003321,7.1683298 5.02404785,10 L1.21426911,10 C0.543965735,10 3.32031236e-05,9.5034193 3.32031236e-05,8.8915038 L3.32031236e-05,1.54663675 L3.32031236e-05,1.13237842 L3.32031236e-05,1.13237842 C3.32031236e-05,0.520211324 0.496292687,0.02395184 1.10845978,0.02395184 L1.21426911,0.02395184 L15.7856977,0.02395184 Z M4.5,6 C5.32842712,6 6,5.32842712 6,4.5 C6,3.67157288 5.32842712,3 4.5,3 C3.67157288,3 3,3.67157288 3,4.5 C3,5.32842712 3.67157288,6 4.5,6 Z M12.5,6 C13.3284271,6 14,5.32842712 14,4.5 C14,3.67157288 13.3284271,3 12.5,3 C11.6715729,3 11,3.67157288 11,4.5 C11,5.32842712 11.6715729,6 12.5,6 Z", "id", "Fill-1"], ["data-text", "Exit VR", 3, "click"], ["id", "icons/minis/VRon-Copy", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "Group-7-Copy", "transform", "translate(1.000000, 3.000000)", "fill", "#FFFFFF"], ["d", "M15.7856977,3.02395184 L17,3.02395184 L17,4.13237842 L17,4.54663675 L17,11.8915038 C17,12.5034193 16.4560011,13 15.7856977,13 L12.0095825,13 C9.98324439,10.1593807 8.80676009,8.741338 8.48012959,8.74587199 C8.16206045,8.75028714 7.01003321,10.1683298 5.02404785,13 L1.21426911,13 C0.543965735,13 3.32031236e-05,12.5034193 3.32031236e-05,11.8915038 L3.32031236e-05,4.54663675 L3.32031236e-05,4.13237842 L3.32031236e-05,3.02395184 L1.21426911,3.02395184 L15.7856977,3.02395184 Z M4.5,9 C5.32842712,9 6,8.32842712 6,7.5 C6,6.67157288 5.32842712,6 4.5,6 C3.67157288,6 3,6.67157288 3,7.5 C3,8.32842712 3.67157288,9 4.5,9 Z M12.5,9 C13.3284271,9 14,8.32842712 14,7.5 C14,6.67157288 13.3284271,6 12.5,6 C11.6715729,6 11,6.67157288 11,7.5 C11,8.32842712 11.6715729,9 12.5,9 Z M2.5486669,0 L14.420089,0 C14.7977406,0 15.1613805,0.149260956 15.4374308,0.417695511 L16.9999668,2.00634766 L0,2.00634766 L1.58537972,0.395493117 C1.84682061,0.141306827 2.19106994,0 2.5486669,0 Z", "id", "Fill-1"], ["data-text", "Fullscreen"], [3, "click"], ["id", "icons/minis/screenfull", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M2.04162598,3 L2.04162598,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z M3,4 L16,4 L16,15 L3,15 L3,4 Z", "id", "Rectangle-Copy", "fill", "#FFFFFF", "fill-rule", "nonzero"], ["data-text", "Exit Fullscreen"], ["id", "icons/minis/screensmall", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M11,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 L2.04162598,10 L11,10 L11,16 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z", "id", "Rectangle", "fill", "#FFFFFF", "fill-rule", "nonzero"]], template: function SumerianSceneComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SumerianSceneComponentCore_sumerian_scene_loading_core_2_Template, 1, 3, "sumerian-scene-loading-core", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, SumerianSceneComponentCore_div_3_Template, 10, 20, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.amplifyUI.sumerianSceneContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.amplifyUI.sumerianScene);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: function () { return [ɵngcc1.NgIf, SumerianSceneLoadingComponentCore, ɵngcc1.NgClass]; }, encapsulation: 2 });
SumerianSceneComponentCore.ctorParameters = () => [
    { type: AmplifyService }
];
__decorate([
    Input()
], SumerianSceneComponentCore.prototype, "sceneName", void 0);
__decorate([
    Input()
], SumerianSceneComponentCore.prototype, "data", null);

const template$s = `
<div id="sumerian-scene-container" [ngClass]="amplifyUI.sumerianSceneContainer" data-test="${sumerianScene.container}">
  <div id="sumerian-scene-dom-id" [class]="amplifyUI.sumerianScene" data-test="${sumerianScene.sumerianScene}">
    <sumerian-scene-loading-ionic *ngIf="loading" loadPercentage={{loadPercentage}} sceneName={{sceneName}} data-test="${sumerianScene.loading}"></sumerian-scene-loading-ionic>
  </div>
  <div *ngIf="!loading" class={{amplifyUI.sceneBar}} data-test="${sumerianScene.bar}">
    <span class={{amplifyUI.sceneActions}} data-test="${sumerianScene.actions}">
      <div [ngClass]="[amplifyUI.tooltip, showEnableAudio ? amplifyUI.autoShowTooltip : '']" [attr.data-text]="showEnableAudio ? 'The scene is muted. Click to unmute.' : (muted ? 'Unmute' : 'Mute')" (click)="muted ? setMuted(false) : setMuted(true)">
        <button class={{amplifyUI.actionButton}}>
          <svg *ngIf="muted" width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/volumeOff" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M3.48026899,12.9630494 C3.63825091,12.9630494 3.79237961,13.0108921 3.92264322,13.1003479 L8.77467683,16.8113609 C9.29423971,17.1679383 10,16.7950396 10,16.1637406 L10,3.78619489 C10,3.15489596 9.29423971,2.78199725 8.77467683,3.13857463 L3.92264322,6.84545211 C3.79237961,6.93490793 3.63825091,6.9827506 3.48026899,6.9827506 L1.78294894,6.9827506 C1.3505185,6.9827506 1,7.33409518 1,7.76754476 L1,12.1781306 C1,12.6117048 1.3505185,12.9630494 1.78294894,12.9630494 L3.48026899,12.9630494 Z M17.2118156,7 L15.0918385,9.11997713 L12.9718614,7 L12,7.97174685 L14.1200917,10.091724 L12,12.2118156 L12.9718614,13.1835625 L15.0918385,11.0635854 L17.2118156,13.1835625 L18.1835625,12.2118156 L16.0635854,10.091724 L18.1835625,7.97174685 L17.2118156,7 Z" id="Fill-2" fill="#FFFFFF"></path>
            </g>
          </svg>
          <svg *ngIf="!muted" width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/volumeOn" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M3.48026899,12.9630494 L1.78294894,12.9630494 C1.3505185,12.9630494 1,12.6117048 1,12.1781306 L1,7.76754476 C1,7.33409518 1.3505185,6.9827506 1.78294894,6.9827506 L3.48026899,6.9827506 C3.63825091,6.9827506 3.79237961,6.93490793 3.92264322,6.84545211 L8.77467683,3.13857463 C9.29423971,2.78199725 10,3.15489596 10,3.78619489 L10,16.1637406 C10,16.7950396 9.29423971,17.1679383 8.77467683,16.8113609 L3.92264322,13.1003479 C3.79237961,13.0108921 3.63825091,12.9630494 3.48026899,12.9630494 Z M14.9270376,3.03232286 C15.1729267,3.03232286 15.4040399,3.12815658 15.5777627,3.3022351 C17.3699891,5.09889099 18.3570052,7.48235058 18.3570052,10.0135053 C18.3570052,12.54466 17.3699891,14.9281196 15.5777627,16.7247755 C15.4041045,16.898854 15.1729914,16.9947524 14.9270052,16.9947524 C14.6820861,16.9947524 14.4515549,16.899436 14.2777674,16.7263598 C13.9192316,16.3684383 13.9185203,15.7852882 14.2762477,15.4264291 C15.7222893,13.9769926 16.5186727,12.0545954 16.5186727,10.0135053 C16.5186727,7.97241524 15.7222893,6.05001801 14.2762154,4.60058152 C13.9184879,4.24175473 13.9191992,3.65857229 14.277832,3.30065081 C14.4514256,3.1275746 14.6819567,3.03232286 14.9270376,3.03232286 Z M13.5730665,6.11570485 C14.6133991,7.15574642 15.1862998,8.54003279 15.1862998,10.0134924 C15.1862998,11.4892799 14.6113945,12.8741159 13.5675376,13.9128965 C13.3942351,14.0855848 13.1639626,14.1806425 12.9191727,14.1806425 C12.6727016,14.1806425 12.4412975,14.0844531 12.2677039,13.9097926 C12.0944984,13.7358111 11.9994406,13.5047303 11.9999903,13.2592291 C12.0005723,13.0136956 12.096794,12.7831644 12.2708079,12.6100882 C12.9654406,11.9185917 13.3479995,10.996467 13.3479995,10.0134924 C13.3479995,9.03119677 12.966346,8.1086194 12.2733298,7.4157649 C11.9150203,7.05745543 11.9149233,6.47436998 12.2731358,6.11589885 C12.4467617,5.94224065 12.6775838,5.84666559 12.923085,5.84666559 C13.1685538,5.84666559 13.3993436,5.94220831 13.5730665,6.11570485 Z" id="Fill-2" fill="#FFFFFF"></path>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isVRCapable && !isVRPresentationActive" class={{amplifyUI.tooltip}} data-text="Enter VR" (click)="toggleVRPresentation()">
        <button class={{amplifyUI.actionButton}}>
          <svg width="19px" height="19px" viewBox="0 0 17 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="VRon" fill="#FFFFFF" fill-rule="nonzero">
                <path d="M15.7856977,0.02395184 L15.8915734,0.02395184 C16.5037405,0.02395184 17,0.520211324 17,1.13237842 L17,1.54663675 L17,8.8915038 C17,9.5034193 16.4560011,10 15.7856977,10 L12.0095825,10 C9.98324439,7.1593807 8.80676009,5.741338 8.48012959,5.74587199 C8.16206045,5.75028714 7.01003321,7.1683298 5.02404785,10 L1.21426911,10 C0.543965735,10 3.32031236e-05,9.5034193 3.32031236e-05,8.8915038 L3.32031236e-05,1.54663675 L3.32031236e-05,1.13237842 L3.32031236e-05,1.13237842 C3.32031236e-05,0.520211324 0.496292687,0.02395184 1.10845978,0.02395184 L1.21426911,0.02395184 L15.7856977,0.02395184 Z M4.5,6 C5.32842712,6 6,5.32842712 6,4.5 C6,3.67157288 5.32842712,3 4.5,3 C3.67157288,3 3,3.67157288 3,4.5 C3,5.32842712 3.67157288,6 4.5,6 Z M12.5,6 C13.3284271,6 14,5.32842712 14,4.5 C14,3.67157288 13.3284271,3 12.5,3 C11.6715729,3 11,3.67157288 11,4.5 C11,5.32842712 11.6715729,6 12.5,6 Z" id="Fill-1"></path>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isVRCapable && isVRPresentationActive" class={{amplifyUI.tooltip}} data-text="Exit VR" (click)="toggleVRPresentation()">
        <button class={{amplifyUI.actionButton}}>
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/VRon-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-7-Copy" transform="translate(1.000000, 3.000000)" fill="#FFFFFF">
                <path d="M15.7856977,3.02395184 L17,3.02395184 L17,4.13237842 L17,4.54663675 L17,11.8915038 C17,12.5034193 16.4560011,13 15.7856977,13 L12.0095825,13 C9.98324439,10.1593807 8.80676009,8.741338 8.48012959,8.74587199 C8.16206045,8.75028714 7.01003321,10.1683298 5.02404785,13 L1.21426911,13 C0.543965735,13 3.32031236e-05,12.5034193 3.32031236e-05,11.8915038 L3.32031236e-05,4.54663675 L3.32031236e-05,4.13237842 L3.32031236e-05,3.02395184 L1.21426911,3.02395184 L15.7856977,3.02395184 Z M4.5,9 C5.32842712,9 6,8.32842712 6,7.5 C6,6.67157288 5.32842712,6 4.5,6 C3.67157288,6 3,6.67157288 3,7.5 C3,8.32842712 3.67157288,9 4.5,9 Z M12.5,9 C13.3284271,9 14,8.32842712 14,7.5 C14,6.67157288 13.3284271,6 12.5,6 C11.6715729,6 11,6.67157288 11,7.5 C11,8.32842712 11.6715729,9 12.5,9 Z M2.5486669,0 L14.420089,0 C14.7977406,0 15.1613805,0.149260956 15.4374308,0.417695511 L16.9999668,2.00634766 L0,2.00634766 L1.58537972,0.395493117 C1.84682061,0.141306827 2.19106994,0 2.5486669,0 Z" id="Fill-1"></path>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="!isFullscreen" class={{amplifyUI.tooltip}} data-text="Fullscreen">
        <button class={{amplifyUI.actionButton}} (click)="maximize()">
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/screenfull" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M2.04162598,3 L2.04162598,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z M3,4 L16,4 L16,15 L3,15 L3,4 Z" id="Rectangle-Copy" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
          </svg>
        </button>
      </div>
      <div *ngIf="isFullscreen" class={{amplifyUI.tooltip}} data-text="Exit Fullscreen">
        <button class={{amplifyUI.actionButton}} (click)="minimize()">
          <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="icons/minis/screensmall" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <path d="M11,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 L2.04162598,10 L11,10 L11,16 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z" id="Rectangle" fill="#FFFFFF" fill-rule="nonzero"></path>
            </g>
          </svg>
        </button>
      </div>
    </span>
  </div>
</div>
`;
let SumerianSceneComponentIonic = class SumerianSceneComponentIonic extends SumerianSceneComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
SumerianSceneComponentIonic.ɵfac = function SumerianSceneComponentIonic_Factory(t) { return new (t || SumerianSceneComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
SumerianSceneComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SumerianSceneComponentIonic, selectors: [["sumerian-scene-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [["id", "sumerian-scene-container", "data-test", "sumerian-scene-container", 3, "ngClass"], ["id", "sumerian-scene-dom-id", "data-test", "sumerian-scene"], ["data-test", "sumerian-scene-loading", 3, "loadPercentage", "sceneName", 4, "ngIf"], ["data-test", "sumerian-scene-bar", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-loading", 3, "loadPercentage", "sceneName"], ["data-test", "sumerian-scene-bar"], ["data-test", "sumerian-scene-actions"], [3, "ngClass", "click"], ["width", "19px", "height", "19px", "viewBox", "0 0 19 19", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 4, "ngIf"], ["data-text", "Enter VR", 3, "class", "click", 4, "ngIf"], ["data-text", "Exit VR", 3, "class", "click", 4, "ngIf"], ["data-text", "Fullscreen", 3, "class", 4, "ngIf"], ["data-text", "Exit Fullscreen", 3, "class", 4, "ngIf"], ["width", "19px", "height", "19px", "viewBox", "0 0 19 19", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["id", "icons/minis/volumeOff", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M3.48026899,12.9630494 C3.63825091,12.9630494 3.79237961,13.0108921 3.92264322,13.1003479 L8.77467683,16.8113609 C9.29423971,17.1679383 10,16.7950396 10,16.1637406 L10,3.78619489 C10,3.15489596 9.29423971,2.78199725 8.77467683,3.13857463 L3.92264322,6.84545211 C3.79237961,6.93490793 3.63825091,6.9827506 3.48026899,6.9827506 L1.78294894,6.9827506 C1.3505185,6.9827506 1,7.33409518 1,7.76754476 L1,12.1781306 C1,12.6117048 1.3505185,12.9630494 1.78294894,12.9630494 L3.48026899,12.9630494 Z M17.2118156,7 L15.0918385,9.11997713 L12.9718614,7 L12,7.97174685 L14.1200917,10.091724 L12,12.2118156 L12.9718614,13.1835625 L15.0918385,11.0635854 L17.2118156,13.1835625 L18.1835625,12.2118156 L16.0635854,10.091724 L18.1835625,7.97174685 L17.2118156,7 Z", "id", "Fill-2", "fill", "#FFFFFF"], ["id", "icons/minis/volumeOn", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M3.48026899,12.9630494 L1.78294894,12.9630494 C1.3505185,12.9630494 1,12.6117048 1,12.1781306 L1,7.76754476 C1,7.33409518 1.3505185,6.9827506 1.78294894,6.9827506 L3.48026899,6.9827506 C3.63825091,6.9827506 3.79237961,6.93490793 3.92264322,6.84545211 L8.77467683,3.13857463 C9.29423971,2.78199725 10,3.15489596 10,3.78619489 L10,16.1637406 C10,16.7950396 9.29423971,17.1679383 8.77467683,16.8113609 L3.92264322,13.1003479 C3.79237961,13.0108921 3.63825091,12.9630494 3.48026899,12.9630494 Z M14.9270376,3.03232286 C15.1729267,3.03232286 15.4040399,3.12815658 15.5777627,3.3022351 C17.3699891,5.09889099 18.3570052,7.48235058 18.3570052,10.0135053 C18.3570052,12.54466 17.3699891,14.9281196 15.5777627,16.7247755 C15.4041045,16.898854 15.1729914,16.9947524 14.9270052,16.9947524 C14.6820861,16.9947524 14.4515549,16.899436 14.2777674,16.7263598 C13.9192316,16.3684383 13.9185203,15.7852882 14.2762477,15.4264291 C15.7222893,13.9769926 16.5186727,12.0545954 16.5186727,10.0135053 C16.5186727,7.97241524 15.7222893,6.05001801 14.2762154,4.60058152 C13.9184879,4.24175473 13.9191992,3.65857229 14.277832,3.30065081 C14.4514256,3.1275746 14.6819567,3.03232286 14.9270376,3.03232286 Z M13.5730665,6.11570485 C14.6133991,7.15574642 15.1862998,8.54003279 15.1862998,10.0134924 C15.1862998,11.4892799 14.6113945,12.8741159 13.5675376,13.9128965 C13.3942351,14.0855848 13.1639626,14.1806425 12.9191727,14.1806425 C12.6727016,14.1806425 12.4412975,14.0844531 12.2677039,13.9097926 C12.0944984,13.7358111 11.9994406,13.5047303 11.9999903,13.2592291 C12.0005723,13.0136956 12.096794,12.7831644 12.2708079,12.6100882 C12.9654406,11.9185917 13.3479995,10.996467 13.3479995,10.0134924 C13.3479995,9.03119677 12.966346,8.1086194 12.2733298,7.4157649 C11.9150203,7.05745543 11.9149233,6.47436998 12.2731358,6.11589885 C12.4467617,5.94224065 12.6775838,5.84666559 12.923085,5.84666559 C13.1685538,5.84666559 13.3993436,5.94220831 13.5730665,6.11570485 Z", "id", "Fill-2", "fill", "#FFFFFF"], ["data-text", "Enter VR", 3, "click"], ["width", "19px", "height", "19px", "viewBox", "0 0 17 10", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["id", "Page-1", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "VRon", "fill", "#FFFFFF", "fill-rule", "nonzero"], ["d", "M15.7856977,0.02395184 L15.8915734,0.02395184 C16.5037405,0.02395184 17,0.520211324 17,1.13237842 L17,1.54663675 L17,8.8915038 C17,9.5034193 16.4560011,10 15.7856977,10 L12.0095825,10 C9.98324439,7.1593807 8.80676009,5.741338 8.48012959,5.74587199 C8.16206045,5.75028714 7.01003321,7.1683298 5.02404785,10 L1.21426911,10 C0.543965735,10 3.32031236e-05,9.5034193 3.32031236e-05,8.8915038 L3.32031236e-05,1.54663675 L3.32031236e-05,1.13237842 L3.32031236e-05,1.13237842 C3.32031236e-05,0.520211324 0.496292687,0.02395184 1.10845978,0.02395184 L1.21426911,0.02395184 L15.7856977,0.02395184 Z M4.5,6 C5.32842712,6 6,5.32842712 6,4.5 C6,3.67157288 5.32842712,3 4.5,3 C3.67157288,3 3,3.67157288 3,4.5 C3,5.32842712 3.67157288,6 4.5,6 Z M12.5,6 C13.3284271,6 14,5.32842712 14,4.5 C14,3.67157288 13.3284271,3 12.5,3 C11.6715729,3 11,3.67157288 11,4.5 C11,5.32842712 11.6715729,6 12.5,6 Z", "id", "Fill-1"], ["data-text", "Exit VR", 3, "click"], ["id", "icons/minis/VRon-Copy", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "Group-7-Copy", "transform", "translate(1.000000, 3.000000)", "fill", "#FFFFFF"], ["d", "M15.7856977,3.02395184 L17,3.02395184 L17,4.13237842 L17,4.54663675 L17,11.8915038 C17,12.5034193 16.4560011,13 15.7856977,13 L12.0095825,13 C9.98324439,10.1593807 8.80676009,8.741338 8.48012959,8.74587199 C8.16206045,8.75028714 7.01003321,10.1683298 5.02404785,13 L1.21426911,13 C0.543965735,13 3.32031236e-05,12.5034193 3.32031236e-05,11.8915038 L3.32031236e-05,4.54663675 L3.32031236e-05,4.13237842 L3.32031236e-05,3.02395184 L1.21426911,3.02395184 L15.7856977,3.02395184 Z M4.5,9 C5.32842712,9 6,8.32842712 6,7.5 C6,6.67157288 5.32842712,6 4.5,6 C3.67157288,6 3,6.67157288 3,7.5 C3,8.32842712 3.67157288,9 4.5,9 Z M12.5,9 C13.3284271,9 14,8.32842712 14,7.5 C14,6.67157288 13.3284271,6 12.5,6 C11.6715729,6 11,6.67157288 11,7.5 C11,8.32842712 11.6715729,9 12.5,9 Z M2.5486669,0 L14.420089,0 C14.7977406,0 15.1613805,0.149260956 15.4374308,0.417695511 L16.9999668,2.00634766 L0,2.00634766 L1.58537972,0.395493117 C1.84682061,0.141306827 2.19106994,0 2.5486669,0 Z", "id", "Fill-1"], ["data-text", "Fullscreen"], [3, "click"], ["id", "icons/minis/screenfull", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M2.04162598,3 L2.04162598,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z M3,4 L16,4 L16,15 L3,15 L3,4 Z", "id", "Rectangle-Copy", "fill", "#FFFFFF", "fill-rule", "nonzero"], ["data-text", "Exit Fullscreen"], ["id", "icons/minis/screensmall", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["d", "M11,16 L17.0147705,16 L17.0147705,3 L2.04162598,3 L2.04162598,10 L11,10 L11,16 Z M1,2 L18,2 L18,17 L1,17 L1,2 Z", "id", "Rectangle", "fill", "#FFFFFF", "fill-rule", "nonzero"]], template: function SumerianSceneComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SumerianSceneComponentIonic_sumerian_scene_loading_ionic_2_Template, 1, 2, "sumerian-scene-loading-ionic", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, SumerianSceneComponentIonic_div_3_Template, 10, 20, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.amplifyUI.sumerianSceneContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.amplifyUI.sumerianScene);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, SumerianSceneLoadingComponentIonic]; }, encapsulation: 2 });
SumerianSceneComponentIonic.ctorParameters = () => [
    { type: AmplifyService }
];

let SumerianSceneComponent = class SumerianSceneComponent {
    constructor(componentFactoryResolver, shared) {
        this.componentFactoryResolver = componentFactoryResolver;
        shared.onContainerCreated(container => {
            this.viewContainerRef = container;
            this.loadComponent();
        });
        shared.onContainerDestroyed(() => {
            this.viewContainerRef = undefined;
        });
    }
    ngOnInit() { }
    ngOnDestroy() { }
    loadComponent() {
        const sumerianScene = this.framework && this.framework.toLowerCase() === 'ionic'
            ? new ComponentMount(SumerianSceneComponentIonic, {
                sceneName: this.sceneName,
            })
            : new ComponentMount(SumerianSceneComponentCore, {
                sceneName: this.sceneName,
            });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(sumerianScene.component);
        this.viewContainerRef.clear();
        const componentRef = this.viewContainerRef.createComponent(componentFactory);
        componentRef.instance.data = sumerianScene.data;
    }
};
SumerianSceneComponent.ɵfac = function SumerianSceneComponent_Factory(t) { return new (t || SumerianSceneComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject('dynamic-component-service')); };
SumerianSceneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SumerianSceneComponent, selectors: [["amplify-sumerian-scene"]], inputs: { framework: "framework", sceneName: "sceneName" }, decls: 1, vars: 0, consts: [["component-host", ""]], template: function SumerianSceneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SumerianSceneComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [DynamicComponentDirective], encapsulation: 2 });
SumerianSceneComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: ['dynamic-component-service',] }] }
];
__decorate([
    Input()
], SumerianSceneComponent.prototype, "framework", void 0);
__decorate([
    Input()
], SumerianSceneComponent.prototype, "sceneName", void 0);
SumerianSceneComponent = __decorate([ __param(1, Inject('dynamic-component-service'))
], SumerianSceneComponent);

const template$t = `
<div class={{AmplifyUI.loadingOverlay}}>
  <div class={{AmplifyUI.loadingContainer}}>
    <div class={{AmplifyUI.loadingLogo}} data-test="${sumerianScene.loadingLogo}">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 2000 1195" style="enable-background:new 0 0 2000 1195;" xml:space="preserve">
        <g>
          <path class="st0" d="M1026.8,146.2c-0.7,2.3-1.2,3.7-1.6,5.1C991.8,291,958.5,430.6,925,570.3c-1.6,6.7-3.8,13.3-6.2,19.7
            c-3.9,10.4-12,16.3-22.8,16.5c-26.3,0.5-52.6,0.5-78.9,0c-9.5-0.2-17.3-5.3-21.2-14.2c-4.1-9.2-7.6-18.7-10.6-28.3
            c-51-167.3-101.9-334.6-152.7-502c-2.5-8.4-4.7-16.9-6.2-25.5c-2-11.7,3.8-18.9,15.5-19c24.6-0.2,49.2,0.1,73.8,0.4
            c12,0.2,21.1,5.9,24.8,17.3c5.4,16.3,10.1,32.8,14.4,49.4c33.9,133.3,67.7,266.6,101.5,399.9c0.3,1.3,0.8,2.6,1.5,5
            c0.7-2,1.3-3,1.5-4.1c19.9-84.2,39.7-168.4,59.6-252.7c14.5-61.3,28.9-122.6,43.4-183.8c0.9-3.6,2.1-7.1,3.2-10.6
            c4-13.2,13.5-19.8,26.6-20.1c24.1-0.6,48.2-0.5,72.3,0c12.6,0.2,21.5,7.2,25.1,19.2c3.9,12.9,7.1,26,10.1,39.1
            c32.5,137.8,65,275.6,97.5,413.4c0.3,1.4,0.8,2.8,1.7,5.7c1.7-6.1,3-10.7,4.2-15.3c36.8-142.6,73.6-285.2,110.5-427.8
            c1.4-5.5,3.7-10.8,5.7-16.2c4.5-12,13.8-17.8,26.1-18.1c21.7-0.6,43.5-0.5,65.2-0.7c2.2,0,4.4,0,6.6,0.3c9.9,1,14.9,5.9,14.3,15.9
            c-0.4,7.5-1.8,15.1-4.1,22.3c-33.5,107.9-67.2,215.6-100.9,323.5c-20.5,65.7-41,131.4-61.6,197.1c-1.3,4-2.8,7.9-4.3,11.9
            c-4.9,12.9-14.9,19.1-28.1,19.4c-23.9,0.5-47.9,0.4-71.8,0c-13.6-0.2-23.3-7.1-27.2-20.2c-4.5-15.5-8.3-31.2-12.1-46.9
            c-31.2-129.6-62.3-259.3-93.4-388.9C1028,150.1,1027.5,148.7,1026.8,146.2z"/>
          <path class="st0" d="M995.7,1194.2c-23.1,0-46.2,0.8-69.3-0.2c-25.4-1.1-50.7-3.5-76-5.7c-77.9-7-154.6-20.9-230.3-40.5
            c-68.1-17.6-134.6-40.1-199.4-67.3C330.7,1042.5,245.3,996,164.5,941c-53.7-36.6-104.7-76.7-153-120.1c-3.5-3.1-6.6-6.8-9-10.8
            c-3.5-5.8-3.4-12.1,0.8-17.5c4.3-5.6,10.5-7.4,17.2-5.7c4.5,1.2,8.8,3.3,12.9,5.5c42.2,22.1,83.9,45.3,126.7,66.4
            c63.2,31.2,128.6,57.4,195.1,80.8c68.4,24,137.7,44.8,208.4,60.6c48.4,10.8,97.2,19.9,146,28.7c29.8,5.3,59.9,8.8,89.9,12.3
            c23.4,2.7,46.9,4.6,70.3,6.3c22.8,1.7,45.7,3.3,68.5,4c39.8,1.1,79.5,2.1,119.3,1.8c29.9-0.2,59.9-2,89.8-4
            c26.2-1.7,52.4-3.7,78.4-7.1c46.8-6.2,93.6-12.7,140.1-20.9c99-17.3,196-42.9,290.8-76.1c40.7-14.3,80.6-30.6,120.8-46.1
            c12-4.6,23.6-5.4,34.7,2c11.5,7.7,15.3,22.7,7.6,34.2c-4,6-9.6,11.4-15.4,15.7c-81,59.3-169.6,104.7-262.8,141.3
            c-77,30.2-156,53.6-237,70.3c-37.9,7.8-76.1,13.8-114.3,19.6c-24.7,3.7-49.7,6-74.7,8.2c-22.1,1.9-44.3,3.3-66.5,4.1
            c-17.8,0.7-35.7,0.1-53.6,0.1C995.7,1194.3,995.7,1194.2,995.7,1194.2z"/>
          <path class="st0" d="M1714.8,0c39.2,0.9,85.7,8.5,130.2,26.1c9.3,3.7,17.9,9.3,26.1,15.1c9,6.4,13.3,15.9,13.4,27.1
            c0,12,0.1,23.9,0,35.9c0,2.5-0.4,5.1-1,7.5c-2.1,8.7-7.4,12.7-16.2,11.4c-5.7-0.9-11.6-2.6-16.8-5c-46.6-21.8-95.9-30.1-147-28.3
            c-21.5,0.8-42.6,3.5-62.7,11.9c-37.6,15.6-54.4,54.2-39.7,91c7.1,17.8,21.1,28.8,37.3,37.7c21.4,11.8,44.5,19.1,67.6,26.5
            c31.6,10,63.3,19.7,94.6,30.6c28.5,9.9,55.1,24,76.4,46.1c23.3,24.1,36.4,53.2,39.9,86.5c9.1,86.7-40.5,150.8-109.3,180.7
            c-38.9,16.8-79.7,24.4-122,24.6c-56.9,0.2-112-9.7-164.9-30.7c-9.4-3.8-18.3-9.3-26.9-14.8c-9.7-6.2-13.6-16.1-13.9-27.3
            c-0.4-13-0.3-26-0.1-38.9c0.3-14.9,8.1-21.1,22.5-17.3c8.2,2.2,16.2,5.6,24.1,9c52.7,22.5,107.7,31.7,164.8,29.6
            c24.9-0.9,49.4-4.7,72-16c29.7-14.9,45.7-38.5,44.5-72.4c-0.9-23.7-11.9-41.7-31.7-54.4c-17.2-10.9-36.1-18-55.4-24.1
            c-36.4-11.5-73.1-22.4-109.3-34.6c-30.8-10.4-58.7-26.2-81.4-50.2c-43.4-45.8-56.3-116.8-30.6-172.5c18.1-39.3,48.5-66.6,86.9-85.5
            C1624,6.4,1664.5,0,1714.8,0z"/>
          <path class="st0" d="M1860.6,746.5c33.3,0.4,66.3,2.8,98.5,11.6c8.4,2.3,16.5,5.8,24.6,9.1c7.5,3.1,11.9,9.2,13.5,17.2
            c2.5,12.2,3.1,24.5,2.5,37.1c-1.2,24-5,47.5-10.5,70.8c-12.3,51.3-31.6,99.8-60.1,144.4c-16.5,25.9-36,49.3-59.4,69.2
            c-5.2,4.4-10.7,8.3-17.9,8.4c-6.8,0-10.7-3.5-10.3-10.2c0.2-4.1,1.3-8.3,2.9-12.1c17-42.7,33.7-85.6,47-129.7
            c7.6-25.2,14.3-50.6,16.5-76.9c0.7-8.8,0.1-17.9-1.1-26.7c-1.6-12-9.3-19.8-20.2-24.6c-12.5-5.4-25.8-8.2-39.2-9.1
            c-18.6-1.3-37.4-2.3-56-2c-20.7,0.4-41.3,2.1-62,3.7c-18.8,1.4-37.5,3.3-56.3,5.2c-9.9,1-19.7,2.4-29.5,3.6c-1,0.1-2,0.4-3,0.3
            c-4.8-0.2-9.7-0.8-12.4-5.4c-2.7-4.6-1.8-9.7,1.5-13.2c5.1-5.5,10.6-10.8,16.9-14.9c36.4-24,76.8-38.4,119.4-46.2
            c22.1-4,44.6-5.9,67-8.3C1842.1,746.9,1851.4,746.9,1860.6,746.5z"/>
          <path class="st0" d="M591.6,541.4c-21.4-36.5-29.7-76.2-29.7-117.9c-0.1-70.3,0.1-140.6-0.1-211c-0.1-29.6-3.8-58.8-13-87.1
            c-15.6-48-45.4-83.2-92.4-102.9C424.8,9.3,391.7,3.9,357.9,2c-63.7-3.6-125.3,6.4-184.7,29.3c-11.7,4.5-23,10.3-34.3,16
            c-11.6,5.8-17.3,15.4-17.1,28.6c0.2,12.6-0.1,25.3,0,37.9c0,2.9,0.1,5.8,0.7,8.5c2,9.5,7.9,13.7,17.3,11.2c8.4-2.2,16.8-5,24.9-8.2
            c40.4-15.9,81.7-28.9,125.3-32.1c29.7-2.2,59.3-1.4,88.3,6.5c24.2,6.6,44.8,18.5,57.2,41.5c10.1,18.6,15.1,38.7,16.1,59.5
            c1.3,24.7,1,49.5,1.4,74.3c0,0.8-0.2,1.6-0.3,2.8c-16.1-3.3-31.5-6.6-47.1-9.5c-46.9-8.6-94.1-13.2-141.8-7.7
            c-33.5,3.9-65.4,12.9-94.4,30.5c-37.4,22.6-64.8,53.5-78.2,95.7c-10.9,34.3-11.9,69.4-4.4,104.4c12,56.1,44.4,96,97.9,117.4
            c41.8,16.6,85.2,17.2,128.9,9.5c57.4-10.1,104-39.3,142.3-82.5c1.3-1.5,2.7-2.9,4.3-4.8c1.7,3.4,3.1,6.2,4.5,9
            c10.4,21.4,22.2,42,38.5,59.7c11.2,12.1,24,14.5,37.5,5.8c14.5-9.3,28.8-18.8,42.9-28.6C597.7,567,600.3,556.1,591.6,541.4z
              M448.3,436.2c-7.1,29.5-25.4,50.8-49.1,68.2c-22,16.2-47.4,23.8-73.8,28.5c-20.7,3.6-41.6,4.4-62.3-0.2
            c-35.6-8-59.6-35.5-63.5-72.3c-2.3-21.9-1.9-43.5,7-64.1c11.9-27.6,34-43.2,61.9-51.5c21.4-6.4,43.4-7.9,63.7-7.5
            c41.1,0.2,79.8,5.3,117.9,14.4c1.6,0.4,4.1,2.4,4.1,3.7C454.7,382.5,454.7,409.6,448.3,436.2z"/>
        </g>
      </svg>
    </div>
    <div class={{AmplifyUI.loadingSceneName}} data-test="${sumerianScene.loadingSceneName}">{{sceneName}}</div>
    <div *ngIf="sceneError" class={{AmplifyUI.sceneErrorText}} data-test="${sumerianScene.errorText}">{{sceneError}}</div>
    <div *ngIf="!sceneError" class={{AmplifyUI.loadingBar}} data-test="${sumerianScene.loadingBar}">
      <div class={{AmplifyUI.loadingBarFill}} [ngStyle]="{ 'width': loadPercentage + '%' }"></div>
    </div>
  </div>
</div>
`;
let SumerianSceneLoadingComponentCore = class SumerianSceneLoadingComponentCore {
    constructor() {
        this.AmplifyUI = AmplifyUI;
    }
};
SumerianSceneLoadingComponentCore.ɵfac = function SumerianSceneLoadingComponentCore_Factory(t) { return new (t || SumerianSceneLoadingComponentCore)(); };
SumerianSceneLoadingComponentCore.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SumerianSceneLoadingComponentCore, selectors: [["sumerian-scene-loading-core"]], inputs: { loadPercentage: "loadPercentage", sceneName: "sceneName", sceneError: "sceneError" }, decls: 14, vars: 15, consts: [["data-test", "sumerian-scene-loading-logo"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 2000 1195", 0, "xml", "space", "preserve", 2, "enable-background", "new 0 0 2000 1195"], ["d", "M1026.8,146.2c-0.7,2.3-1.2,3.7-1.6,5.1C991.8,291,958.5,430.6,925,570.3c-1.6,6.7-3.8,13.3-6.2,19.7\n            c-3.9,10.4-12,16.3-22.8,16.5c-26.3,0.5-52.6,0.5-78.9,0c-9.5-0.2-17.3-5.3-21.2-14.2c-4.1-9.2-7.6-18.7-10.6-28.3\n            c-51-167.3-101.9-334.6-152.7-502c-2.5-8.4-4.7-16.9-6.2-25.5c-2-11.7,3.8-18.9,15.5-19c24.6-0.2,49.2,0.1,73.8,0.4\n            c12,0.2,21.1,5.9,24.8,17.3c5.4,16.3,10.1,32.8,14.4,49.4c33.9,133.3,67.7,266.6,101.5,399.9c0.3,1.3,0.8,2.6,1.5,5\n            c0.7-2,1.3-3,1.5-4.1c19.9-84.2,39.7-168.4,59.6-252.7c14.5-61.3,28.9-122.6,43.4-183.8c0.9-3.6,2.1-7.1,3.2-10.6\n            c4-13.2,13.5-19.8,26.6-20.1c24.1-0.6,48.2-0.5,72.3,0c12.6,0.2,21.5,7.2,25.1,19.2c3.9,12.9,7.1,26,10.1,39.1\n            c32.5,137.8,65,275.6,97.5,413.4c0.3,1.4,0.8,2.8,1.7,5.7c1.7-6.1,3-10.7,4.2-15.3c36.8-142.6,73.6-285.2,110.5-427.8\n            c1.4-5.5,3.7-10.8,5.7-16.2c4.5-12,13.8-17.8,26.1-18.1c21.7-0.6,43.5-0.5,65.2-0.7c2.2,0,4.4,0,6.6,0.3c9.9,1,14.9,5.9,14.3,15.9\n            c-0.4,7.5-1.8,15.1-4.1,22.3c-33.5,107.9-67.2,215.6-100.9,323.5c-20.5,65.7-41,131.4-61.6,197.1c-1.3,4-2.8,7.9-4.3,11.9\n            c-4.9,12.9-14.9,19.1-28.1,19.4c-23.9,0.5-47.9,0.4-71.8,0c-13.6-0.2-23.3-7.1-27.2-20.2c-4.5-15.5-8.3-31.2-12.1-46.9\n            c-31.2-129.6-62.3-259.3-93.4-388.9C1028,150.1,1027.5,148.7,1026.8,146.2z", 1, "st0"], ["d", "M995.7,1194.2c-23.1,0-46.2,0.8-69.3-0.2c-25.4-1.1-50.7-3.5-76-5.7c-77.9-7-154.6-20.9-230.3-40.5\n            c-68.1-17.6-134.6-40.1-199.4-67.3C330.7,1042.5,245.3,996,164.5,941c-53.7-36.6-104.7-76.7-153-120.1c-3.5-3.1-6.6-6.8-9-10.8\n            c-3.5-5.8-3.4-12.1,0.8-17.5c4.3-5.6,10.5-7.4,17.2-5.7c4.5,1.2,8.8,3.3,12.9,5.5c42.2,22.1,83.9,45.3,126.7,66.4\n            c63.2,31.2,128.6,57.4,195.1,80.8c68.4,24,137.7,44.8,208.4,60.6c48.4,10.8,97.2,19.9,146,28.7c29.8,5.3,59.9,8.8,89.9,12.3\n            c23.4,2.7,46.9,4.6,70.3,6.3c22.8,1.7,45.7,3.3,68.5,4c39.8,1.1,79.5,2.1,119.3,1.8c29.9-0.2,59.9-2,89.8-4\n            c26.2-1.7,52.4-3.7,78.4-7.1c46.8-6.2,93.6-12.7,140.1-20.9c99-17.3,196-42.9,290.8-76.1c40.7-14.3,80.6-30.6,120.8-46.1\n            c12-4.6,23.6-5.4,34.7,2c11.5,7.7,15.3,22.7,7.6,34.2c-4,6-9.6,11.4-15.4,15.7c-81,59.3-169.6,104.7-262.8,141.3\n            c-77,30.2-156,53.6-237,70.3c-37.9,7.8-76.1,13.8-114.3,19.6c-24.7,3.7-49.7,6-74.7,8.2c-22.1,1.9-44.3,3.3-66.5,4.1\n            c-17.8,0.7-35.7,0.1-53.6,0.1C995.7,1194.3,995.7,1194.2,995.7,1194.2z", 1, "st0"], ["d", "M1714.8,0c39.2,0.9,85.7,8.5,130.2,26.1c9.3,3.7,17.9,9.3,26.1,15.1c9,6.4,13.3,15.9,13.4,27.1\n            c0,12,0.1,23.9,0,35.9c0,2.5-0.4,5.1-1,7.5c-2.1,8.7-7.4,12.7-16.2,11.4c-5.7-0.9-11.6-2.6-16.8-5c-46.6-21.8-95.9-30.1-147-28.3\n            c-21.5,0.8-42.6,3.5-62.7,11.9c-37.6,15.6-54.4,54.2-39.7,91c7.1,17.8,21.1,28.8,37.3,37.7c21.4,11.8,44.5,19.1,67.6,26.5\n            c31.6,10,63.3,19.7,94.6,30.6c28.5,9.9,55.1,24,76.4,46.1c23.3,24.1,36.4,53.2,39.9,86.5c9.1,86.7-40.5,150.8-109.3,180.7\n            c-38.9,16.8-79.7,24.4-122,24.6c-56.9,0.2-112-9.7-164.9-30.7c-9.4-3.8-18.3-9.3-26.9-14.8c-9.7-6.2-13.6-16.1-13.9-27.3\n            c-0.4-13-0.3-26-0.1-38.9c0.3-14.9,8.1-21.1,22.5-17.3c8.2,2.2,16.2,5.6,24.1,9c52.7,22.5,107.7,31.7,164.8,29.6\n            c24.9-0.9,49.4-4.7,72-16c29.7-14.9,45.7-38.5,44.5-72.4c-0.9-23.7-11.9-41.7-31.7-54.4c-17.2-10.9-36.1-18-55.4-24.1\n            c-36.4-11.5-73.1-22.4-109.3-34.6c-30.8-10.4-58.7-26.2-81.4-50.2c-43.4-45.8-56.3-116.8-30.6-172.5c18.1-39.3,48.5-66.6,86.9-85.5\n            C1624,6.4,1664.5,0,1714.8,0z", 1, "st0"], ["d", "M1860.6,746.5c33.3,0.4,66.3,2.8,98.5,11.6c8.4,2.3,16.5,5.8,24.6,9.1c7.5,3.1,11.9,9.2,13.5,17.2\n            c2.5,12.2,3.1,24.5,2.5,37.1c-1.2,24-5,47.5-10.5,70.8c-12.3,51.3-31.6,99.8-60.1,144.4c-16.5,25.9-36,49.3-59.4,69.2\n            c-5.2,4.4-10.7,8.3-17.9,8.4c-6.8,0-10.7-3.5-10.3-10.2c0.2-4.1,1.3-8.3,2.9-12.1c17-42.7,33.7-85.6,47-129.7\n            c7.6-25.2,14.3-50.6,16.5-76.9c0.7-8.8,0.1-17.9-1.1-26.7c-1.6-12-9.3-19.8-20.2-24.6c-12.5-5.4-25.8-8.2-39.2-9.1\n            c-18.6-1.3-37.4-2.3-56-2c-20.7,0.4-41.3,2.1-62,3.7c-18.8,1.4-37.5,3.3-56.3,5.2c-9.9,1-19.7,2.4-29.5,3.6c-1,0.1-2,0.4-3,0.3\n            c-4.8-0.2-9.7-0.8-12.4-5.4c-2.7-4.6-1.8-9.7,1.5-13.2c5.1-5.5,10.6-10.8,16.9-14.9c36.4-24,76.8-38.4,119.4-46.2\n            c22.1-4,44.6-5.9,67-8.3C1842.1,746.9,1851.4,746.9,1860.6,746.5z", 1, "st0"], ["d", "M591.6,541.4c-21.4-36.5-29.7-76.2-29.7-117.9c-0.1-70.3,0.1-140.6-0.1-211c-0.1-29.6-3.8-58.8-13-87.1\n            c-15.6-48-45.4-83.2-92.4-102.9C424.8,9.3,391.7,3.9,357.9,2c-63.7-3.6-125.3,6.4-184.7,29.3c-11.7,4.5-23,10.3-34.3,16\n            c-11.6,5.8-17.3,15.4-17.1,28.6c0.2,12.6-0.1,25.3,0,37.9c0,2.9,0.1,5.8,0.7,8.5c2,9.5,7.9,13.7,17.3,11.2c8.4-2.2,16.8-5,24.9-8.2\n            c40.4-15.9,81.7-28.9,125.3-32.1c29.7-2.2,59.3-1.4,88.3,6.5c24.2,6.6,44.8,18.5,57.2,41.5c10.1,18.6,15.1,38.7,16.1,59.5\n            c1.3,24.7,1,49.5,1.4,74.3c0,0.8-0.2,1.6-0.3,2.8c-16.1-3.3-31.5-6.6-47.1-9.5c-46.9-8.6-94.1-13.2-141.8-7.7\n            c-33.5,3.9-65.4,12.9-94.4,30.5c-37.4,22.6-64.8,53.5-78.2,95.7c-10.9,34.3-11.9,69.4-4.4,104.4c12,56.1,44.4,96,97.9,117.4\n            c41.8,16.6,85.2,17.2,128.9,9.5c57.4-10.1,104-39.3,142.3-82.5c1.3-1.5,2.7-2.9,4.3-4.8c1.7,3.4,3.1,6.2,4.5,9\n            c10.4,21.4,22.2,42,38.5,59.7c11.2,12.1,24,14.5,37.5,5.8c14.5-9.3,28.8-18.8,42.9-28.6C597.7,567,600.3,556.1,591.6,541.4z\n              M448.3,436.2c-7.1,29.5-25.4,50.8-49.1,68.2c-22,16.2-47.4,23.8-73.8,28.5c-20.7,3.6-41.6,4.4-62.3-0.2\n            c-35.6-8-59.6-35.5-63.5-72.3c-2.3-21.9-1.9-43.5,7-64.1c11.9-27.6,34-43.2,61.9-51.5c21.4-6.4,43.4-7.9,63.7-7.5\n            c41.1,0.2,79.8,5.3,117.9,14.4c1.6,0.4,4.1,2.4,4.1,3.7C454.7,382.5,454.7,409.6,448.3,436.2z", 1, "st0"], ["data-test", "sumerian-scene-loading-scene-name"], ["data-test", "sumerian-scene-error-text", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-loading-bar", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-error-text"], ["data-test", "sumerian-scene-loading-bar"], [3, "ngStyle"]], template: function SumerianSceneLoadingComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 1);
        ɵngcc0.ɵɵelementStart(4, "g");
        ɵngcc0.ɵɵelement(5, "path", 2);
        ɵngcc0.ɵɵelement(6, "path", 3);
        ɵngcc0.ɵɵelement(7, "path", 4);
        ɵngcc0.ɵɵelement(8, "path", 5);
        ɵngcc0.ɵɵelement(9, "path", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, SumerianSceneLoadingComponentCore_div_12_Template, 2, 4, "div", 8);
        ɵngcc0.ɵɵtemplate(13, SumerianSceneLoadingComponentCore_div_13_Template, 2, 9, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingOverlay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingLogo);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingSceneName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.sceneName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sceneError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sceneError);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgStyle], encapsulation: 2 });
__decorate([
    Input()
], SumerianSceneLoadingComponentCore.prototype, "loadPercentage", void 0);
__decorate([
    Input()
], SumerianSceneLoadingComponentCore.prototype, "sceneName", void 0);
__decorate([
    Input()
], SumerianSceneLoadingComponentCore.prototype, "sceneError", void 0);

const DynamicComponentService = {
    createListeners: [],
    destroyListeners: [],
    onContainerCreated(fn) {
        this.createListeners.push(fn);
    },
    onContainerDestroyed(fn) {
        this.destroyListeners.push(fn);
    },
    registerContainer(container) {
        this.createListeners.forEach(fn => {
            fn(container);
        });
    },
    destroyContainer(container) {
        this.destroyListeners.forEach(fn => {
            fn(container);
        });
    },
};

/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable:max-line-length
const components = [
    AuthenticatorComponent,
    AuthenticatorComponentCore,
    ConfirmSignInComponent,
    ConfirmSignInComponentCore,
    ConfirmSignUpComponent,
    ConfirmSignUpComponentCore,
    SignInComponent,
    SignInComponentCore,
    SignUpComponent,
    SignUpComponentCore,
    RequireNewPasswordComponent,
    RequireNewPasswordComponentCore,
    GreetingComponent,
    GreetingComponentCore,
    ForgotPasswordComponent,
    ForgotPasswordComponentCore,
    UsernameFieldComponentCore,
    PhoneFieldComponentCore,
    S3AlbumComponent,
    S3AlbumComponentCore,
    S3ImageComponent,
    S3ImageComponentCore,
    PhotoPickerComponent,
    PhotoPickerComponentCore,
    ChatBotComponent,
    ChatbotComponentCore,
    FormComponent,
    SumerianSceneComponent,
    SumerianSceneComponentCore,
    SumerianSceneLoadingComponentCore,
];
const ɵ0 = DynamicComponentService;
let AmplifyAngularModule = class AmplifyAngularModule {
};
AmplifyAngularModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AmplifyAngularModule });
AmplifyAngularModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AmplifyAngularModule_Factory(t) { return new (t || AmplifyAngularModule)(); }, providers: [
        {
            provide: 'dynamic-component-service',
            useValue: ɵ0
        },
    ], imports: [[CommonModule, FormsModule]] });

// tslint:disable
const template$u = `
<ion-grid class="amplify-ionic-grid-padding-left">
    <ion-row>
        <ion-col size="6" class="amplify-ionic-grid-padding-left">
            <ion-label class="amplify-input-label push-right"
                position="stacked" 
                for="localPhoneNumberField">
                {{ this.amplifyService.i18n().get(this._label) }}
                <span *ngIf="_required">*</span>
            </ion-label>
            <ion-select 
            #countryCodeField
            name="countryCode"
            class="amplify-select-phone-country"
            [value]="_country_code"
            (ionChange)="setCountryCode($event.target.value)"
            data-test="${auth.genericAttrs.dialCodeSelect}">
            <ion-select-option *ngFor="let country of _countries"
            value={{country.value}}>
                {{country.label}}
            </ion-select-option>
            </ion-select>
        </ion-col>
        <ion-col size="6">
            <ion-label class="amplify-input-label push-right">&nbsp;</ion-label>
            <ion-input
            #localPhoneNumberField
            class="amplify-form-input-phone-ionic"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            name="local_phone_number"
            type="tel"
            (ionChange)="setLocalPhoneNumber($event.target.value)"
            data-test="${auth.genericAttrs.phoneNumberInput}"
            ></ion-input>
        </ion-col>
    </ion-row>
</ion-grid>`;
let PhoneFieldComponentIonic = class PhoneFieldComponentIonic extends PhoneFieldComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
PhoneFieldComponentIonic.ɵfac = function PhoneFieldComponentIonic_Factory(t) { return new (t || PhoneFieldComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
PhoneFieldComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PhoneFieldComponentIonic, selectors: [["amplify-auth-phone-field-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 5, consts: [[1, "amplify-ionic-grid-padding-left"], ["size", "6", 1, "amplify-ionic-grid-padding-left"], ["position", "stacked", "for", "localPhoneNumberField", 1, "amplify-input-label", "push-right"], [4, "ngIf"], ["name", "countryCode", "data-test", "dial-code-select", 1, "amplify-select-phone-country", 3, "value", "ionChange"], ["countryCodeField", ""], [3, "value", 4, "ngFor", "ngForOf"], ["size", "6"], [1, "amplify-input-label", "push-right"], ["name", "local_phone_number", "type", "tel", "data-test", "phone-number-input", 1, "amplify-form-input-phone-ionic", 3, "placeholder", "ionChange"], ["localPhoneNumberField", ""], [3, "value"]], template: function PhoneFieldComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ion-grid", 0);
        ɵngcc0.ɵɵelementStart(1, "ion-row");
        ɵngcc0.ɵɵelementStart(2, "ion-col", 1);
        ɵngcc0.ɵɵelementStart(3, "ion-label", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵtemplate(5, PhoneFieldComponentIonic_span_5_Template, 2, 0, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "ion-select", 4, 5);
        ɵngcc0.ɵɵlistener("ionChange", function PhoneFieldComponentIonic_Template_ion_select_ionChange_6_listener($event) { return ctx.setCountryCode($event.target.value); });
        ɵngcc0.ɵɵtemplate(8, PhoneFieldComponentIonic_ion_select_option_8_Template, 2, 2, "ion-select-option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "ion-col", 7);
        ɵngcc0.ɵɵelementStart(10, "ion-label", 8);
        ɵngcc0.ɵɵtext(11, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "ion-input", 9, 10);
        ɵngcc0.ɵɵlistener("ionChange", function PhoneFieldComponentIonic_Template_ion_input_ionChange_12_listener($event) { return ctx.setLocalPhoneNumber($event.target.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.amplifyService.i18n().get(ctx._label), " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._required);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx._country_code);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._countries);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.amplifyService.i18n().get(ctx.getPlaceholder()));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2 });
PhoneFieldComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
PhoneFieldComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], PhoneFieldComponentIonic);

// tslint:disable
const template$v = `

    <ion-item lines="none" *ngIf="this._usernameAttributes === 'email'">
        <ion-label class="amplify-input-label amplify-input-label-ionic" for="emailField" position="stacked">{{ this.amplifyService.i18n().get('Email *') }}</ion-label>
        <ion-input type="text"
            #emailField
            class="amplify-form-input"
            type="email"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setEmail($event.target.value)"
            data-test="${auth.genericAttrs.emailInput}"
        ></ion-input>
    </ion-item> 
    <ion-item lines="none" *ngIf="this._usernameAttributes === 'phone_number'">
       <amplify-auth-phone-field-ionic
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
        ></amplify-auth-phone-field-ionic>
    </ion-item>
    <ion-item lines="none" *ngIf="this._usernameAttributes !== 'email' && this._usernameAttributes !== 'phone_number'">
        <ion-label class="amplify-input-label amplify-input-label-ionic" for="usernameField" position="stacked">{{ this.amplifyService.i18n().get(getUsernameLabel()) }} *</ion-label>
        <ion-input type="text"
            #usernameField
            class="amplify-form-input"
            type="text"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setUsername($event.target.value)"
            data-test="${auth.genericAttrs.usernameInput}"
        ></ion-input>
    </ion-item>

`;
let UsernameFieldComponentIonic = class UsernameFieldComponentIonic extends UsernameFieldComponentCore {
    constructor(amplifyService) {
        super(amplifyService);
        this.amplifyService = amplifyService;
    }
};
UsernameFieldComponentIonic.ɵfac = function UsernameFieldComponentIonic_Factory(t) { return new (t || UsernameFieldComponentIonic)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
UsernameFieldComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UsernameFieldComponentIonic, selectors: [["amplify-auth-username-field-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [["lines", "none", 4, "ngIf"], ["lines", "none"], ["for", "emailField", "position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "type", "email", "data-test", "email-input", 1, "amplify-form-input", 3, "placeholder", "keyup"], ["emailField", ""], [3, "phoneFieldChanged"], ["for", "usernameField", "position", "stacked", 1, "amplify-input-label", "amplify-input-label-ionic"], ["type", "text", "type", "text", "data-test", "username-input", 1, "amplify-form-input", 3, "placeholder", "keyup"], ["usernameField", ""]], template: function UsernameFieldComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, UsernameFieldComponentIonic_ion_item_0_Template, 5, 2, "ion-item", 0);
        ɵngcc0.ɵɵtemplate(1, UsernameFieldComponentIonic_ion_item_1_Template, 2, 0, "ion-item", 0);
        ɵngcc0.ɵɵtemplate(2, UsernameFieldComponentIonic_ion_item_2_Template, 5, 2, "ion-item", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes === "email");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes === "phone_number");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._usernameAttributes !== "email" && ctx._usernameAttributes !== "phone_number");
    } }, directives: [ɵngcc1.NgIf, PhoneFieldComponentIonic], encapsulation: 2 });
UsernameFieldComponentIonic.ctorParameters = () => [
    { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] }] }
];
UsernameFieldComponentIonic = __decorate([ __param(0, Inject(AmplifyService))
], UsernameFieldComponentIonic);

const template$w = `
<div class={{AmplifyUI.loadingOverlay}}>
  <div class={{AmplifyUI.loadingContainer}}>
    <div class={{AmplifyUI.loadingLogo}} data-test="${sumerianScene.loadingLogo}">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 2000 1195" style="enable-background:new 0 0 2000 1195;" xml:space="preserve">
        <g>
          <path class="st0" d="M1026.8,146.2c-0.7,2.3-1.2,3.7-1.6,5.1C991.8,291,958.5,430.6,925,570.3c-1.6,6.7-3.8,13.3-6.2,19.7
            c-3.9,10.4-12,16.3-22.8,16.5c-26.3,0.5-52.6,0.5-78.9,0c-9.5-0.2-17.3-5.3-21.2-14.2c-4.1-9.2-7.6-18.7-10.6-28.3
            c-51-167.3-101.9-334.6-152.7-502c-2.5-8.4-4.7-16.9-6.2-25.5c-2-11.7,3.8-18.9,15.5-19c24.6-0.2,49.2,0.1,73.8,0.4
            c12,0.2,21.1,5.9,24.8,17.3c5.4,16.3,10.1,32.8,14.4,49.4c33.9,133.3,67.7,266.6,101.5,399.9c0.3,1.3,0.8,2.6,1.5,5
            c0.7-2,1.3-3,1.5-4.1c19.9-84.2,39.7-168.4,59.6-252.7c14.5-61.3,28.9-122.6,43.4-183.8c0.9-3.6,2.1-7.1,3.2-10.6
            c4-13.2,13.5-19.8,26.6-20.1c24.1-0.6,48.2-0.5,72.3,0c12.6,0.2,21.5,7.2,25.1,19.2c3.9,12.9,7.1,26,10.1,39.1
            c32.5,137.8,65,275.6,97.5,413.4c0.3,1.4,0.8,2.8,1.7,5.7c1.7-6.1,3-10.7,4.2-15.3c36.8-142.6,73.6-285.2,110.5-427.8
            c1.4-5.5,3.7-10.8,5.7-16.2c4.5-12,13.8-17.8,26.1-18.1c21.7-0.6,43.5-0.5,65.2-0.7c2.2,0,4.4,0,6.6,0.3c9.9,1,14.9,5.9,14.3,15.9
            c-0.4,7.5-1.8,15.1-4.1,22.3c-33.5,107.9-67.2,215.6-100.9,323.5c-20.5,65.7-41,131.4-61.6,197.1c-1.3,4-2.8,7.9-4.3,11.9
            c-4.9,12.9-14.9,19.1-28.1,19.4c-23.9,0.5-47.9,0.4-71.8,0c-13.6-0.2-23.3-7.1-27.2-20.2c-4.5-15.5-8.3-31.2-12.1-46.9
            c-31.2-129.6-62.3-259.3-93.4-388.9C1028,150.1,1027.5,148.7,1026.8,146.2z"/>
          <path class="st0" d="M995.7,1194.2c-23.1,0-46.2,0.8-69.3-0.2c-25.4-1.1-50.7-3.5-76-5.7c-77.9-7-154.6-20.9-230.3-40.5
            c-68.1-17.6-134.6-40.1-199.4-67.3C330.7,1042.5,245.3,996,164.5,941c-53.7-36.6-104.7-76.7-153-120.1c-3.5-3.1-6.6-6.8-9-10.8
            c-3.5-5.8-3.4-12.1,0.8-17.5c4.3-5.6,10.5-7.4,17.2-5.7c4.5,1.2,8.8,3.3,12.9,5.5c42.2,22.1,83.9,45.3,126.7,66.4
            c63.2,31.2,128.6,57.4,195.1,80.8c68.4,24,137.7,44.8,208.4,60.6c48.4,10.8,97.2,19.9,146,28.7c29.8,5.3,59.9,8.8,89.9,12.3
            c23.4,2.7,46.9,4.6,70.3,6.3c22.8,1.7,45.7,3.3,68.5,4c39.8,1.1,79.5,2.1,119.3,1.8c29.9-0.2,59.9-2,89.8-4
            c26.2-1.7,52.4-3.7,78.4-7.1c46.8-6.2,93.6-12.7,140.1-20.9c99-17.3,196-42.9,290.8-76.1c40.7-14.3,80.6-30.6,120.8-46.1
            c12-4.6,23.6-5.4,34.7,2c11.5,7.7,15.3,22.7,7.6,34.2c-4,6-9.6,11.4-15.4,15.7c-81,59.3-169.6,104.7-262.8,141.3
            c-77,30.2-156,53.6-237,70.3c-37.9,7.8-76.1,13.8-114.3,19.6c-24.7,3.7-49.7,6-74.7,8.2c-22.1,1.9-44.3,3.3-66.5,4.1
            c-17.8,0.7-35.7,0.1-53.6,0.1C995.7,1194.3,995.7,1194.2,995.7,1194.2z"/>
          <path class="st0" d="M1714.8,0c39.2,0.9,85.7,8.5,130.2,26.1c9.3,3.7,17.9,9.3,26.1,15.1c9,6.4,13.3,15.9,13.4,27.1
            c0,12,0.1,23.9,0,35.9c0,2.5-0.4,5.1-1,7.5c-2.1,8.7-7.4,12.7-16.2,11.4c-5.7-0.9-11.6-2.6-16.8-5c-46.6-21.8-95.9-30.1-147-28.3
            c-21.5,0.8-42.6,3.5-62.7,11.9c-37.6,15.6-54.4,54.2-39.7,91c7.1,17.8,21.1,28.8,37.3,37.7c21.4,11.8,44.5,19.1,67.6,26.5
            c31.6,10,63.3,19.7,94.6,30.6c28.5,9.9,55.1,24,76.4,46.1c23.3,24.1,36.4,53.2,39.9,86.5c9.1,86.7-40.5,150.8-109.3,180.7
            c-38.9,16.8-79.7,24.4-122,24.6c-56.9,0.2-112-9.7-164.9-30.7c-9.4-3.8-18.3-9.3-26.9-14.8c-9.7-6.2-13.6-16.1-13.9-27.3
            c-0.4-13-0.3-26-0.1-38.9c0.3-14.9,8.1-21.1,22.5-17.3c8.2,2.2,16.2,5.6,24.1,9c52.7,22.5,107.7,31.7,164.8,29.6
            c24.9-0.9,49.4-4.7,72-16c29.7-14.9,45.7-38.5,44.5-72.4c-0.9-23.7-11.9-41.7-31.7-54.4c-17.2-10.9-36.1-18-55.4-24.1
            c-36.4-11.5-73.1-22.4-109.3-34.6c-30.8-10.4-58.7-26.2-81.4-50.2c-43.4-45.8-56.3-116.8-30.6-172.5c18.1-39.3,48.5-66.6,86.9-85.5
            C1624,6.4,1664.5,0,1714.8,0z"/>
          <path class="st0" d="M1860.6,746.5c33.3,0.4,66.3,2.8,98.5,11.6c8.4,2.3,16.5,5.8,24.6,9.1c7.5,3.1,11.9,9.2,13.5,17.2
            c2.5,12.2,3.1,24.5,2.5,37.1c-1.2,24-5,47.5-10.5,70.8c-12.3,51.3-31.6,99.8-60.1,144.4c-16.5,25.9-36,49.3-59.4,69.2
            c-5.2,4.4-10.7,8.3-17.9,8.4c-6.8,0-10.7-3.5-10.3-10.2c0.2-4.1,1.3-8.3,2.9-12.1c17-42.7,33.7-85.6,47-129.7
            c7.6-25.2,14.3-50.6,16.5-76.9c0.7-8.8,0.1-17.9-1.1-26.7c-1.6-12-9.3-19.8-20.2-24.6c-12.5-5.4-25.8-8.2-39.2-9.1
            c-18.6-1.3-37.4-2.3-56-2c-20.7,0.4-41.3,2.1-62,3.7c-18.8,1.4-37.5,3.3-56.3,5.2c-9.9,1-19.7,2.4-29.5,3.6c-1,0.1-2,0.4-3,0.3
            c-4.8-0.2-9.7-0.8-12.4-5.4c-2.7-4.6-1.8-9.7,1.5-13.2c5.1-5.5,10.6-10.8,16.9-14.9c36.4-24,76.8-38.4,119.4-46.2
            c22.1-4,44.6-5.9,67-8.3C1842.1,746.9,1851.4,746.9,1860.6,746.5z"/>
          <path class="st0" d="M591.6,541.4c-21.4-36.5-29.7-76.2-29.7-117.9c-0.1-70.3,0.1-140.6-0.1-211c-0.1-29.6-3.8-58.8-13-87.1
            c-15.6-48-45.4-83.2-92.4-102.9C424.8,9.3,391.7,3.9,357.9,2c-63.7-3.6-125.3,6.4-184.7,29.3c-11.7,4.5-23,10.3-34.3,16
            c-11.6,5.8-17.3,15.4-17.1,28.6c0.2,12.6-0.1,25.3,0,37.9c0,2.9,0.1,5.8,0.7,8.5c2,9.5,7.9,13.7,17.3,11.2c8.4-2.2,16.8-5,24.9-8.2
            c40.4-15.9,81.7-28.9,125.3-32.1c29.7-2.2,59.3-1.4,88.3,6.5c24.2,6.6,44.8,18.5,57.2,41.5c10.1,18.6,15.1,38.7,16.1,59.5
            c1.3,24.7,1,49.5,1.4,74.3c0,0.8-0.2,1.6-0.3,2.8c-16.1-3.3-31.5-6.6-47.1-9.5c-46.9-8.6-94.1-13.2-141.8-7.7
            c-33.5,3.9-65.4,12.9-94.4,30.5c-37.4,22.6-64.8,53.5-78.2,95.7c-10.9,34.3-11.9,69.4-4.4,104.4c12,56.1,44.4,96,97.9,117.4
            c41.8,16.6,85.2,17.2,128.9,9.5c57.4-10.1,104-39.3,142.3-82.5c1.3-1.5,2.7-2.9,4.3-4.8c1.7,3.4,3.1,6.2,4.5,9
            c10.4,21.4,22.2,42,38.5,59.7c11.2,12.1,24,14.5,37.5,5.8c14.5-9.3,28.8-18.8,42.9-28.6C597.7,567,600.3,556.1,591.6,541.4z
              M448.3,436.2c-7.1,29.5-25.4,50.8-49.1,68.2c-22,16.2-47.4,23.8-73.8,28.5c-20.7,3.6-41.6,4.4-62.3-0.2
            c-35.6-8-59.6-35.5-63.5-72.3c-2.3-21.9-1.9-43.5,7-64.1c11.9-27.6,34-43.2,61.9-51.5c21.4-6.4,43.4-7.9,63.7-7.5
            c41.1,0.2,79.8,5.3,117.9,14.4c1.6,0.4,4.1,2.4,4.1,3.7C454.7,382.5,454.7,409.6,448.3,436.2z"/>
        </g>
      </svg>
    </div>
    <div class={{AmplifyUI.loadingSceneName}} data-test="${sumerianScene.loadingSceneName}">{{sceneName}}</div>
    <div *ngIf="sceneError" class={{AmplifyUI.sceneErrorText}} data-test="${sumerianScene.errorText}">{{sceneError}}</div>
    <div *ngIf="!sceneError" class={{AmplifyUI.loadingBar}} data-test="${sumerianScene.loadingBar}">
      <div class={{AmplifyUI.loadingBarFill}} [ngStyle]="{ 'width': loadPercentage + '%' }"></div>
    </div>
  </div>
</div>
`;
let SumerianSceneLoadingComponentIonic = class SumerianSceneLoadingComponentIonic extends SumerianSceneLoadingComponentCore {
    constructor() {
        super();
    }
};
SumerianSceneLoadingComponentIonic.ɵfac = function SumerianSceneLoadingComponentIonic_Factory(t) { return new (t || SumerianSceneLoadingComponentIonic)(); };
SumerianSceneLoadingComponentIonic.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SumerianSceneLoadingComponentIonic, selectors: [["sumerian-scene-loading-ionic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 15, consts: [["data-test", "sumerian-scene-loading-logo"], ["version", "1.1", "id", "Layer_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 2000 1195", 0, "xml", "space", "preserve", 2, "enable-background", "new 0 0 2000 1195"], ["d", "M1026.8,146.2c-0.7,2.3-1.2,3.7-1.6,5.1C991.8,291,958.5,430.6,925,570.3c-1.6,6.7-3.8,13.3-6.2,19.7\n            c-3.9,10.4-12,16.3-22.8,16.5c-26.3,0.5-52.6,0.5-78.9,0c-9.5-0.2-17.3-5.3-21.2-14.2c-4.1-9.2-7.6-18.7-10.6-28.3\n            c-51-167.3-101.9-334.6-152.7-502c-2.5-8.4-4.7-16.9-6.2-25.5c-2-11.7,3.8-18.9,15.5-19c24.6-0.2,49.2,0.1,73.8,0.4\n            c12,0.2,21.1,5.9,24.8,17.3c5.4,16.3,10.1,32.8,14.4,49.4c33.9,133.3,67.7,266.6,101.5,399.9c0.3,1.3,0.8,2.6,1.5,5\n            c0.7-2,1.3-3,1.5-4.1c19.9-84.2,39.7-168.4,59.6-252.7c14.5-61.3,28.9-122.6,43.4-183.8c0.9-3.6,2.1-7.1,3.2-10.6\n            c4-13.2,13.5-19.8,26.6-20.1c24.1-0.6,48.2-0.5,72.3,0c12.6,0.2,21.5,7.2,25.1,19.2c3.9,12.9,7.1,26,10.1,39.1\n            c32.5,137.8,65,275.6,97.5,413.4c0.3,1.4,0.8,2.8,1.7,5.7c1.7-6.1,3-10.7,4.2-15.3c36.8-142.6,73.6-285.2,110.5-427.8\n            c1.4-5.5,3.7-10.8,5.7-16.2c4.5-12,13.8-17.8,26.1-18.1c21.7-0.6,43.5-0.5,65.2-0.7c2.2,0,4.4,0,6.6,0.3c9.9,1,14.9,5.9,14.3,15.9\n            c-0.4,7.5-1.8,15.1-4.1,22.3c-33.5,107.9-67.2,215.6-100.9,323.5c-20.5,65.7-41,131.4-61.6,197.1c-1.3,4-2.8,7.9-4.3,11.9\n            c-4.9,12.9-14.9,19.1-28.1,19.4c-23.9,0.5-47.9,0.4-71.8,0c-13.6-0.2-23.3-7.1-27.2-20.2c-4.5-15.5-8.3-31.2-12.1-46.9\n            c-31.2-129.6-62.3-259.3-93.4-388.9C1028,150.1,1027.5,148.7,1026.8,146.2z", 1, "st0"], ["d", "M995.7,1194.2c-23.1,0-46.2,0.8-69.3-0.2c-25.4-1.1-50.7-3.5-76-5.7c-77.9-7-154.6-20.9-230.3-40.5\n            c-68.1-17.6-134.6-40.1-199.4-67.3C330.7,1042.5,245.3,996,164.5,941c-53.7-36.6-104.7-76.7-153-120.1c-3.5-3.1-6.6-6.8-9-10.8\n            c-3.5-5.8-3.4-12.1,0.8-17.5c4.3-5.6,10.5-7.4,17.2-5.7c4.5,1.2,8.8,3.3,12.9,5.5c42.2,22.1,83.9,45.3,126.7,66.4\n            c63.2,31.2,128.6,57.4,195.1,80.8c68.4,24,137.7,44.8,208.4,60.6c48.4,10.8,97.2,19.9,146,28.7c29.8,5.3,59.9,8.8,89.9,12.3\n            c23.4,2.7,46.9,4.6,70.3,6.3c22.8,1.7,45.7,3.3,68.5,4c39.8,1.1,79.5,2.1,119.3,1.8c29.9-0.2,59.9-2,89.8-4\n            c26.2-1.7,52.4-3.7,78.4-7.1c46.8-6.2,93.6-12.7,140.1-20.9c99-17.3,196-42.9,290.8-76.1c40.7-14.3,80.6-30.6,120.8-46.1\n            c12-4.6,23.6-5.4,34.7,2c11.5,7.7,15.3,22.7,7.6,34.2c-4,6-9.6,11.4-15.4,15.7c-81,59.3-169.6,104.7-262.8,141.3\n            c-77,30.2-156,53.6-237,70.3c-37.9,7.8-76.1,13.8-114.3,19.6c-24.7,3.7-49.7,6-74.7,8.2c-22.1,1.9-44.3,3.3-66.5,4.1\n            c-17.8,0.7-35.7,0.1-53.6,0.1C995.7,1194.3,995.7,1194.2,995.7,1194.2z", 1, "st0"], ["d", "M1714.8,0c39.2,0.9,85.7,8.5,130.2,26.1c9.3,3.7,17.9,9.3,26.1,15.1c9,6.4,13.3,15.9,13.4,27.1\n            c0,12,0.1,23.9,0,35.9c0,2.5-0.4,5.1-1,7.5c-2.1,8.7-7.4,12.7-16.2,11.4c-5.7-0.9-11.6-2.6-16.8-5c-46.6-21.8-95.9-30.1-147-28.3\n            c-21.5,0.8-42.6,3.5-62.7,11.9c-37.6,15.6-54.4,54.2-39.7,91c7.1,17.8,21.1,28.8,37.3,37.7c21.4,11.8,44.5,19.1,67.6,26.5\n            c31.6,10,63.3,19.7,94.6,30.6c28.5,9.9,55.1,24,76.4,46.1c23.3,24.1,36.4,53.2,39.9,86.5c9.1,86.7-40.5,150.8-109.3,180.7\n            c-38.9,16.8-79.7,24.4-122,24.6c-56.9,0.2-112-9.7-164.9-30.7c-9.4-3.8-18.3-9.3-26.9-14.8c-9.7-6.2-13.6-16.1-13.9-27.3\n            c-0.4-13-0.3-26-0.1-38.9c0.3-14.9,8.1-21.1,22.5-17.3c8.2,2.2,16.2,5.6,24.1,9c52.7,22.5,107.7,31.7,164.8,29.6\n            c24.9-0.9,49.4-4.7,72-16c29.7-14.9,45.7-38.5,44.5-72.4c-0.9-23.7-11.9-41.7-31.7-54.4c-17.2-10.9-36.1-18-55.4-24.1\n            c-36.4-11.5-73.1-22.4-109.3-34.6c-30.8-10.4-58.7-26.2-81.4-50.2c-43.4-45.8-56.3-116.8-30.6-172.5c18.1-39.3,48.5-66.6,86.9-85.5\n            C1624,6.4,1664.5,0,1714.8,0z", 1, "st0"], ["d", "M1860.6,746.5c33.3,0.4,66.3,2.8,98.5,11.6c8.4,2.3,16.5,5.8,24.6,9.1c7.5,3.1,11.9,9.2,13.5,17.2\n            c2.5,12.2,3.1,24.5,2.5,37.1c-1.2,24-5,47.5-10.5,70.8c-12.3,51.3-31.6,99.8-60.1,144.4c-16.5,25.9-36,49.3-59.4,69.2\n            c-5.2,4.4-10.7,8.3-17.9,8.4c-6.8,0-10.7-3.5-10.3-10.2c0.2-4.1,1.3-8.3,2.9-12.1c17-42.7,33.7-85.6,47-129.7\n            c7.6-25.2,14.3-50.6,16.5-76.9c0.7-8.8,0.1-17.9-1.1-26.7c-1.6-12-9.3-19.8-20.2-24.6c-12.5-5.4-25.8-8.2-39.2-9.1\n            c-18.6-1.3-37.4-2.3-56-2c-20.7,0.4-41.3,2.1-62,3.7c-18.8,1.4-37.5,3.3-56.3,5.2c-9.9,1-19.7,2.4-29.5,3.6c-1,0.1-2,0.4-3,0.3\n            c-4.8-0.2-9.7-0.8-12.4-5.4c-2.7-4.6-1.8-9.7,1.5-13.2c5.1-5.5,10.6-10.8,16.9-14.9c36.4-24,76.8-38.4,119.4-46.2\n            c22.1-4,44.6-5.9,67-8.3C1842.1,746.9,1851.4,746.9,1860.6,746.5z", 1, "st0"], ["d", "M591.6,541.4c-21.4-36.5-29.7-76.2-29.7-117.9c-0.1-70.3,0.1-140.6-0.1-211c-0.1-29.6-3.8-58.8-13-87.1\n            c-15.6-48-45.4-83.2-92.4-102.9C424.8,9.3,391.7,3.9,357.9,2c-63.7-3.6-125.3,6.4-184.7,29.3c-11.7,4.5-23,10.3-34.3,16\n            c-11.6,5.8-17.3,15.4-17.1,28.6c0.2,12.6-0.1,25.3,0,37.9c0,2.9,0.1,5.8,0.7,8.5c2,9.5,7.9,13.7,17.3,11.2c8.4-2.2,16.8-5,24.9-8.2\n            c40.4-15.9,81.7-28.9,125.3-32.1c29.7-2.2,59.3-1.4,88.3,6.5c24.2,6.6,44.8,18.5,57.2,41.5c10.1,18.6,15.1,38.7,16.1,59.5\n            c1.3,24.7,1,49.5,1.4,74.3c0,0.8-0.2,1.6-0.3,2.8c-16.1-3.3-31.5-6.6-47.1-9.5c-46.9-8.6-94.1-13.2-141.8-7.7\n            c-33.5,3.9-65.4,12.9-94.4,30.5c-37.4,22.6-64.8,53.5-78.2,95.7c-10.9,34.3-11.9,69.4-4.4,104.4c12,56.1,44.4,96,97.9,117.4\n            c41.8,16.6,85.2,17.2,128.9,9.5c57.4-10.1,104-39.3,142.3-82.5c1.3-1.5,2.7-2.9,4.3-4.8c1.7,3.4,3.1,6.2,4.5,9\n            c10.4,21.4,22.2,42,38.5,59.7c11.2,12.1,24,14.5,37.5,5.8c14.5-9.3,28.8-18.8,42.9-28.6C597.7,567,600.3,556.1,591.6,541.4z\n              M448.3,436.2c-7.1,29.5-25.4,50.8-49.1,68.2c-22,16.2-47.4,23.8-73.8,28.5c-20.7,3.6-41.6,4.4-62.3-0.2\n            c-35.6-8-59.6-35.5-63.5-72.3c-2.3-21.9-1.9-43.5,7-64.1c11.9-27.6,34-43.2,61.9-51.5c21.4-6.4,43.4-7.9,63.7-7.5\n            c41.1,0.2,79.8,5.3,117.9,14.4c1.6,0.4,4.1,2.4,4.1,3.7C454.7,382.5,454.7,409.6,448.3,436.2z", 1, "st0"], ["data-test", "sumerian-scene-loading-scene-name"], ["data-test", "sumerian-scene-error-text", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-loading-bar", 3, "class", 4, "ngIf"], ["data-test", "sumerian-scene-error-text"], ["data-test", "sumerian-scene-loading-bar"], [3, "ngStyle"]], template: function SumerianSceneLoadingComponentIonic_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 1);
        ɵngcc0.ɵɵelementStart(4, "g");
        ɵngcc0.ɵɵelement(5, "path", 2);
        ɵngcc0.ɵɵelement(6, "path", 3);
        ɵngcc0.ɵɵelement(7, "path", 4);
        ɵngcc0.ɵɵelement(8, "path", 5);
        ɵngcc0.ɵɵelement(9, "path", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, SumerianSceneLoadingComponentIonic_div_12_Template, 2, 4, "div", 8);
        ɵngcc0.ɵɵtemplate(13, SumerianSceneLoadingComponentIonic_div_13_Template, 2, 9, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingOverlay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingLogo);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵclassMap(ctx.AmplifyUI.loadingSceneName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.sceneName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sceneError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sceneError);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgStyle], encapsulation: 2 });

// tslint:disable
// tslint:enable:max-line-length
const components$1 = [
    AuthenticatorIonicComponent,
    ConfirmSignInComponentIonic,
    ConfirmSignUpComponentIonic,
    ForgotPasswordComponentIonic,
    GreetingComponentIonic,
    SignInComponentIonic,
    SignUpComponentIonic,
    UsernameFieldComponentIonic,
    PhoneFieldComponentIonic,
    RequireNewPasswordComponentIonic,
    PhotoPickerIonicComponent,
    S3AlbumComponentIonic,
    S3ImageComponentIonic,
    ChatbotComponentIonic,
    SumerianSceneComponentIonic,
    SumerianSceneLoadingComponentIonic,
];
let AmplifyIonicModule = class AmplifyIonicModule {
};
AmplifyIonicModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AmplifyIonicModule });
AmplifyIonicModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AmplifyIonicModule_Factory(t) { return new (t || AmplifyIonicModule)(); }, providers: [AmplifyService], imports: [[CommonModule, FormsModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AmplifyService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: ['modules']
            }, {
                type: Optional
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticatorComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-authenticator-core',
                template
            }]
    }], function () { return [{ type: AmplifyService }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], signUpConfig: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticatorIonicComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-authenticator-ionic',
                template: template$1
            }]
    }], function () { return [{ type: AmplifyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticatorComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-authenticator',
                template: `
		<div class="amplify-component">
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { hide: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }], framework: [{
            type: Input
        }], signUpConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignInComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-in-core',
                template: template$2
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignInComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-in-ionic',
                template: template$3
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignInComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-in',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignUpComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-up-core',
                template: template$4
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], authState: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignUpComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-up-ionic',
                template: template$5
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfirmSignUpComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-confirm-sign-up',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignInComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-in-core',
                template: template$6
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], authState: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignInComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-in-ionic',
                template: template$7
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignInComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-in',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignUpComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-up-core',
                template: template$8
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }], authState: [{
            type: Input
        }], signUpConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignUpComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-up-ionic',
                template: template$9
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SignUpComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-sign-up',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }], signUpConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RequireNewPasswordComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-require-new-password-core',
                template: template$a
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], authState: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RequireNewPasswordComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-require-new-password-ionic',
                template: template$b
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RequireNewPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-require-new-password',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GreetingComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-greetings-core',
                template: template$c
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GreetingComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-greetings-ionic',
                template: template$d
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GreetingComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-greetings',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-forgot-password-core',
                template: template$e
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { hide: [{
            type: Input
        }], data: [{
            type: Input
        }], authState: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-forgot-password-ionic',
                template: template$f
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ForgotPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-forgot-password',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], hide: [{
            type: Input
        }], framework: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UsernameFieldComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-username-field-core',
                template: template$g
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { usernameFieldChanged: [{
            type: Output
        }], data: [{
            type: Input
        }], usernameAttributes: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhoneFieldComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-phone-field-core',
                template: template$h
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { phoneFieldChanged: [{
            type: Output
        }], data: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], required: [{
            type: Input
        }], defaultCountryCode: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3AlbumComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-album-core',
                template: template$i
            }]
    }], function () { return [{ type: AmplifyService }]; }, { selected: [{
            type: Output
        }], data: [{
            type: Input
        }], path: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3AlbumComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-album-ionic',
                template: template$j
            }]
    }], function () { return [{ type: AmplifyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3AlbumComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-album',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { selected: [{
            type: Output
        }], framework: [{
            type: Input
        }], path: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3ImageComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-image-core',
                template: template$k
            }]
    }], function () { return [{ type: AmplifyService }]; }, { selected: [{
            type: Output
        }], data: [{
            type: Input
        }], path: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3ImageComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-image-ionic',
                template: template$l
            }]
    }], function () { return [{ type: AmplifyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(S3ImageComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-s3-image',
                template: `
		<div>
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { selected: [{
            type: Output
        }], framework: [{
            type: Input
        }], path: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhotoPickerComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-photo-picker-core',
                template: template$m
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { picked: [{
            type: Output
        }], loaded: [{
            type: Output
        }], uploaded: [{
            type: Output
        }], url: [{
            type: Input
        }], storageOptions: [{
            type: Input
        }], path: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhotoPickerIonicComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-photo-picker-ionic',
                template: template$n
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhotoPickerComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-photo-picker',
                template: `
		<div class="amplify-component">
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { picked: [{
            type: Output
        }], loaded: [{
            type: Output
        }], uploaded: [{
            type: Output
        }], framework: [{
            type: Input
        }], url: [{
            type: Input
        }], path: [{
            type: Input
        }], storageOptions: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatbotComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-interactions-core',
                template: template$o
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { complete: [{
            type: Output
        }], data: [{
            type: Input
        }], bot: [{
            type: Input
        }], title: [{
            type: Input
        }], clearOnComplete: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatbotComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-interactions-ionic',
                template: template$p
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChatBotComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-interactions',
                template: `
		<div class="amplify-component">
			<ng-template component-host></ng-template>
		</div>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { complete: [{
            type: Output
        }], framework: [{
            type: Input
        }], bot: [{
            type: Input
        }], title: [{
            type: Input
        }], clearComplete: [{
            type: Input
        }], conversationModeOn: [{
            type: Input
        }], voiceConfig: [{
            type: Input
        }], voiceEnabled: [{
            type: Input
        }], textEnabled: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicComponentDirective, [{
        type: Directive,
        args: [{
                selector: '[component-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-form',
                template: template$q
            }]
    }], null, { title: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SumerianSceneComponentCore, [{
        type: Component,
        args: [{
                selector: 'sumerian-scene-core',
                template: template$r
            }]
    }], function () { return [{ type: AmplifyService }]; }, { data: [{
            type: Input
        }], sceneName: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SumerianSceneComponentIonic, [{
        type: Component,
        args: [{
                selector: 'sumerian-scene-ionic',
                template: template$s
            }]
    }], function () { return [{ type: AmplifyService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SumerianSceneComponent, [{
        type: Component,
        args: [{
                selector: 'amplify-sumerian-scene',
                template: `
		<ng-template component-host></ng-template>
	`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: ['dynamic-component-service']
            }] }]; }, { framework: [{
            type: Input
        }], sceneName: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SumerianSceneLoadingComponentCore, [{
        type: Component,
        args: [{
                selector: 'sumerian-scene-loading-core',
                template: template$t
            }]
    }], function () { return []; }, { loadPercentage: [{
            type: Input
        }], sceneName: [{
            type: Input
        }], sceneError: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AmplifyAngularModule, { declarations: function () { return [DynamicComponentDirective,
        AuthenticatorComponent,
        AuthenticatorComponentCore,
        ConfirmSignInComponent,
        ConfirmSignInComponentCore,
        ConfirmSignUpComponent,
        ConfirmSignUpComponentCore,
        SignInComponent,
        SignInComponentCore,
        SignUpComponent,
        SignUpComponentCore,
        RequireNewPasswordComponent,
        RequireNewPasswordComponentCore,
        GreetingComponent,
        GreetingComponentCore,
        ForgotPasswordComponent,
        ForgotPasswordComponentCore,
        UsernameFieldComponentCore,
        PhoneFieldComponentCore,
        S3AlbumComponent,
        S3AlbumComponentCore,
        S3ImageComponent,
        S3ImageComponentCore,
        PhotoPickerComponent,
        PhotoPickerComponentCore,
        ChatBotComponent,
        ChatbotComponentCore,
        FormComponent,
        SumerianSceneComponent,
        SumerianSceneComponentCore,
        SumerianSceneLoadingComponentCore]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [AuthenticatorComponent,
        AuthenticatorComponentCore,
        ConfirmSignInComponent,
        ConfirmSignInComponentCore,
        ConfirmSignUpComponent,
        ConfirmSignUpComponentCore,
        SignInComponent,
        SignInComponentCore,
        SignUpComponent,
        SignUpComponentCore,
        RequireNewPasswordComponent,
        RequireNewPasswordComponentCore,
        GreetingComponent,
        GreetingComponentCore,
        ForgotPasswordComponent,
        ForgotPasswordComponentCore,
        UsernameFieldComponentCore,
        PhoneFieldComponentCore,
        S3AlbumComponent,
        S3AlbumComponentCore,
        S3ImageComponent,
        S3ImageComponentCore,
        PhotoPickerComponent,
        PhotoPickerComponentCore,
        ChatBotComponent,
        ChatbotComponentCore,
        FormComponent,
        SumerianSceneComponent,
        SumerianSceneComponentCore,
        SumerianSceneLoadingComponentCore]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AmplifyAngularModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [DynamicComponentDirective, ...components],
                entryComponents: [],
                providers: [
                    {
                        provide: 'dynamic-component-service',
                        useValue: ɵ0
                    },
                ],
                exports: [...components]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PhoneFieldComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-phone-field-ionic',
                template: template$u
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UsernameFieldComponentIonic, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-username-field-ionic',
                template: template$v
            }]
    }], function () { return [{ type: AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SumerianSceneLoadingComponentIonic, [{
        type: Component,
        args: [{
                selector: 'sumerian-scene-loading-ionic',
                template: template$w
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AmplifyIonicModule, { declarations: function () { return [AuthenticatorIonicComponent,
        ConfirmSignInComponentIonic,
        ConfirmSignUpComponentIonic,
        ForgotPasswordComponentIonic,
        GreetingComponentIonic,
        SignInComponentIonic,
        SignUpComponentIonic,
        UsernameFieldComponentIonic,
        PhoneFieldComponentIonic,
        RequireNewPasswordComponentIonic,
        PhotoPickerIonicComponent,
        S3AlbumComponentIonic,
        S3ImageComponentIonic,
        ChatbotComponentIonic,
        SumerianSceneComponentIonic,
        SumerianSceneLoadingComponentIonic]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [AuthenticatorIonicComponent,
        ConfirmSignInComponentIonic,
        ConfirmSignUpComponentIonic,
        ForgotPasswordComponentIonic,
        GreetingComponentIonic,
        SignInComponentIonic,
        SignUpComponentIonic,
        UsernameFieldComponentIonic,
        PhoneFieldComponentIonic,
        RequireNewPasswordComponentIonic,
        PhotoPickerIonicComponent,
        S3AlbumComponentIonic,
        S3ImageComponentIonic,
        ChatbotComponentIonic,
        SumerianSceneComponentIonic,
        SumerianSceneLoadingComponentIonic]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AmplifyIonicModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [...components$1],
                entryComponents: [],
                providers: [AmplifyService],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                exports: [...components$1]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AmplifyAngularModule, AmplifyIonicModule, amplify_compose_service as AmplifyModules, AmplifyService, DynamicComponentDirective as ɵa, AuthenticatorComponent as ɵb, S3ImageComponentCore as ɵba, PhotoPickerComponent as ɵbb, PhotoPickerComponentCore as ɵbc, ChatBotComponent as ɵbd, ChatbotComponentCore as ɵbe, FormComponent as ɵbf, SumerianSceneComponent as ɵbg, SumerianSceneComponentCore as ɵbh, SumerianSceneLoadingComponentCore as ɵbi, DynamicComponentService as ɵbj, AuthenticatorIonicComponent as ɵbk, ConfirmSignInComponentIonic as ɵbl, ConfirmSignUpComponentIonic as ɵbm, ForgotPasswordComponentIonic as ɵbn, GreetingComponentIonic as ɵbo, SignInComponentIonic as ɵbp, SignUpComponentIonic as ɵbq, UsernameFieldComponentIonic as ɵbr, PhoneFieldComponentIonic as ɵbs, RequireNewPasswordComponentIonic as ɵbt, PhotoPickerIonicComponent as ɵbu, S3AlbumComponentIonic as ɵbv, S3ImageComponentIonic as ɵbw, ChatbotComponentIonic as ɵbx, SumerianSceneComponentIonic as ɵby, SumerianSceneLoadingComponentIonic as ɵbz, AuthenticatorComponentCore as ɵc, ConfirmSignInComponent as ɵd, ConfirmSignInComponentCore as ɵe, sumerianScene as ɵf, genericAttrs as ɵg, auth as ɵh, AmplifyService as ɵi, ConfirmSignUpComponent as ɵj, ConfirmSignUpComponentCore as ɵk, SignInComponent as ɵl, SignInComponentCore as ɵm, SignUpComponent as ɵn, SignUpComponentCore as ɵo, RequireNewPasswordComponent as ɵp, RequireNewPasswordComponentCore as ɵq, GreetingComponent as ɵr, GreetingComponentCore as ɵs, ForgotPasswordComponent as ɵt, ForgotPasswordComponentCore as ɵu, UsernameFieldComponentCore as ɵv, PhoneFieldComponentCore as ɵw, S3AlbumComponent as ɵx, S3AlbumComponentCore as ɵy, S3ImageComponent as ɵz };

//# sourceMappingURL=flowaccount-aws-amplify-angular.js.map